var DFI = window.DFI;
if(window.DFI_client === undefined){
	window.DFI_client = {};
    DFI_client = window.DFI_client;
    //test
}

/*
|---------------------------------------------------------------------------
| substitución función eval
|---------------------------------------------------------------------------
*/

DFI.eval = function (str, scope=window) {
    const keys = str.split(/[\.\[\]'"]/).filter(e => e);
    let ret = scope;
    
    try {
        keys.forEach(key => {
        ret = ret[key];
        });
        return ret;
    } catch(e) {
        return undefined;
    }
    }

/*
|---------------------------------------------------------------------------
| Devolucion objeto al back 
|---------------------------------------------------------------------------
*/
DFI.objectDataBack = function (tokenContainer, returnMeLocation, returnMeName) {
    //returnMeLocation=2 (1-javascript, 2-cookie, 3-session storage)
    var objetoEnviar = null;
    switch (returnMeLocation) {
        case "1":
            if (typeof returnMeName != undefined) {
                objetoEnviar = encodeURIComponent(DFI.JSONstringify(DFI.eval(returnMeName)));
            } else {
                objetoEnviar = null;
            }

            break;
        case "2":
            //undefined si no existe
            objetoEnviar = DFI.getCookie(returnMeName);

            if (objetoEnviar === undefined) {
                objetoEnviar = null;
            } else if (!DFI.IsJsonString(objetoEnviar)) {
                objetoEnviarTemporal = {};
                objetoEnviarTemporal[returnMeName] = DFI.getCookie(returnMeName);
                objetoEnviar = DFI.JSONstringify(objetoEnviarTemporal);
            }
            break;
        case "3":
            //null si no existe
            objetoEnviar = sessionStorage.getItem(returnMeName);
            break;
        default:
            objetoEnviar = null;
    }

    DAL.Ajax({
        type: "jsonp",
        url: DFI.global.provision + 'wsContainer/object_put.html?format=jsonp&idTag=' + idTagDelio + "&tokenContainer=" + tokenContainer + "&object=" + objetoEnviar,
    }).done(function(response) {
        DFI.consoleLogDelio("objeto enviado");
    }).fail(function(response) {
        DFI.consoleLogDelio("objeto error: " + response);
    });
    
}

DFI.setCookie= function(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

DFI.oldJSONStringify = JSON.stringify;

DFI.JSONstringify = function (input) {
    if (DFI.oldJSONStringify(input) == '[]')
        return DFI.oldJSONStringify(DFI.convArrToObj(input));
    else
        return DFI.oldJSONStringify(input);
};

DFI.getUrlVar = function (variable, url) {
    var href = url || window.location.search;
    var i, pair;
    var query = href.split("?")[1];
    var vars = query ? query.split("&") : [];

    for (i = 0; i < vars.length; i++) {

        pair = vars[i].split("=");

        if (pair[0] == variable && pair[1] !== "")
            return pair[1];
    }

    return "";
};

/*
|---------------------------------------------------------------------------
| Cargar un script en la pagina.
|---------------------------------------------------------------------------
*/
DFI.loadScript = function (url, fn, docScope) {
    var doc = docScope || document;
    var head = doc.head || doc.getElementsByTagName("head")[0];
    var script = doc.createElement("script");
    script.src = url;
    script.type = "text/javascript";

    if (fn)
        script.addEventListener('load', fn);

    head.appendChild(script);
};

DFI.consoleLogDelio = function (logToShow) {
    if (DFI.consoleLogEnable === "true") {
        DFI.consoleLogDelio(logToShow);
    }

}

DFI.globalInit = function() {

    /*
    |---------------------------------------------------------------------------
    | Datos de sesión 
    |---------------------------------------------------------------------------
    */

    DFI.dataSessionStore = function() {
        // Los datos de sesión están almacenados en: DFI.sessionData

        // tenemos que tener disponibles antes las etiquetas de visita 

        // Las etiquetas utm las recogemos de las urls almacenadas

        // Aunque no tiene que tener relevancia los duplicados, los evitamos, 
        //DFI.sessionData.url = DFI.uniq(DFI.sessionData.url);

        sessionStorage.setItem('delioSessionData', JSONstringify(DFI.sessionData))



    }




    /*
    |---------------------------------------------------------------------------
    | Data Layer
    |---------------------------------------------------------------------------
    */

    DFI.setDataLayer = function() {
        DFI.layerIdVal = {};
        DFI.layerIdValTemp = {};
        let layerIdVal = DFI.layerIdVal;

        //Chequeamos si existe DFI.DFI_configuration.hasOwnProperty(mappingLabels), en caso de que no exista no continuamos

        if (DFI.DFI_configuration.hasOwnProperty("mappingLabels")) {

            if (DFI.DFI_configuration.mappingLabels.form !== null) {
                if (DFI.DFI_configuration.mappingLabels.form.parentId !== "" && DFI.DFI_configuration.mappingLabels.form.parentId !== undefined) {
                    // Data layer existe, por lo que en labels viene el mapeado

                    if (document.getElementById(DFI.DFI_configuration.mappingLabels.form.parentId) !== null) {
                        var searchEles = document.getElementById(DFI.DFI_configuration.mappingLabels.form.parentId).children;
                        for (var i = 0; i < searchEles.length; i++) {
                            DFI.layerIdVal[searchEles[i].id] = searchEles[i].value;

                        }

                    }
                }

            }
            if (DFI.DFI_configuration.mappingLabels.url !== null) {
                DFI.layerIdValTemp = function() {
                    var p = window.location.search.substr(1).split(/\&/),
                        l = p.length,
                        kv, r = {};
                    while (l--) {
                        kv = p[l].split(/\=/);
                        r[kv[0]] = kv[1] || ""; //if no =value just set it as true
                    }
                    return r;
                }();

                Object.assign(DFI.layerIdVal, DFI.layerIdValTemp);
            }
            if (DFI.DFI_configuration.mappingLabels.byUrl !== null && DFI.DFI_configuration.mappingLabels.byUrl !== undefined && DFI.labelsByUrlOk) {
                //DFI.DFI_configuration.labelsByUrl
                for (var key in DFI.DFI_configuration.labelsValuesByUrl[0].EDeclaratives) {
                    DFI.layerIdValTemp[key] = DFI.DFI_configuration.labelsValuesByUrl[1].EDeclaratives[key];
                }
                for (var key in DFI.DFI_configuration.labelsValuesByUrl[0].EConversion) {
                    DFI.layerIdValTemp[key] = DFI.DFI_configuration.labelsValuesByUrl[1].EConversion[key];
                }
                for (var key in DFI.DFI_configuration.labelsValuesByUrl[0].EVisits) {
                    DFI.layerIdValTemp[key] = DFI.DFI_configuration.labelsValuesByUrl[1].EVisits[key];
                }

                Object.assign(DFI.layerIdVal, DFI.layerIdValTemp);
            }

            if (DFI.DFI_configuration.mappingLabels.json !== null) {
                switch (DFI.DFI_configuration.mappingLabels.json.container) {
                    case "1":
                        var evaluation = DFI.DFI_configuration.mappingLabels.json.objectName;
                        if (DFI.DFI_configuration.mappingLabels.json.path.substr(0, 1) != '[' && DFI.DFI_configuration.mappingLabels.json.path != "") evaluation += '.';
                        evaluation += DFI.DFI_configuration.mappingLabels.json.path;
                        if (window.hasOwnProperty(DFI.DFI_configuration.mappingLabels.json.objectName)) {
                            DFI.objectAnalyze = DFI.eval(evaluation);
                        }
                        break;
                    case "2":
                        var evaluation = DFI.DFI_configuration.mappingLabels.json.objectName;
                        if (DFI.getCookie(DFI.DFI_configuration.mappingLabels.json.objectName) !== undefined) {

                            // Si la estructura del cooki es JSON leemos como siempre, si no es JSON asumimos que es una cookie normal nombre valor
                            if (DFI.IsJsonString(DFI.getCookie(DFI.DFI_configuration.mappingLabels.json.objectName))) {
                                window[DFI.DFI_configuration.mappingLabels.json.objectName] = JSON.parse(DFI.getCookie(DFI.DFI_configuration.mappingLabels.json.objectName));
                                if (DFI.DFI_configuration.mappingLabels.json.path.substr(0, 1) != '[' && DFI.DFI_configuration.mappingLabels.json.path != "") evaluation += '.';
                                evaluation += DFI.DFI_configuration.mappingLabels.json.path;
                                if (window.hasOwnProperty(DFI.DFI_configuration.mappingLabels.json.objectName)) {
                                    DFI.objectAnalyze = DFI.eval(evaluation);
                                }
                            } else {
                                // cookie nombre valor
                                DFI.objectAnalyze = {};
                                DFI.objectAnalyze[DFI.DFI_configuration.mappingLabels.json.objectName] = DFI.getCookie(DFI.DFI_configuration.mappingLabels.json.objectName);
                            }
                        }

                        break;
                    case "3":
                        var evaluation = DFI.DFI_configuration.mappingLabels.json.objectName;
                        window[DFI.DFI_configuration.mappingLabels.json.objectName] = JSON.parse(sessionStorage.getItem(DFI.DFI_configuration.mappingLabels.json.objectName));
                        if (DFI.DFI_configuration.mappingLabels.json.path.substr(0, 1) != '[' && DFI.DFI_configuration.mappingLabels.json.path != "") evaluation += '.';
                        evaluation += DFI.DFI_configuration.mappingLabels.json.path;
                        if (window.hasOwnProperty(DFI.DFI_configuration.mappingLabels.json.objectName)) {
                            DFI.objectAnalyze = DFI.eval(evaluation);
                        }

                        break;
                    default:

                }
                if (typeof DFI.objectAnalyze !== undefined) {
                    Object.assign(DFI.layerIdVal, DFI.objectAnalyze);
                    //DFI.layerIdVal = DFI.objectAnalyze;
                }


            }

            if (DFI.DFI_configuration.mappingLabels.ids !== null) {
                var list = document.querySelectorAll("*[id]");
                DFI.objectAnalyzeIds = {};
                for (var i = 0; i < list.length; ++i) {

                    var curr_node = list[i].innerHTML;
                    var curr_id = list[i].id;
                    if (curr_node !== "") {
                        //DFI.objectAnalyzeIds.push({curr_id: curr_node });
                        DFI.objectAnalyzeIds[curr_id] = curr_node;
                    }
                }
                //DFI.layerIdVal = DFI.objectAnalyzeIds;
                Object.assign(DFI.layerIdVal, DFI.objectAnalyzeIds);
            }


        }

    };

    /*
    |---------------------------------------------------------------------------
    | Etiquetas Declarativas
    |---------------------------------------------------------------------------
    */
    DFI.setDeclaratives = function() {
        if (DFI.DFI_configuration.labels.hasOwnProperty("EDeclaratives")) {
            DFI.logger("Set Declaratives");

            for (var propt in DFI.layerIdVal) {
                for (var propt1 in DFI.DFI_configuration.labels.EDeclaratives) {
                    if (DFI.DFI_configuration.labels.EDeclaratives[propt1] === propt) {
                        DFI.consoleLogDelio(propt1 + ": " + DFI.DFI_configuration.labels.EDeclaratives[propt1] + ": " + DFI.layerIdVal[propt]);
                        DFI.labels.EDeclaratives[propt1] = DFI.layerIdVal[propt];
                    }
                }

            }

            // Añadimos al objeto de sesión las etiquetas declarativas
            // DFI.sessionData.declarativeLabel
            DFI.sessionData.declarativeLabel.push(DFI.labels.EDeclaratives);
        }
        var EDeclarativesTest = {};

        DFI.EDeclarativesTest = JSON.parse(JSONstringify(DFI.labels.EDeclaratives));

        for (let index = 0; index < DFI.sessionData.declarativeLabel.length; ++index) {

            for (var propt1 in DFI.sessionData.declarativeLabel[index]) {
                DFI.EDeclarativesTest[propt1] = DFI.sessionData.declarativeLabel[index][propt1];
            }


        }

        //DFI.whereAreYouFrom();

        DFI.labels.EDeclaratives = JSON.parse(JSONstringify(DFI.EDeclarativesTest));




    };

    /*
    |---------------------------------------------------------------------------
    | Etiquetas utm
    |---------------------------------------------------------------------------
    */
    DFI.setUtmsVars = function() {
        // Tipo: 1 utm_campaign
        //		 2 utm_medium  fuente de tráfico
        //		 3 utm_source proveedr
        //	     4 utm_term  tipo de acción
        //		 5 utm_content  creatividad	
        DFI.labels.utmVars = {};
        DFI.labels.utmVars["utm_campaign"] = DFI.getQueryVariable("utm_campaign");
        DFI.labels.utmVars["utm_medium"] = DFI.getQueryVariable("utm_medium ");
        DFI.labels.utmVars["utm_source"] = DFI.getQueryVariable("utm_source");
        DFI.labels.utmVars["utm_term"] = DFI.getQueryVariable("utm_term");
        DFI.labels.utmVars["utm_content"] = DFI.getQueryVariable("utm_content");

    }



    /*
    |---------------------------------------------------------------------------
    | Etiquetas de Visita
    |---------------------------------------------------------------------------
    */
    DFI.setTrackingVars = function() {
        DFI.logger("Set Visit tags");
        // GCLID reservado en la etiqueta de visita 1. Por lo que se sobreescribe lo que haya.

        if (DFI.getQueryVariable("gclid") !== "") {

            window.v_var_3 = DFI.getQueryVariable("gclid");
            // window.womtp.v_vars[3] = DFI.getQueryVariable("gclid");
            DFI.labels.EVisits["v_var_3"] = window.v_var_3;

            // Seteamos la window.v_var_1 de "click conversion" antes "call me back"
            window.v_var_1 = "click conversion";
            // window.womtp.v_vars[1] = "click conversion";
            DFI.labels.EVisits["v_var_1"] = "click conversion";

        }

        //Site conversion  v_var_2
        // Si hay formulario o clase de Ring pool es landing, si no site
        window.v_var_2 = "landing";
        // window.womtp.v_vars[2] = "landing";
        if (DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass.length > 0 || document.querySelectorAll("form").length > 0) {
            window.v_var_2 = "landing";
            // window.womtp.v_vars[2] = "landing";
            DFI.labels.EVisits["v_var_2"] = "landing";

        } else {
            window.v_var_2 = "site";
            // window.womtp.v_vars[2] = "site";
            DFI.labels.EVisits["v_var_2"] = "site";
        }

        if (DFI.DFI_configuration.labels.hasOwnProperty("EVisits")) {

            if (DFI.DFI_configuration.dataLayerId !== "" && DFI.DFI_configuration.dataLayerId !== undefined) {
                // Data layer existe, por lo que en labels viene el mapeado
                for (var propt in DFI.layerIdVal) {
                    if (DFI.DFI_configuration.labels.visits[propt] === DFI.layerIdVal[propt]) {
                        if (DFI.layerIdVal[propt] !== undefined && DFI.layerIdVal[propt] !== "undefined") {
                            DFI.labels.EVisits[propt] = DFI.layerIdVal[propt];
                        }
                    }
                }

            } else {
                // Data layer no existe, por lo que los valores vienen en el objetoo DFI.layerIdVal
                Object.getOwnPropertyNames(DFI.DFI_configuration.labels.EVisits).forEach(
                    function(val, idx, array) {
                        DFI.consoleLogDelio(val + ' -> ' + DFI.DFI_configuration.labels.EVisits[val]);

                        if (DFI.layerIdVal[DFI.DFI_configuration.labels.EVisits[val]] !== undefined && DFI.layerIdVal[DFI.DFI_configuration.labels.EVisits[val]] !== "undefined") {

                            DFI.labels.EVisits[val] = DFI.layerIdVal[DFI.DFI_configuration.labels.EVisits[val]];
                            // window.womtp.v_vars[Number(val.replace("v_var_", ""))] = DFI.layerIdVal[DFI.DFI_configuration.labels.EVisits[val]];
                            window[val] = DFI.layerIdVal[DFI.DFI_configuration.labels.EVisits[val]];
                        }

                    }
                );


            }
            // Añadimos al objeto de sesión las etiquetas visita
            // DFI.sessionData.visitLabel
            DFI.sessionData.visitLabel.push(DFI.convArrToObj(DFI.labels.EVisits));
        }
        var EVisitTest = [];

        DFI.EVisitTest = JSON.parse(JSONstringify(DFI.labels.EVisits));
        for (let index = 0; index < DFI.sessionData.visitLabel.length; ++index) {

            for (var propt1 in DFI.sessionData.visitLabel[index]) {
                DFI.EVisitTest[propt1] = DFI.sessionData.visitLabel[index][propt1];
            }

        }

        for (var propt1 in DFI.EVisitTest) {
            DFI.labels.EVisits[propt1] = DFI.EVisitTest[propt1];
        }

        DFI.labels.EVisitsDef = [{
            "id": 1,
            "value": "ring pool"
        }]
        var i = 0;
        for (let property in DFI.labels.EVisits) {
            var indice = property.replace("v_var_", "");
            DFI.labels.EVisitsDef.push({
                "id": +indice,
                "value": DFI.labels.EVisits[property]
            });
            window[property] = DFI.labels.EVisits[property];
        }




    };

    /*
    |---------------------------------------------------------------------------
    | Etiquetas de Conversión
    |---------------------------------------------------------------------------
    */
    DFI.setConversionsLabels = function() {
        if (DFI.DFI_configuration.labels.hasOwnProperty("EConversion")) {

            if (DFI.DFI_configuration.dataLayerId !== "" && DFI.DFI_configuration.dataLayerId !== undefined) {
                // Data layer existe, por lo que en labels viene el mapeado
                for (var propt in DFI.layerIdVal) {
                    if (DFI.DFI_configuration.labels.EConversion[propt] === DFI.layerIdVal[propt]) {
                        DFI.labels.EConversion[propt] = DFI.layerIdVal[propt];
                    }
                }



            } else {
                // Data layer no existe, por lo que los valores vienen en el objetoo DFI.layerIdVal
                Object.getOwnPropertyNames(DFI.DFI_configuration.labels.EConversion).forEach(
                    function(val, idx, array) {
                        DFI.consoleLogDelio(val + ' -> ' + DFI.DFI_configuration.labels.EConversion[val]);

                        if (DFI.layerIdVal[DFI.DFI_configuration.labels.EConversion[val]] !== undefined && DFI.layerIdVal[DFI.DFI_configuration.labels.EConversion[val]] !== "undefined") {

                            DFI.labels.EConversion[val] = DFI.layerIdVal[DFI.DFI_configuration.labels.EConversion[val]];
                            window[val] = DFI.layerIdVal[DFI.DFI_configuration.labels.EConversion[val]];
                        }

                    }
                );

            }

            // Añadimos al objeto de sesión las etiquetas visita
            // DFI.sessionData.visitLabel
            DFI.sessionData.conversionLabel.push(DFI.convArrToObj(DFI.labels.EConversion));
        };
        var EConversionTest = [];

        DFI.EConversionTest = JSON.parse(JSONstringify(DFI.labels.EConversion));
        for (let index = 0; index < DFI.sessionData.conversionLabel.length; ++index) {

            for (var propt1 in DFI.sessionData.conversionLabel[index]) {
                DFI.EConversionTest[propt1] = DFI.sessionData.conversionLabel[index][propt1];
            }

        }

        DFI.labels.EConversion = DFI.EConversionTest;
        for (var propt1 in DFI.EConversionTest) {
            DFI.labels.EConversion[propt1] = DFI.EConversionTest[propt1];

        }



        DFI.labels.EConversionDef = []
        var i = 0;
        for (let property in DFI.labels.EConversion) {
            var indice = property.replace("c_var_", "");
            DFI.labels.EConversionDef.push({
                "id": +indice,
                "value": DFI.labels.EConversion[property]
            });
            window[property] = DFI.labels.EConversion[property];
        }


    }

    /*
    |---------------------------------------------------------------------------
    | setLandingCustomVars Variables customizadas despues de  captura dataLayer
    |---------------------------------------------------------------------------
    */
   DFI.setLandingCustomVars = function() {
        if(typeof DFI_client === "object" 
        && typeof DFI_client.LandingCustomVars === "object"
        ){
            for (let propertyMain in DFI_client.LandingCustomVars) {
                for (let property in DFI_client.LandingCustomVars[propertyMain]) {

                    DFI.labels[propertyMain][property] = DFI_client.LandingCustomVars[propertyMain][property];

                    if(propertyMain === "EConversion" 
                    || propertyMain === "EVisits"){
                        window[property] = DFI_client.LandingCustomVars[propertyMain][property];
                    }
                    
                }
            }

        }

    }


    /*
    |---------------------------------------------------------------------------
    | Servicios de llamada
    |---------------------------------------------------------------------------
    */
    DFI.setRingPoolServices = function() {
        var ringPoolidServiceConditions = DFI.DFI_configuration.ringPoolidServiceConditions;
        for (i = 0; i < ringPoolidServiceConditions.length; i++) {
            DFI.allConditions[i] = 0;

            DFI.visitCond = ringPoolidServiceConditions[i].v_var;
            var visitCondName = Object.keys(DFI.visitCond)[0];

            if (DFI.DFI_configuration.labels.hasOwnProperty("visits")) {
                if (visitCondName != "undefined" && visitCondName != undefined && DFI.DFI_configuration.labels.visits.hasOwnProperty(visitCondName)) {
                    var visitCondValue = DFI.visitCond[Object.keys(visitCond)[0]];
                    if (DFI.DFI_configuration.labels.visits[visitCondName] === visitCondValue) {
                        ++DFI.allConditions[i];
                    }
                }
            }

            DFI.urlCond = ringPoolidServiceConditions[i].url;

            if (DFI.totalURL.search(DFI.urlCond) >= 0) {
                ++DFI.allConditions[i];
            }

            DFI.nickCond = ringPoolidServiceConditions[i].nick;
            var nickCondName = Object.keys(DFI.nickCond)[0];
            if (nickCondName != "undefined" && nickCondName != undefined) {
                var nickCondValue = nickCond[Object.keys(DFI.nickCond)[0]];

                if (DFI.getQueryVariable("nickCondName") === nickCondValue) {
                    ++DFI.allConditions[i];
                }
            }

            DFI.idServiceCond = ringPoolidServiceConditions[i].idService;
        }

        for (i = 0; i < DFI.allConditions.length; i++) {
            var repeticion = 0
            if (DFI.allConditions[i] > repeticion) {
                repeticion = DFI.allConditions[i];
                DFI.idServiceCond = ringPoolidServiceConditions[i].idService;


            }
        }
        return DFI.idServiceCond;
    };


    /*
    |---------------------------------------------------------------------------
    | Servicios de llamada Nuevo
    |---------------------------------------------------------------------------
    */

    DFI.setRingPoolServicesNew = function() {
        DFI.allConditions = [];

        var ringPoolidServiceConditions = DFI.DFI_configuration.ringPoolidServiceConditions;
        var visitsVars = DFI.DFI_configuration.labels.visits;
        //var visitsVars = DFI.labels.EVisits
        //var ringPoolidServiceConditions = window.ringPoolidServiceConditions;
        for (i = 0; i < ringPoolidServiceConditions.length; i++) {
            DFI.priorityService = {};
            //Chequeamos si existe condición de visita
            if (ringPoolidServiceConditions[i].hasOwnProperty("visitLabel") && (ringPoolidServiceConditions[i].visitLabel)) {

                if (ringPoolidServiceConditions[i].visitLabel.hasOwnProperty("id")) {
                    // Hay  condición basada en visita
                    // Pasamos el id de Alberto a FORMATO DFI.labels.EVisits = {v_var_0: "true", v_var_2: "Coca"}
                    DFI.v_varIdRingPoolTemp = "v_var_" + ringPoolidServiceConditions[i].visitLabel.id;
                    DFI.v_varIdRingPoolTemp_ = ringPoolidServiceConditions[i].visitLabel.value;

                    if (DFI.labels.EVisits.hasOwnProperty(DFI.v_varIdRingPoolTemp)) {
                        DFI.v_varIdRingPool = DFI.labels.EVisits[DFI.v_varIdRingPoolTemp];
                        // DFI.buscarvisitTracking(DFI.v_varIdRingPoolTemp,DFI.v_varIdRingPoolTemp_ )
                        if (DFI.v_varIdRingPool === DFI.DFI_configuration.ringPoolidServiceConditions[i].visitLabel.value) {
                            DFI.v_varIdRingPool = "ok";
                        } else {
                            DFI.v_varIdRingPool = "none";
                        }


                    } else {
                        // No hay condición basada envisita
                        DFI.v_varIdRingPool = "none";
                    }


                } else {
                    // No hay condición basada envisita
                    DFI.v_varIdRingPool = "void";

                }

            } else {
                // No hay condición basada envisita
                DFI.v_varIdRingPool = "void";

            }

            // Chequeamos condición de url
            if (ringPoolidServiceConditions[i].hasOwnProperty("url")) {
                DFI.urlCond = ringPoolidServiceConditions[i].url;

                if (DFI.urlCond == "null" || DFI.urlCond == null) {
                    // No existe condición de url
                    DFI.v_varUrlRingPool = true;


                } else {
                    // Existe condición de url
                    //					if(DFI.totalURL.search(DFI.urlCond) >= 0){
                    //						DFI.v_varUrlRingPool = true;
                    //
                    //					} else{
                    //						
                    //						DFI.v_varUrlRingPool = false;
                    //					}

                    DFI.v_varUrlRingPool = DFI.buscarTexto(DFI.urlCond);

                }
            } else {
                //
                // No existe condición de url. Este caso no debiera de ocurrir.
                DFI.v_varUrlRingPool = true;
            }

            // Chequeamos condición utms que era el nick
            // ie: "idLabelValue": "1",   //El tipo es 1 campaña, 2 fuente de tráfico, 3 proveedor, 4 tipo de acción, 5 creatividad
            // Tipo: 1 utm_campaign
            //		 2 utm_medium  fuente de tráfico
            //		 3 utm_source proveedr
            //	     4 utm_term  tipo de acción
            //		 5 utm_content  creatividad	
            DFI.v_varTrkRingPoolTtes = false;
            DFI.v_varTrkRingPool1 = "void";
            if (ringPoolidServiceConditions[i].hasOwnProperty("trk") && ringPoolidServiceConditions[i].trk) {
                if (ringPoolidServiceConditions[i].trk.hasOwnProperty("idLabelType")) {
                    // Existe idLabelValue
                    // Convertimo idLabelValue a variable de url

                    switch (ringPoolidServiceConditions[i].trk.idLabelType) {
                        case "1":
                            DFI.v_varTrkRingPool = "utm_campaign";
                            break;
                        case "2":
                            DFI.v_varTrkRingPool = "utm_medium";
                            break;
                        case "3":
                            DFI.v_varTrkRingPool = "utm_source";
                            break;
                        case "4":
                            DFI.v_varTrkRingPool = "utm_term";
                            break;
                        case "5":
                            DFI.v_varTrkRingPool = "utm_content";
                            break;

                        default:
                            // No se debería de dar nunca
                            DFI.v_varTrkRingPool = "void";
                    }

                    // DFI.buscarUtmTracking
                    //if(DFI.totalURL.search(DFI.v_varTrkRingPool) >= 0 && DFI.totalURL.search(ringPoolidServiceConditions[i].trk.idLabelValue) >= 0){
                    if (DFI.buscarUtmTracking(DFI.v_varTrkRingPool, ringPoolidServiceConditions[i].trk.idLabelValue)) {
                        DFI.v_varTrkRingPoolTtes = true;
                        DFI.v_varTrkRingPool1 = "void";

                    } else {
                        DFI.v_varTrkRingPoolTtes = false;
                        DFI.v_varTrkRingPool1 = "none";
                    }

                } else {
                    // No Existe idLabelValue
                    DFI.v_varTrkRingPool1 = "none";

                }

            } else {
                // No Existe idLabelValue
                DFI.v_varTrkRingPool = "void";
            }


            // Asignamos el servicio de llamada.
            if (DFI.v_varIdRingPool !== "none" && DFI.v_varTrkRingPool1 !== "none" && DFI.v_varUrlRingPool) {

                DFI.priorityService.priority = ringPoolidServiceConditions[i].priority;
                DFI.priorityService.ruleId = ringPoolidServiceConditions[i].ruleId;
                DFI.priorityService.active = ringPoolidServiceConditions[i].active;
                //DFI.priorityService.serviceId = ringPoolidServiceConditions[i].serviceId;
                //DFI.priorityService.phoneCallCenter  = ringPoolidServiceConditions[i].phoneCallCenter;
                DFI.priorityService.services = ringPoolidServiceConditions[i].services;

                DFI.allConditions.push(DFI.priorityService);

                //alert("DFI.v_varIdRingPool: " + DFI.v_varIdRingPool + "	DFI.v_varTrkRingPool: " + DFI.v_varTrkRingPool + "	DFI.v_varUrlRingPool: " +  DFI.v_varUrlRingPool); 				
                DFI.consoleLogDelio(JSONstringify(DFI.allConditions));


            }

            //return DFI.idServiceCond;
        }

        // Asignamos  el servicio de llamada por defecto
        DFI.allConditions.push({
            priority: 9999,
            serviceId: DFI.DFI_configuration.services.serviceCallDefaultId,
            phoneCallCenter: DFI.DFI_configuration.defaultPhone
        });
        var actualPriority = DFI.allConditions[0];
        for (i = 0; i < DFI.allConditions.length; i++) {

            if (i > 0 && (DFI.allConditions[i].priority < actualPriority.priority && DFI.allConditions[i].active)) {

                actualPriority = DFI.allConditions[i];

            }

        }


        // En caso de que no existe actualPriority.services, lo tenemos controlado

        if(actualPriority.services != undefined){
            var porcentaje = [];
            for (var i = 0, len = 4; i < len; i++) {
                porcentaje[i] = 0;
    
            }
            for (var i = 0, len = actualPriority.services.length; i < len; i++) {
                porcentaje[i] = Number(actualPriority.services[i].percentage);
                DFI.consoleLogDelio(porcentaje[i]);
            }
    
            //variable para decidir el indice del porcentaje
    
            var pencentageIndex = 0;
    
            switch (DFI.elegirVariante(porcentaje)) {
                case "a":
                    pencentageIndex = 0;
                    break;
                case "b":
                    pencentageIndex = 1;
                    break;
                case "c":
                    pencentageIndex = 2;
                    break;
                case "d":
                    pencentageIndex = 3;
                    break;
                default:
                    pencentageIndex = 0;
            }
    
            if (typeof actualPriority.services[pencentageIndex].serviceIdCallMeBack != "undefined") {
                //Versión antigua. Se mantiene en caso de que desktpb o mobileb de versiones ant 01062018 se sigan utilizando
                actualPriority.serviceId = actualPriority.services[pencentageIndex].serviceIdCallMeBack;
                actualPriority.phoneCallCenter = actualPriority.services[pencentageIndex].phoneCallCenterCallMeBack;
                actualPriority.country = actualPriority.services[pencentageIndex].countryCallMeBack;
                actualPriority.serviceName = actualPriority.services[pencentageIndex].serviceNameCallMeBack;
    
                //Call me back nueva
                actualPriority.serviceIdCallMeBack = actualPriority.services[pencentageIndex].serviceIdCallMeBack;
                actualPriority.phoneCallCenterCallMeBack = actualPriority.services[pencentageIndex].phoneCallCenterCallMeBack;
                actualPriority.countryCallMeBack = actualPriority.services[pencentageIndex].countryCallMeBack;
                actualPriority.serviceNameCallMeBack = actualPriority.services[pencentageIndex].serviceNameCallMeBack;
    
                // Ring Pool nueva
                actualPriority.serviceIdRingPool = actualPriority.services[pencentageIndex].serviceIdRingPool;
                actualPriority.phoneCallCenterRingPool = actualPriority.services[pencentageIndex].phoneCallCenterRingPool;
                actualPriority.countryRingPool = actualPriority.services[pencentageIndex].countryRingPool;
                actualPriority.serviceNameRingPool = actualPriority.services[pencentageIndex].serviceNameRingPool;
    
            } else {
                //Versión antigua. Se mantiene en caso de que desktpb o mobileb de versiones ant 01062018 se sigan utilizando
                actualPriority.serviceId = actualPriority.services[pencentageIndex].serviceId;
                actualPriority.phoneCallCenter = actualPriority.services[pencentageIndex].phoneCallCenter;
                actualPriority.country = actualPriority.services[pencentageIndex].country;
                actualPriority.serviceName = actualPriority.services[pencentageIndex].serviceName;
    
                //Call me back nueva
                actualPriority.serviceIdCallMeBack = actualPriority.services[pencentageIndex].serviceId;
                actualPriority.phoneCallCenterCallMeBack = actualPriority.services[pencentageIndex].phoneCallCenter;
                actualPriority.countryCallMeBack = actualPriority.services[pencentageIndex].country;
                actualPriority.serviceNameCallMeBack = actualPriority.services[pencentageIndex].serviceName;
    
                // Ring Pool nueva
                actualPriority.serviceIdRingPool = actualPriority.services[pencentageIndex].serviceId;
                actualPriority.phoneCallCenterRingPool = actualPriority.services[pencentageIndex].phoneCallCenter;
                actualPriority.countryRingPool = actualPriority.services[pencentageIndex].country;
                actualPriority.serviceNameRingPool = actualPriority.services[pencentageIndex].serviceName;
    
            }
        }



        return actualPriority;

    }




    /*
    |---------------------------------------------------------------------------
    | Servicios DFI.setShowRules Nuevo
    |---------------------------------------------------------------------------
    */

    DFI.setShowRulesScoring = function() {
        DFI.allConditionsShowRules = [];
        DFI.allConditionsShowRulesUltimo = [];

        var setShowrulesConditions = DFI.DFI_configuration.showRules;
        var visitsVars = DFI.DFI_configuration.labels.visits;
        //var visitsVars = DFI.labels.EVisits
        //var setShowrulesConditions = DFI.setShowrulesConditions;
        for (i = 0; i < setShowrulesConditions.length; i++) {
            DFI.priorityServiceSetShowRules = {};
            DFI.priorityServiceSetShowRulesUltimo = {};
            //Chequeamos si existe condición de visita
            if (setShowrulesConditions[i].hasOwnProperty("rules") && (setShowrulesConditions[i].rules.visitLabel)) {

                if (setShowrulesConditions[i].rules.visitLabel.hasOwnProperty("id")) {
                    // Hay  condición basada en visita
                    // Pasamos el id de Alberto a FORMATO DFI.labels.EVisits = {v_var_0: "true", v_var_2: "Coca"}
                    DFI.v_varIdsetshowRulesTemp = "v_var_" + setShowrulesConditions[i].rules.visitLabel.id;

                    // Condiciones 11/02/2018
                    //DFI.DFI_configuration.showRules[i].visitLabel.idConditionType
                    // 0: Indistinto
                    // 1: Igual a
                    // 2: Distinto a
                    // 11: Comience por
                    // 8: Contenga
                    // 5: No vacio
                    // 12: Vacio

                    if (DFI.labels.EVisits.hasOwnProperty(DFI.v_varIdsetshowRulesTemp)) {
                        DFI.v_varIdsetshowRules = DFI.labels.EVisits[DFI.v_varIdsetshowRulesTemp];
                        switch (DFI.DFI_configuration.showRules[i].rules.visitLabel.idConditionType) {
                            case 10:
                                // 0: Indistinto
                                if (DFI.labels.EVisits[DFI.v_varIdsetshowRulesTemp] !== undefined) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 1:
                                // 1: Igual a
                                if (DFI.v_varIdsetshowRules === DFI.DFI_configuration.showRules[i].rules.visitLabel.value1) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 2:
                                // 2: Distinto a
                                if (DFI.v_varIdsetshowRules !== DFI.DFI_configuration.showRules[i].rules.visitLabel.value1) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 11:
                                // 11: Comience por
                                if (DFI.v_varIdsetshowRules.startsWith(DFI.DFI_configuration.showRules[i].rules.visitLabel.value1)) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 8:
                                // 8: Contenga
                                if (DFI.v_varIdsetshowRules.indexOf(DFI.DFI_configuration.showRules[i].rules.visitLabel.value1) > -1) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 5:
                                // 5: No vacio
                                if (DFI.v_varIdsetshowRules.length > 0) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                                break;
                            case 12:
                                // 12: Vacio
                                if (DFI.v_varIdsetshowRules.length === 0) {
                                    DFI.v_varIdsetshowRules = "ok";
                                    DFI.v_varIdsetshowRulesUltimo = "ok";
                                } else {
                                    DFI.v_varIdsetshowRules = "none";
                                    DFI.v_varIdsetshowRulesUltimo = "none";
                                }
                            default:
                                DFI.v_varIdsetshowRules = "none";
                                DFI.v_varIdsetshowRulesUltimo = "none";
                        }
                        //   if(DFI.v_varIdsetshowRules === DFI.DFI_configuration.showRules[i].rules.visitLabel.value ){
                        //       DFI.v_varIdsetshowRules = "ok";
                        //       DFI.v_varIdsetshowRulesUltimo = "ok";
                        //   } else{
                        //       DFI.v_varIdsetshowRules = "none";
                        //       DFI.v_varIdsetshowRulesUltimo = "none";
                        //   }


                    } else {
                        // No hay condición basada envisita
                        DFI.v_varIdsetshowRules = "none";
                        DFI.v_varIdsetshowRulesUltimo = "none";
                    }


                } else {
                    // No hay condición basada envisita
                    DFI.v_varIdsetshowRules = "void";
                    DFI.v_varIdsetshowRulesUltimo = "void";

                }

            } else {
                // No hay condición basada envisita
                DFI.v_varIdsetshowRules = "void";
                DFI.v_varIdsetshowRulesUltimo = "void";

            }

            // Chequeamos condición de url
            if (setShowrulesConditions[i].rules.hasOwnProperty("url")) {
                DFI.urlCondSetShowrules = setShowrulesConditions[i].rules.url;

                if (DFI.urlCondSetShowrules == "null" || DFI.urlCondSetShowrules == null) {
                    // No existe condición de url
                    DFI.v_varUrlSetShowRules = true;


                } else {
                    // Existe condición de url
                    //						if(DFI.totalURL.search(DFI.urlCondSetShowrules) >= 0){
                    //							DFI.v_varUrlSetShowRules = true;
                    //
                    //						} else{
                    //							DFI.v_varUrlSetShowRules = false;
                    //						}
                    //						

                    DFI.v_varUrlSetShowRules = DFI.buscarTextoUltimo(DFI.urlCondSetShowrules, "resto");
                    DFI.v_varUrlSetShowRulesUltimo = DFI.buscarTextoUltimo(DFI.urlCondSetShowrules, "ultima");

                }
            } else {
                //
                // No existe condición de url. Este caso no debiera de ocurrir.
                DFI.v_varUrlSetShowRules = false;
                DFI.v_varUrlSetShowRulesUltimo = false;
            }

            // Chequeamos condición utms que era el nick
            // ie: "idLabelValue": "1",   //El tipo es 1 campaña, 2 fuente de tráfico, 3 proveedor, 4 tipo de acción, 5 creatividad
            // Tipo: 1 utm_campaign
            //		 2 utm_medium  fuente de tráfico
            //		 3 utm_source proveedr
            //	     4 utm_term  tipo de acción
            //		 5 utm_content  creatividad	
            DFI.v_varTrkSetShowRulesTtes = false;
            if (setShowrulesConditions[i].rules.hasOwnProperty("trk") && setShowrulesConditions[i].rules.trk) {
                if (setShowrulesConditions[i].rules.trk.hasOwnProperty("idLabelType")) {
                    // Existe idLabelValue
                    // Convertimo idLabelValue a variable de url

                    switch (setShowrulesConditions[i].rules.trk.idLabelType) {
                        case "1":
                            DFI.v_varTrkSetShowRules = "utm_campaign";
                            break;
                        case "2":
                            DFI.v_varTrkSetShowRules = "utm_medium";
                            break;
                        case "3":
                            DFI.v_varTrkSetShowRules = "utm_source";
                            break;
                        case "4":
                            DFI.v_varTrkSetShowRules = "utm_term";
                            break;
                        case "5":
                            DFI.v_varTrkSetShowRules = "utm_content";
                            break;

                        default:
                            // No se debería de dar nunca
                            DFI.v_varTrkSetShowRules = "void";
                    }

                    if (DFI.buscarUtmTrackingUltimo(DFI.v_varTrkRingPool, setShowrulesConditions[i].rules.trk.idLabelValue, "resto")) {
                        DFI.v_varTrkSetShowRulesTtes = true;
                        DFI.v_varTrkRingPool1 = "void";

                    } else {
                        DFI.v_varTrkSetShowRulesTtes = false;
                        DFI.v_varTrkSetShowRules1 = "none";
                    }
                    if (DFI.buscarUtmTrackingUltimo(DFI.v_varTrkRingPool, setShowrulesConditions[i].rules.trk.idLabelValue, "ultima")) {
                        DFI.v_varTrkSetShowRulesTesUltima = true;
                        DFI.v_varTrkRingPool1Ultima = "void";

                    } else {
                        DFI.v_varTrkSetShowRulesTtesTesUltima = false;
                        DFI.v_varTrkSetShowRules1Ultima = "none";
                    }



                } else {
                    // No Existe idLabelValue
                    DFI.v_varTrkSetShowRules1 = "none";
                    DFI.v_varTrkSetShowRules1Ultima = "none";

                }

            } else {
                // No Existe idLabelValue
                DFI.v_varTrkSetShowRules1 = "void";
                DFI.v_varTrkSetShowRules1Ultima = "void";
            }


            // Asignamos el scoring.
            var scoringResult = false;
            
            if (((setShowrulesConditions[i].rules.scoring !== "" 
            && setShowrulesConditions[i].rules.scoring !== null 
            && setShowrulesConditions[i].rules.scoring !== "null") 
            && setShowrulesConditions[i].rules.scoring.result === true) 
            || (setShowrulesConditions[i].rules.scoring === "" 
            || setShowrulesConditions[i].rules.scoring === null 
            || setShowrulesConditions[i].rules.scoring === "null")) {
                scoringResult = true;
                if (((setShowrulesConditions[i].rules.scoring !== "" 
                && setShowrulesConditions[i].rules.scoring !== null 
                && setShowrulesConditions[i].rules.scoring !== "null") 
                && setShowrulesConditions[i].rules.scoring.result === true)) {
                    DFI.scoringPriority = true;
                }
            }



            if (DFI.scoringPriority !== true && DFI.setVarCounter === true) {
                scoringResult = false;
            }

            //Listas
            var listResult = true;

            if(window.DFI.DFI_configuration.showRules[i].rules.list.output === false ){
                listResult = false;
            }



            if (DFI.v_varIdsetshowRules !== "none" && DFI.v_varTrkSetShowRules1 !== "none" && DFI.v_varUrlSetShowRules && scoringResult && listResult) {
                DFI.setVarCounter = true;
                DFI.scoringPriority = false;
                DFI.priorityServiceSetShowRules.idRule = setShowrulesConditions[i].idRule;
                DFI.priorityServiceSetShowRules.order = setShowrulesConditions[i].order;
                DFI.priorityServiceSetShowRules.description = setShowrulesConditions[i].description ;
                DFI.priorityServiceSetShowRules.actionIsOkDSA = setShowrulesConditions[i].actionIsOkDSA;
                DFI.priorityServiceSetShowRules.actionIsOkInterfereForm = setShowrulesConditions[i].actionIsOkInterfereForm;
                DFI.priorityServiceSetShowRules.actionIsOkInterferePhone = setShowrulesConditions[i].actionIsOkInterferePhone;
                DFI.priorityServiceSetShowRules.actionIsOkShowChat = setShowrulesConditions[i].actionIsOkShowChat;
                //Compatibilidad hacia atrás. Verificamos si existen los cambios nuevos (whoValidate, interfereButtonsWithClass, fieldsMandatory )
                //Si no existen los seteamos
                if (setShowrulesConditions[i].whoValidate === undefined) {
                    DFI.priorityServiceSetShowRules.whoValidate = 1;
                    DFI.priorityServiceSetShowRules.interfereButtonsWithClass = "";
                    DFI.priorityServiceSetShowRules.fieldsMandatory = [];
                } else {
                    DFI.priorityServiceSetShowRules.whoValidate = setShowrulesConditions[i].whoValidate;
                    DFI.priorityServiceSetShowRules.interfereButtonsWithClass = setShowrulesConditions[i].interfereButtonsWithClass;
                    DFI.priorityServiceSetShowRules.fieldsMandatory = setShowrulesConditions[i].fieldsMandatory;
                }
                DFI.priorityServiceSetShowRules.fieldNameCheckLegalConditions = setShowrulesConditions[i].fieldNameCheckLegalConditions;
                DFI.priorityServiceSetShowRules.fieldNamePhone = setShowrulesConditions[i].fieldNamePhone;
               
               
                //Comprobación multiDSA, tiene que ser compatible hacia atrás.
                if(setShowrulesConditions[i].dsaId !== undefined && setShowrulesConditions[i].dsaId !== null && setShowrulesConditions[i].dsaId !== "undefined" && setShowrulesConditions[i].dsaId !== "null"   ){
                    DFI.priorityServiceSetShowRules.dsaId = setShowrulesConditions[i].dsaId;
                }
                //Comprobación multiModals, tiene que ser compatible hacia atrás.
                if(setShowrulesConditions[i].modalId !== undefined && setShowrulesConditions[i].modalId !== null && setShowrulesConditions[i].modalId !== "undefined" && setShowrulesConditions[i].modalId !== "null"   ){
                    DFI.priorityServiceSetShowRules.modalId = setShowrulesConditions[i].modalId;
                }

                DFI.allConditionsShowRules.push(DFI.priorityServiceSetShowRules);

                //alert("DFI.v_varIdsetshowRules: " + DFI.v_varIdsetshowRules + "	DFI.v_varTrkSetShowRules: " + DFI.v_varTrkSetShowRules + "	DFI.v_varUrlSetShowRules: " +  DFI.v_varUrlSetShowRules); 				
                DFI.consoleLogDelio(JSONstringify(DFI.allConditionsShowRules));

            }
            if (DFI.v_varIdsetshowRulesUltimo !== "none" && DFI.v_varTrkSetShowRules1Ultima !== "none" && DFI.v_varUrlSetShowRulesUltimo && scoringResult && listResult) {
                DFI.setVarCounter = true;
                DFI.scoringPriority = false;
                DFI.priorityServiceSetShowRulesUltimo.idRule = setShowrulesConditions[i].idRule;
                DFI.priorityServiceSetShowRulesUltimo.order = setShowrulesConditions[i].order;
                DFI.priorityServiceSetShowRulesUltimo.description = setShowrulesConditions[i].description;
                DFI.priorityServiceSetShowRulesUltimo.actionIsOkDSA = setShowrulesConditions[i].actionIsOkDSA;
                DFI.priorityServiceSetShowRulesUltimo.actionIsOkInterfereForm = setShowrulesConditions[i].actionIsOkInterfereForm;
                DFI.priorityServiceSetShowRulesUltimo.actionIsOkInterferePhone = setShowrulesConditions[i].actionIsOkInterferePhone;
                DFI.priorityServiceSetShowRulesUltimo.actionIsOkShowChat = setShowrulesConditions[i].actionIsOkShowChat;

                //Compatibilidad hacia atrás. Verificamos si existen los cambios nuevos (whoValidate, interfereButtonsWithClass, fieldsMandatory )
                //Si no existen los seteamos
                if (setShowrulesConditions[i].whoValidate === undefined) {
                    DFI.priorityServiceSetShowRulesUltimo.whoValidate = 1;
                    DFI.priorityServiceSetShowRulesUltimo.interfereButtonsWithClass = "";
                    DFI.priorityServiceSetShowRulesUltimo.fieldsMandatory = [];
                } else {
                    DFI.priorityServiceSetShowRulesUltimo.whoValidate = setShowrulesConditions[i].whoValidate;
                    DFI.priorityServiceSetShowRulesUltimo.interfereButtonsWithClass = setShowrulesConditions[i].interfereButtonsWithClass;
                    DFI.priorityServiceSetShowRulesUltimo.fieldsMandatory = setShowrulesConditions[i].fieldsMandatory;
                }

                DFI.priorityServiceSetShowRulesUltimo.fieldNameCheckLegalConditions = setShowrulesConditions[i].fieldNameCheckLegalConditions;
                DFI.priorityServiceSetShowRulesUltimo.fieldNamePhone = setShowrulesConditions[i].fieldNamePhone;

                //Comprobación multiDSA, tiene que ser compatible hacia atrás.
                 if(setShowrulesConditions[i].dsaId !== undefined && setShowrulesConditions[i].dsaId !== null && setShowrulesConditions[i].dsaId !== "undefined" && setShowrulesConditions[i].dsaId !== "null"   ){
                    DFI.priorityServiceSetShowRulesUltimo.dsaId = setShowrulesConditions[i].dsaId;
                }  
                 //Comprobación multiModals, tiene que ser compatible hacia atrás.
                 if(setShowrulesConditions[i].modalId !== undefined && setShowrulesConditions[i].modalId !== null && setShowrulesConditions[i].modalId !== "undefined" && setShowrulesConditions[i].modalId !== "null"   ){
                    DFI.priorityServiceSetShowRulesUltimo.modalId = setShowrulesConditions[i].modalId;
                }                
                
                DFI.allConditionsShowRulesUltimo.push(DFI.priorityServiceSetShowRulesUltimo);

                //alert("DFI.v_varIdsetshowRules: " + DFI.v_varIdsetshowRules + "	DFI.v_varTrkSetShowRules: " + DFI.v_varTrkSetShowRules + "	DFI.v_varUrlSetShowRules: " +  DFI.v_varUrlSetShowRules); 				
                DFI.consoleLogDelio(JSONstringify(DFI.allConditionsShowRulesUltimo));

            }



            //return DFI.idServiceCond;
        }
        if (DFI.DFI_configuration.showRules.length > 0) {
            //DFI.allConditionsShowRules.push({idRule:9999, "actionIsOkDSA": DFI.DFI_configuration.showRules[0].actionIsOkDSA, "actionIsOkInterfere": DFI.DFI_configuration.showRules[0].actionIsOkInterfere} );
            //DFI.allConditionsShowRules.push({idRule:9999, "actionIsOkDSA":"hide", "actionIsOkInterfere": false} );
            //DFI.allConditionsShowRulesUltimo.push({idRule:9999, "actionIsOkDSA":"hide", "actionIsOkInterfere": false} );
            DFI.allConditionsShowRulesUltimo.push({
                "idRule": 9999,
                "order": 9999,
                "description": "default",
                "actionIsOkDSA": "hide",
                "actionIsOkInterfereForm": false,
                "actionIsOkShowChat":false,
                "whoValidate": 1,
                "dsaId":1,
                "modalId":1,
                "interfereButtonsWithClass": "",
                "fieldsMandatory": [],
                "actionIsOkInterferePhone": false
            });


        } else {
            DFI.allConditionsShowRules.push({
                "idRule": 9999,
                "order": 9999,
                "description": "default",
                "actionIsOkDSA": "show",
                "actionIsOkInterfereForm": true,
                "actionIsOkInterfereForm": false,
                "whoValidate": 1,
                "dsaId":1,
                "modalId":1,
                "actionIsOkShowChat":false,
                "interfereButtonsWithClass": "",
                "fieldsMandatory": [],
                "actionIsOkInterferePhone": true,
                "actionIsOkShowChat": true
                
            });
            DFI.allConditionsShowRulesUltimo.push({
                "idRule": 9999,
                "order": 9999,
                "description": "default",
                "actionIsOkDSA": "show",
                "actionIsOkInterfereForm": true,
                "actionIsOkInterfereForm": false,
                "whoValidate": 1,
                "dsaId":1,
                "modalId":1,
                "actionIsOkShowChat":false,
                "interfereButtonsWithClass": "",
                "fieldsMandatory": [],
                "actionIsOkInterferePhone": true,
                "actionIsOkShowChat": true
            });

        }

        if (DFI.allConditionsShowRules.length === 0 && DFI.DFI_configuration.showRules.length > 0) {
            DFI.allConditionsShowRules.push({
                "idRule": 9999,
                "order": 9999,
                "description": "default",
                "actionIsOkDSA": "hide",
                "actionIsOkInterfereForm": false,
                "actionIsOkInterfereForm": false,
                "whoValidate": 1,
                "dsaId":1,
                "modalId":1,
                "actionIsOkShowChat":false,
                "interfereButtonsWithClass": "",
                "fieldsMandatory": [],
                "actionIsOkInterferePhone": false,
                "actionIsOkShowChat": false
            });

        }

        var actualPriority = DFI.allConditionsShowRules[0];
        var actualPriorityUltimo = DFI.allConditionsShowRulesUltimo[0];
        for (i = 0; i < DFI.allConditionsShowRules.length; i++) {

            if ((DFI.allConditionsShowRules[i].actionIsOkDSA === "hide")) {

                actualPriority.actionIsOkDSA = DFI.allConditionsShowRules[i].actionIsOkDSA;

            }
            if ((DFI.allConditionsShowRules[i].actionIsOkInterfereForm === false || DFI.allConditionsShowRules[i].actionIsOkInterferePhone === false)) {

                actualPriority.actionIsOkInterfereForm = DFI.allConditionsShowRules[i].actionIsOkInterfereForm;
                actualPriority.actionIsOkInterferePhone = DFI.allConditionsShowRules[i].actionIsOkInterferePhone;
                actualPriority.actionIsOkShowChat = DFI.allConditionsShowRules[i].actionIsOkShowChat;
                //Compatibilidad hacia atrás. Verificamos si existen los cambios nuevos (whoValidate, interfereButtonsWithClass, fieldsMandatory )
                //Si no existen los seteamos
                if (actualPriority.whoValidate === undefined) {
                    actualPriority.whoValidate = 1;
                    actualPriority.interfereButtonsWithClass = "";
                    actualPriority.fieldsMandatory = [];
                } else {
                    actualPriority.whoValidate = DFI.allConditionsShowRules[i].whoValidate;
                    actualPriority.interfereButtonsWithClass = DFI.allConditionsShowRules[i].interfereButtonsWithClass;
                    actualPriority.fieldsMandatory = DFI.allConditionsShowRules[i].fieldsMandatory;
                }
                actualPriority.fieldNameCheckLegalConditions = DFI.allConditionsShowRules[i].fieldNameCheckLegalConditions;
                actualPriority.fieldNamePhone = DFI.allConditionsShowRules[i].fieldNamePhone;
            }

            if (i < DFI.allConditionsShowRulesUltimo.length) {
                if (i === 0 && (DFI.allConditionsShowRulesUltimo[i].actionIsOkDSA !== "show")) {

                    actualPriorityUltimo.actionIsOkDSA = DFI.allConditionsShowRulesUltimo[i].actionIsOkDSA;

                }
                if (i === 0 && (DFI.allConditionsShowRulesUltimo[i].actionIsOkInterfereForm !== true || DFI.allConditionsShowRulesUltimo[i].actionIsOkInterferePhone !== true)) {

                    actualPriorityUltimo.actionIsOkInterfereForm = DFI.allConditionsShowRulesUltimo[i].actionIsOkInterfereForm;
                    actualPriorityUltimo.actionIsOkInterferePhone = DFI.allConditionsShowRulesUltimo[i].actionIsOkInterferePhone;
                    actualPriorityUltimo.actionIsOkShowChat = DFI.allConditionsShowRulesUltimo[i].actionIsOkShowChat;
                    //Compatibilidad hacia atrás. Verificamos si existen los cambios nuevos (whoValidate, interfereButtonsWithClass, fieldsMandatory )
                    //Si no existen los seteamos
                    if (actualPriorityUltimo.whoValidate === undefined) {
                        actualPriorityUltimo.whoValidate = 1;
                        actualPriorityUltimo.interfereButtonsWithClass = "";
                        actualPriorityUltimo.fieldsMandatory = [];
                    } else {
                        actualPriorityUltimo.whoValidate = DFI.allConditionsShowRulesUltimo[i].whoValidate;
                        actualPriorityUltimo.interfereButtonsWithClass = DFI.allConditionsShowRulesUltimo[i].interfereButtonsWithClass;
                        actualPriorityUltimo.fieldsMandatory = DFI.allConditionsShowRulesUltimo[i].fieldsMandatory;
                    }
                    actualPriorityUltimo.fieldNameCheckLegalConditions = DFI.allConditionsShowRulesUltimo[i].fieldNameCheckLegalConditions;
                    actualPriorityUltimo.fieldNamePhone = DFI.allConditionsShowRulesUltimo[i].fieldNamePhone;

                }
            }

        }

        if (actualPriorityUltimo.order !== 9999 ) {
            actualPriority = DFI.allConditionsShowRulesUltimo[0];
            actualPriority.actionIsOkDSA = actualPriorityUltimo.actionIsOkDSA;
            actualPriority.actionIsOkInterfereForm = actualPriorityUltimo.actionIsOkInterfereForm;
            actualPriority.actionIsOkInterferePhone = actualPriorityUltimo.actionIsOkInterferePhone;
            actualPriority.actionIsOkShowChat = actualPriorityUltimo.actionIsOkShowChat;
            //Compatibilidad hacia atrás. Verificamos si existen los cambios nuevos (whoValidate, interfereButtonsWithClass, fieldsMandatory )
            //Si no existen los seteamos
            if (actualPriority.whoValidate === undefined) {
                actualPriority.whoValidate = 1;
                actualPriority.interfereButtonsWithClass = "";
                actualPriority.fieldsMandatory = [];
            } else {
                actualPriority.whoValidate = actualPriorityUltimo.whoValidate;
                actualPriority.interfereButtonsWithClass = actualPriorityUltimo.interfereButtonsWithClass;
                actualPriority.fieldsMandatory = actualPriorityUltimo.fieldsMandatory;
            }
            actualPriority.fieldNameCheckLegalConditions = actualPriorityUltimo.fieldNameCheckLegalConditions;
            actualPriority.fieldNamePhone = actualPriorityUltimo.fieldNamePhone;
            
            //13/08/2018. No se tiene en cuenta los multiDSAs. Añadirlo que caso de que se reuiqrea para la regla 9999, aunque en principio no está contemplado. Depende de lo que al final se haga en el front
            //  con la regla por defecto.

        }
        //if(actualPriorityUltimo.actionIsOkInterfere === true){
        //	actualPriority.actionIsOkInterfere = actualPriorityUltimo.actionIsOkInterfere;
        //}
        DFI.setVarCounter = false;
        return actualPriority;

    };

    /*
    |---------------------------------------------------------------------------
    |Leer el Web service de una lista
    |---------------------------------------------------------------------------
    */

    //Añadir en init.js DFI.global.checkList = DFI.global.provision +"wsList/checkListBy.html?format=jsonp&idTag=";
    //Cuando se pase a producción debajo de la línea 188
    DFI.global.checkList = DFI.global.provision +"wsList/checkListBy.html?format=jsonp&idTag=";

    /*
    |---------------------------------------------------------------------------
    |Comprobar los elementos que cumplen una lista 
    |---------------------------------------------------------------------------
    */



    /*
    |---------------------------------------------------------------------------
    | Smart scoring
    |---------------------------------------------------------------------------
    */

    //DFI.DFI_configuration.showRules
    //Dentro del propio Objeto DFI.DFI_configuration.showRules se añade el resultado de la comparación
    // La etiqueta global  DFI.ScoringActionCompleted= true, indica que se ha completado en todo el objeto el metodo probabilístico 

    // Promsesa para la resolucion de todas las peticiones internas de smartScoringShowRules
    DFI.promiseSmartScoringShowRules = new DAL.Promise();


    DFI.smartScoringShowRulesNewWay = function(callback) {
        var idRequest = "null";

        for (var x = 0, len = DFI.DFI_configuration.showRules.length; x < len; x++) {
            if((DFI.DFI_configuration.showRules[x].rules.scoring !== null 
                && DFI.DFI_configuration.showRules[x].rules.scoring !== "") 
                && DFI.DFI_configuration.showRules[x].rules.scoring.scoringUrl !== null 
                && DFI.DFI_configuration.showRules[x].rules.scoring.scoringUrl !== "null"){

                    idRequest =  DFI.DFI_configuration.showRules[x].rules.scoring.idRequest;
                    DFI.DFI_configuration.scoringIdRequest = idRequest;
                    //Setintervals para recalcular scoring on mouse leave
                    

            }
          }

        if(idRequest != "null"){
            var waitPiwikToLoad = 0;
            var piwikIsAlreadyLoaded = false;
            var PiwikToLoaded  = setInterval(function(){
            
                waitPiwikToLoad ++;
                
                if(waitPiwikToLoad > 50){
                    clearInterval(PiwikToLoaded);
                }

                if(typeof Piwik === "object" 
                && typeof Piwik.getAsyncTracker() === "object" 
                && typeof Piwik.getAsyncTracker().getVisitorId() ==="string" ){
                    clearInterval(PiwikToLoaded);
                    piwikIsAlreadyLoaded = true;
                }

                if( piwikIsAlreadyLoaded ){
                    var respuestaLeadDelio1 = false;
                    DFI.datosLead = {};
                    DFI.ScoringActionCompleted = false;
                    //Vemos si existe el lead
                    var leadStored = DFI.getCookie("wIdlLead");
                    var leadNotStored;
                    if (leadStored === undefined){
                        leadNotStored = Piwik.getAsyncTracker().getVisitorId();
                    }
                    DFI.intervalOutFocus(idRequest); 
                    DAL.Ajax({
                        type: 'jsonp',
                        url: DFI.global.updateVisitLabelByVisitorId,
                        data: {
                            data: encodeURIComponent(JSON.stringify(DFI.labels.EVisitsDef)),
                            idTag: DFI.idTagDelio,
                            idVisitor: Piwik.getAsyncTracker().getVisitorId(),
                            format: "jsonp",
                        }
                    }).done(function(dataResp) {
                        //Vemos si tenemos algún scoring
                        // En esta versión solo hay un idRequest, por lo que en caso de haber scoring solo hacemos una
                        // llamada al web service.
                        
                        //Existe el lead
                        if (leadStored != undefined) {
                            //DFI.global.scoringLeadId en V7 se obtendrá de config
                            //leadId:leadStored

                            try {
                                DAL.Ajax({
                                    type: "jsonp",
                                    url: DFI.global.scoringVisitoId,
                                    data:{
                                        format: "jsonp",
                                        idTag:DFI.idTagDelio,
                                        idRequest:idRequest,
                                        visitorId: Piwik.getAsyncTracker().getVisitorId()
                                    }
                                }).done(function(response) {
                    
                                    DFI.scoringSaving(response,leadStored,false);
                                    if (callback) { 
                                        callback(); 
                                    };
                    
                                });
                              }
                              catch(error) {
                                if (callback) { 
                                    callback(); 
                                };
                              }

                
                            //No existe el lead
                        } else {


                            try {
                                DAL.Ajax({
                                    type: "jsonp",
                                    url: DFI.global.scoringVisitoId,
                                    data:{
                                        format: "jsonp",
                                        idTag:DFI.idTagDelio,
                                        idRequest:idRequest,
                                        visitorId: Piwik.getAsyncTracker().getVisitorId()
                                    }
                                }).done(function(response) {
                    
                                    DFI.scoringSaving(response,leadNotStored,true);
                                    if (callback) { 
                                        callback(); 
                                    };
                    
                                });
                              }
                              catch(error) {
                                console.error(error);
                                if (callback) { 
                                    callback(); 
                                };
                              }
                            

                        }
 
                    });
                }
        
        }, 50);   

        } else{
            if (callback) { 
                callback(); 
            };
        }
    };

    DFI.saveScoringVisit = function(scoringIdRequest){
        DAL.Ajax({
            type: 'jsonp',
            url: DFI.global.updateVisitLabelByVisitorId,
            data: {
                data: encodeURIComponent(JSON.stringify(DFI.labels.EVisitsDef)),
                idTag: DFI.idTagDelio,
                idVisitor: Piwik.getAsyncTracker().getVisitorId(),
                format: "jsonp",
            }
        }).done(function(dataResp) {
            //Vemos si tenemos algún scoring
            // En esta versión solo hay un idRequest, por lo que en caso de haber scoring solo hacemos una
            // llamada al web service.
            
            //Existe el lead
            if(typeof Piwik === "object" 
            && typeof Piwik.getAsyncTracker() === "object" 
            && typeof Piwik.getAsyncTracker().getVisitorId() ==="string" ) {
                try {
                    DAL.Ajax({
                        type: "jsonp",
                        url: DFI.global.scoringVisitoId,
                        data:{
                            format: "jsonp",
                            idTag:DFI.idTagDelio,
                            idRequest:scoringIdRequest,
                            visitorId: Piwik.getAsyncTracker().getVisitorId()
                        }
                    }).done(function(response) {
                        var leadStored = DFI.getCookie("wIdlLead");
                        var visitOnly = false;
                        if (leadStored === undefined){
                            leadStored = Piwik.getAsyncTracker().getVisitorId();
                            visitOnly = true;
                        }
                        DFI.scoringSaving(response,leadStored,visitOnly);
                        
        
                    });
                  }
                  catch(error) {
                    console.error(error);

                  }
                  

            } 
        });
    }



    // scoring on mouse leave


    DFI.intervalOutFocus = function(idRequest){
        DFI.recalculateScoring = function () {
            const threshold = 10000; // Tiempo mínimo que ha de transcurrir para volver a lanzar la petición
            if (DFI.lastCalculationOfScoring === undefined || ((Date.now() - DFI.lastCalculationOfScoring) > threshold)) {
                DAL.Ajax({
                    type: "jsonp",
                    url: DFI.global.scoringVisitoId,
                    data:{
                        format: "jsonp",
                        idTag:DFI.idTagDelio,
                        idRequest:idRequest,
                        visitorId: Piwik.getAsyncTracker().getVisitorId()
                    }
                }).done(function(response) {
                    var leadStored = DFI.getCookie("wIdlLead");
                    var visitOnly = false;
                    if (leadStored === undefined){
                        leadStored = Piwik.getAsyncTracker().getVisitorId();
                        visitOnly = true;
                    }
                    DFI.scoringSaving(response,leadStored,visitOnly);
                    

    
                });
            DFI.setLastCalculationOfScoring();
            }
            }
            
            DFI.recalculateScoringBasedOnMousePosition = function() {
            document.querySelector("html").addEventListener("mouseleave", DFI.recalculateScoring);
            document.querySelector("html").addEventListener("mouseenter", null);
            } 
            
            DFI.setLastCalculationOfScoring = function() {
            DFI.lastCalculationOfScoring = Date.now();
            }
            DFI.getMousePosition = (canvas, e) => ({ mouseX: e.clientX, mouseY: e.clientY });
            DFI.recalculateScoringBasedOnMousePosition();
    }
    //Guardamos el scoring

    DFI.scoringSaving = function(response,leadStored,visitOnly){
        if(typeof response != "object" || response === null ){
            response ={};
            response.valueToMatch = 0;
        }

        if(typeof response.valueToMatch === "undefined" ){
            response.valueToMatch = 0;
        }
        var leadUpdated = false
        for (var indice = 0, len = DFI.DFI_configuration.showRules.length; indice  < len; indice++) {
            if((DFI.DFI_configuration.showRules[indice].rules.scoring !== null 
                && DFI.DFI_configuration.showRules[indice].rules.scoring !== "") 
                && DFI.DFI_configuration.showRules[indice].rules.scoring.scoringUrl !== null 
                && DFI.DFI_configuration.showRules[indice].rules.scoring.scoringUrl !== "null"){

                //Se devuelven invertidos
                //DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium:Nivel inferior
                //DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow: Nivel superior

                var lowLevel = parseFloat(DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow)*100;
                var highLevel = parseFloat(DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium)*100;
                var valueReceived = parseFloat(response.valueToMatch);

                DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived = valueReceived;

                var scoringReceived = "medium";
                if (valueReceived >= highLevel) {
                    scoringReceived = "high";
                } else if (valueReceived <= lowLevel) {
                    scoringReceived = "low";
                }
                DFI.DFI_configuration.showRules[indice].rules.scoring.delioScoringCondition = scoringReceived;

                var scoringToMatch = DFI.DFI_configuration.showRules[indice].rules.scoring.valueToMatch;

                if(scoringToMatch === undefined){
                    scoringToMatch = DFI.DFI_configuration.showRules[indice].rules.scoring.condition;
                }

                if (scoringToMatch === '1' && scoringReceived === "high") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else if (scoringToMatch === '2' && scoringReceived === "medium") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else if (scoringToMatch === '3' && scoringReceived === "low") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = false;

                }

                // En caso de que valueReceived === NaN, significa que no se ha recibido response.valueToMatch
                if (isNaN(valueReceived)) {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = false;
                    //En caso de que scoring.completed sea false, seteamos una etiqueta declarativa para indicar que no ha habido un error en la petición del scoring.
                    // Se devuelve el mismo valor de response serializado.
                    DFI.labels.EDeclaratives.scoringQueryeryError = JSON.stringify(response);
                    DFI.DFI_configuration.showRules[indice].rules.scoring.scoringQueryeryError = DFI.labels.EDeclaratives.scoringQueryeryError;
                }

                if(typeof DFI.labels.EDeclaratives.scoringQueryeryError === "undefined"){
                    DFI.DFI_configuration.showRules[indice].rules.scoring.scoringQueryeryError ="  ";
                } else{
                    DFI.DFI_configuration.showRules[indice].rules.scoring.scoringQueryeryError = DFI.labels.EDeclaratives.scoringQueryeryError;                   
                }

                //Almacenamos en statusDFI.scoring, para que se utilice externamente.
                if(typeof statusDFI.scoring === "undefined"){
                    statusDFI.scoring = {};
                }
                
                if(  DFI.DFI_configuration.showRules[indice].scoringVisibleToThirdParties != null 
                &&  typeof statusDFI.scoring!= "undefined" && typeof statusDFI.scoring.completed === "undefined" ){
                    statusDFI.scoring.completed = DFI.DFI_configuration.showRules[indice].rules.scoring.completed;
                    statusDFI.scoring.result = DFI.DFI_configuration.showRules[indice].rules.scoring.result;
                    statusDFI.scoring.valueReceived = DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived;
                    statusDFI.scoring.idRequest = DFI.DFI_configuration.showRules[indice].rules.scoring.idRequest;
                    statusDFI.scoring.condition = DFI.DFI_configuration.showRules[indice].rules.scoring.condition;
                    statusDFI.scoring.description = DFI.DFI_configuration.showRules[indice].rules.scoring.description;
                    statusDFI.scoring.result = DFI.DFI_configuration.showRules[indice].rules.scoring.result;
                    statusDFI.scoring.delioScoringCondition = DFI.DFI_configuration.showRules[indice].rules.scoring.delioScoringCondition;
                    
                }

                var dataLeadScoring  = JSON.stringify({
                    "EDeclaratives": {
                        //"delio_scoring_idRequest":DFI.DFI_configuration.showRules[indice].rules.scoring.idRequest,
                        "delio_scoring_value":DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived,
                        "delio_scoring_description":DFI.DFI_configuration.showRules[indice].rules.scoring.description,
                        "delio_scoring_HighMedium":DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium,
                        "delio_scoring_MediumLow":DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow,
                        "delio_scoring_completed":DFI.DFI_configuration.showRules[indice].rules.scoring.completed,
                        "delio_scoring_condition":DFI.DFI_configuration.showRules[indice].rules.scoring.condition,
                        "delio_scoring_result":DFI.DFI_configuration.showRules[indice].rules.scoring.result,
                        "delio_scoring_scoringQueryeryError":DFI.DFI_configuration.showRules[indice].rules.scoring.scoringQueryeryError,
                        "delio_scoring_fechaScore":'fn_delioTimestampNow',
                        "delio_scoring_condition":DFI.DFI_configuration.showRules[indice].rules.scoring.delioScoringCondition,
                    }
                });

                //Guardamos los datos en una cookie para que lo consuma el pixel de visita
                DFI.savingScoringForVisitag("scrWal",dataLeadScoring);




                if(!leadUpdated && leadStored != undefined && visitOnly != true){
                    leadUpdated = true;
                    //actualizamos el lead.
                    var ws = DFI.global.provision + "wsclient/delioClientLeadId_put.html";
                    ws += '?idTag=' + DFI.idTagDelio;
                    ws += '&leadId=' + leadStored;
                    DAL.Ajax({ type: "script", url: ws + "&data=" + dataLeadScoring }); 

                }

                   

                if(!leadUpdated && leadStored === undefined){
                    leadUpdated = true;
                    //actualizamos el lead.

                    //DFI.labels.EDeclaratives.delio_scoring_idRequest = DFI.DFI_configuration.showRules[indice].rules.scoring.idRequest;
                    // DFI.labels.EDeclaratives.delio_scoring_value = DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived;
                    // DFI.labels.EDeclaratives.delio_scoring_description = DFI.DFI_configuration.showRules[indice].rules.scoring.description;
                    // DFI.labels.EDeclaratives.delio_scoring_HighMedium = DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium;
                    // DFI.labels.EDeclaratives.delio_scoring_MediumLow = DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow;
                    // DFI.labels.EDeclaratives.delio_scoring_completed = DFI.DFI_configuration.showRules[indice].rules.scoring.completed;
                    // DFI.labels.EDeclaratives.delio_scoring_condition = DFI.DFI_configuration.showRules[indice].rules.scoring.condition;
                    // DFI.labels.EDeclaratives.delio_scoring_result = DFI.DFI_configuration.showRules[indice].rules.scoring.result;
                    // DFI.labels.EDeclaratives.delio_scoring_scoringQueryeryError = DFI.DFI_configuration.showRules[indice].rules.scoring.scoringQueryeryError;
                    // DFI.labels.EDeclaratives.delio_scoring_fechaScore = 'fn_delioTimestampNow';
                    // DFI.labels.EDeclaratives.delio_scoring_evaluation  = DFI.DFI_configuration.showRules[indice].rules.scoring.delioScoringCondition;

                }



            }

            
          }



    }

    //Guardamos el scorinng para consumo del pixel de visita.

    DFI.savingScoringForVisitag= function(cookiename,dataLeadSerialized) {
       
        var dataLead = JSON.parse(dataLeadSerialized);
        // Mapeamos los datos que necesita el pixel de visita
        // cambiamos delio_scoring_fechaScore con la fecha actual en vez de la del servidor.
        // Añadimos delio_scoring_condition_decoded basada en delio_scoring_condition
        // delio_scoring_condition = "1" => high
        // delio_scoring_condition = "2" => medium
        // delio_scoring_condition = "3" => low

        var dataLeadCookie = {};
        
        for (const prop in dataLead.EDeclaratives) {
            dataLeadCookie[prop] = dataLead.EDeclaratives[prop]
          }


        var d = new Date();
        //dataLeadCookie.delio_scoring_fechaScore = d.toLocaleString('es-ES', { timeZone: 'UTC' });
        var cookieHour= String(d.getHours());
        if(cookieHour.length === 1){
            cookieHour = "0" + cookieHour;
        }
        var cookieMinute= String(d.getMinutes());
        if(cookieMinute.length === 1){
            cookieMinute = "0" + cookieMinute;
        }
        var cookieSecond= String(d.getSeconds());
        if(cookieSecond.length === 1){
            cookieSecond = "0" + cookieSecond;
        }

        
        dataLeadCookie.delio_scoring_fechaScore  = d.getFullYear() +"/" + d.getMonth()+"/" + d.getDate() + " " + cookieHour + ":" + cookieMinute + ":" +  cookieSecond;

        // var delioScoringConditions  = ["high", "medium","low"];

        // dataLeadCookie.delio_scoring_condition = delioScoringConditions[Number(dataLeadCookie.delio_scoring_condition)-1]; 

        
        //dataLeadCookie.delio_scoring_condition_decoded
        DFI.setCookie(cookiename, JSON.stringify(dataLeadCookie), 30);
        

    };

    //DFI.consoleLogDelio("Smart Scoring")

    DFI.doCheck = function(countExec, numExec) {
        DFI.consoleLogDelio('doCheck');

        var i = countExec - 1;

        var ui_item = DFI.DFI_configuration.showRules[i].rules.scoring;

        if ((DFI.DFI_configuration.showRules[i].rules.scoring !== null 
            && DFI.DFI_configuration.showRules[i].rules.scoring !== "") 
            && DFI.DFI_configuration.showRules[i].rules.scoring.scoringUrl !== null 
            && DFI.DFI_configuration.showRules[i].rules.scoring.scoringUrl !== "null") {
            var tagsToSend = '{"idTag":"' + DFI.DFI_configuration.idTagDelioClient + '"';
            var tagTemp = '';
            // construimos tagsToSend en función de las etiquetas que puedan venir en el lead.
            //tipo se añadió el 12/12/2018, para identificar el tipo de etiqueta. Se pone la nomenclatura corta: del, ext, con, etc.
            //DFI.compareObjects(DFI.labels.EDeclaratives,DFI.datosLead.EDeclaratives,DFI.DFI_configuration.showRules[0].rules.scoring.scoringVars.EDeclaratives, tipo)

            // DFI.labels.EDeclaratives
            if (DFI.labels.EDeclaratives === undefined) {
                DFI.labels.EDeclaratives = {};
            }
            if (DFI.datosLead === undefined) {
                DFI.datosLead = {};
            }
            if (DFI.datosLead.EDeclaratives === undefined) {
                DFI.datosLead.EDeclaratives = {};
            }

            if (DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EDeclaratives === undefined) {
                DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EDeclaratives = {};
            }
            tagTemp = DFI.compareObjects(DFI.labels.EDeclaratives, DFI.datosLead.EDeclaratives, DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EDeclaratives,'dec');

            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            //DFI.labels.EExternals
            if (DFI.labels.EExternals === undefined) {
                DFI.labels.EExternals1 = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.labels.EExternals1 = {};
                for (var j = 0, len = DFI.labels.EExternals.length; j < len; j++) {
                    DFI.labels.EExternals1[DFI.labels.EExternals[j].description] = DFI.labels.EExternals[j].descriptionOption;
                }
            }


            if (DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EExternals === undefined) {
                DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EExternals = {};
            }
            if (DFI.datosLead.EExternals === undefined) {
                DFI.datosLead.EExternals1 = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.datosLead.EExternals1 = {};
                for (var j = 0, len = DFI.datosLead.EExternals.length; j < len; j++) {
                    DFI.datosLead.EExternals1[DFI.datosLead.EExternals[j].description] = DFI.datosLead.EExternals[j].descriptionOption;
                }
            }

            tagTemp = DFI.compareObjects(DFI.labels.EExternals, DFI.datosLead.EExternals1, DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EExternals,'ext');
            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }
            // Etiquetas generales, las tenemos que mapear individuálmente.
            if (DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EGenerals === undefined) {
                DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EGenerals = {};
            }

            if (DFI.datosLead.CallRegisterDate === undefined) {
                DFI.datosLead.EGenerals = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.datosLead.EGenerals = {};
                DFI.datosLead.EGenerals.CallRegisterDate = DFI.datosLead.CallRegisterDate;
                DFI.datosLead.EGenerals.Device = DFI.datosLead.Device;
                DFI.datosLead.EGenerals["Fecha Actualizacion"] = DFI.datosLead["Fecha Actualizacion"];
                DFI.datosLead.EGenerals["Fecha Registro"] = DFI.datosLead["Fecha Actualizacion"];
                DFI.datosLead.EGenerals.IP = DFI.datosLead.IP;
                DFI.datosLead.EGenerals.Navigator = DFI.datosLead.Navigator;
                DFI.datosLead.EGenerals.OS = DFI.datosLead.OS;
                DFI.datosLead.EGenerals.averageDurationPerPage = DFI.datosLead.averageDurationPerPage;
                DFI.datosLead.EGenerals.averagePagesPerVisit = DFI.datosLead.averagePagesPerVisit;
                DFI.datosLead.EGenerals.contactId = DFI.datosLead.contactIdt;
                DFI.datosLead.EGenerals.extleadId = DFI.datosLead.extleadId;
                DFI.datosLead.EGenerals.optout = DFI.datosLead.optout;
                DFI.datosLead.EGenerals.owner = DFI.datosLead.owner;
                DFI.datosLead.EGenerals.totalVisits = DFI.datosLead.totalVisits;
            }
            DFI.labels.EGenerals = {};

            tagTemp = DFI.compareObjects(DFI.labels.EGenerals, DFI.datosLead.EGenerals, DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.EGenerals,'gen');
            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            // DFI.labels.utmVars
            if (DFI.labels.utmVars === undefined) {
                DFI.labels.utmVars = {};
            }

            if (DFI.datosLead.Visits === undefined) {
                DFI.datosLead.utmVars = {};
            } else {
                // Tipo: 1 utm_campaign
                //		 2 utm_medium  fuente de tráfico
                //		 3 utm_source proveedr
                //	     4 utm_term  tipo de acción
                //		 5 utm_content  creatividad	
                DFI.datosLead.utmVars = {};
                //En integración no hay pixel de visita por lo que esta parte nos la tenemos que saltar.
                if(DFI.datosLead.Visits.length > 0){
                    DFI.datosLead.utmVars.utm_campaign = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].campaign;
                    DFI.datosLead.utmVars.utm_term = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].actionType;
                    DFI.datosLead.utmVars.utm_content = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].creativity;
                    DFI.datosLead.utmVars.utm_source = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].provider;
                    DFI.datosLead.utmVars.utm_medium = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].trafficSource;    
                }

            }

            if (DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding === undefined) {
                DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.utmVars = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.utmVars = [];
                if (typeof DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars === "object"
                    && DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding.length > 0) {
                    for (var j = 0, len = DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding.length; j < len; j++) {
                        // Tipo: 1 utm_campaign
                        //		 2 utm_medium  fuente de tráfico
                        //		 3 utm_source proveedr
                        //	     4 utm_term  tipo de acción
                        //		 5 utm_content  creatividad	
                        var utmType = "utm_campaign";

                        switch (DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding[j]) {
                            case "Campaña":
                                utmType = "utm_campaign";
                                break;
                            case "Proveedor":
                                utmType = "utm_medium";
                                break;
                            case "Fuente de Tráfico":
                                utmType = "utm_source";
                                break;
                            case "Tipo de Acción":
                                utmType = "utm_term";
                                break;
                            case "Creatividad":
                                utmType = "utm_content";
                                break;
                            default:
                                utmType = DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding[j];
                        }


                        DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.utmVars.push(utmType);
                    }
                }

            }



            tagTemp = DFI.compareObjects(DFI.labels.utmVars, DFI.datosLead.utmVars, DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.utmVars,'utm');

            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            var indice = i;
            //Cerramos el objeto JSON

            if (DFI.DFI_configuration.showRules[i].rules.scoring.hasOwnProperty('objetive')) {
                tagsToSend += ',"objetive":' + '"' + DFI.DFI_configuration.showRules[i].rules.scoring.objetive + '"}';
            } else {
                tagsToSend += '}';
            }

            var urlProbabilisticScoring = DFI.DFI_configuration.showRules[indice].rules.scoring.scoringUrl
            if(urlProbabilisticScoring.indexOf('?') > -1){
                urlProbabilisticScoring += "&format=jsonp&data=";
            } else{
                urlProbabilisticScoring += "?format=jsonp&data=";
            }

            DAL.Ajax({
                type: "jsonp",
                url: urlProbabilisticScoring + JSONstringify(JSON.parse(tagsToSend)),
            }).done(function(response) {
                //Se devuelven invertidos
                //DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium:Nivel inferior
                //DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow: Nivel superior

                var highLevel = parseFloat(DFI.DFI_configuration.showRules[indice].rules.scoring.MediumLow);
                var lowLevel = parseFloat(DFI.DFI_configuration.showRules[indice].rules.scoring.HighMedium);
                var valueReceived = parseFloat(response.valueToMatch);

                DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived = valueReceived;

                var scoringReceived = "medium";
                if (valueReceived >= highLevel) {
                    scoringReceived = "high";
                } else if (valueReceived <= lowLevel) {
                    scoringReceived = "low";
                }

                var scoringToMatch = DFI.DFI_configuration.showRules[indice].rules.scoring.valueToMatch;

                if(scoringToMatch === undefined){
                    scoringToMatch = DFI.DFI_configuration.showRules[indice].rules.scoring.condition;
                }

                if (scoringToMatch === '1' && scoringReceived === "high") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else if (scoringToMatch === '2' && scoringReceived === "medium") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else if (scoringToMatch === '3' && scoringReceived === "low") {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = true;
                } else {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = true;
                    DFI.DFI_configuration.showRules[indice].rules.scoring.result = false;

                }

                // En caso de que valueReceived === NaN, significa que no se ha recibido response.valueToMatch
                if (isNaN(valueReceived)) {
                    DFI.DFI_configuration.showRules[indice].rules.scoring.completed = false;
                    //En caso de que scoring.completed sea false, seteamos una etiqueta declarativa para indicar que no ha habido un error en la petición del scoring.
                    // Se devuelve el mismo valor de response serializado.
                    DFI.labels.EDeclaratives.scoringQueryeryError = JSON.stringify(response);
                }

                //Almacenamos en statusDFI.scoring, para que se utilice externamente.
                statusDFI.scoring = {};
                if(  typeof  DFI.DFI_configuration.showRules[indice].scoringVisibleToThirdParties === "object"  ){
                    statusDFI.scoring.completed = DFI.DFI_configuration.showRules[indice].rules.scoring.completed;
                    statusDFI.scoring.result = DFI.DFI_configuration.showRules[indice].rules.scoring.result;
                    statusDFI.scoring.valueReceived = DFI.DFI_configuration.showRules[indice].rules.scoring.valueReceived;
                    statusDFI.scoring.idRequest = DFI.DFI_configuration.showRules[indice].rules.scoring.idRequest;
                    statusDFI.scoring.condition = DFI.DFI_configuration.showRules[indice].rules.scoring.condition;
                    statusDFI.scoring.description = DFI.DFI_configuration.showRules[indice].rules.scoring.description;
                }


                DFI.consoleLogDelio(ui_item + ': ' + i);

                if (countExec === numExec) {
                    DFI.promiseSmartScoringShowRules.resolve();
                } else {
                    countExec++;
                    DFI.doCheck(countExec, numExec);
                }
            });

        } else {
            DFI.consoleLogDelio(ui_item + ': ' + i);

            if (countExec === numExec) {
                DFI.promiseSmartScoringShowRules.resolve();
            } else {
                countExec++;
                DFI.doCheck(countExec, numExec);
            }
        }

    }


    // Fin Smart scoring


        /*
    |---------------------------------------------------------------------------
    | Smart scoring scoringVisibleToThirdParties
    |---------------------------------------------------------------------------
    */

    //Se prepara como función. En un futuro sustituye a parte del código de
    // ((DFI.DFI_configuration.showRules[i].rules.scoring !== null 
    // && DFI.DFI_configuration.showRules[i].rules.scoring !== "") 
    //&& DFI.DFI_configuration.showRules[i].rules.scoring.scoringUrl !== null 
    // && DFI.DFI_configuration.showRules[i].rules.scoring.scoringUrl !== "null") 

    DFI.caculateScoringbasedOnParameters = function(scoringObject,callBack){

        if ((scoringObject !== null 
            && scoringObject !== "") 
            && scoringObject.scoringUrl !== null 
            && scoringObject.scoringUrl !== "null") {
            var tagsToSend = '{"idTag":"' + DFI.DFI_configuration.idTagDelioClient + '"';
            var tagTemp = '';
            // construimos tagsToSend en función de las etiquetas que puedan venir en el lead.
            //tipo se añadió el 12/12/2018, para identificar el tipo de etiqueta. Se pone la nomenclatura corta: del, ext, con, etc.
            //DFI.compareObjects(DFI.labels.EDeclaratives,DFI.datosLead.EDeclaratives,DFI.DFI_configuration.showRules[0].scoring.scoringVars.EDeclaratives, tipo)

            // DFI.labels.EDeclaratives
            if (DFI.labels.EDeclaratives === undefined) {
                DFI.labels.EDeclaratives = {};
            }
            if (DFI.datosLead === undefined) {
                DFI.datosLead = {};
            }
            if (DFI.datosLead.EDeclaratives === undefined) {
                DFI.datosLead.EDeclaratives = {};
            }

            if (scoringObject.scoringVars.EDeclaratives === undefined) {
                scoringObject.scoringVars.EDeclaratives = {};
            }
            tagTemp = DFI.compareObjects(DFI.labels.EDeclaratives, DFI.datosLead.EDeclaratives, scoringObject.scoringVars.EDeclaratives,'dec');

            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            //DFI.labels.EExternals
            if (DFI.labels.EExternals === undefined) {
                DFI.labels.EExternals1 = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.labels.EExternals1 = {};
                for (var j = 0, len = DFI.labels.EExternals.length; j < len; j++) {
                    DFI.labels.EExternals1[DFI.labels.EExternals[j].description] = DFI.labels.EExternals[j].descriptionOption;
                }
            }


            if (scoringObject.scoringVars.EExternals === undefined) {
                scoringObject.scoringVars.EExternals = {};
            }
            if (DFI.datosLead.EExternals === undefined) {
                DFI.datosLead.EExternals1 = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.datosLead.EExternals1 = {};
                for (var j = 0, len = DFI.datosLead.EExternals.length; j < len; j++) {
                    DFI.datosLead.EExternals1[DFI.datosLead.EExternals[j].description] = DFI.datosLead.EExternals[j].descriptionOption;
                }
            }

            tagTemp = DFI.compareObjects(DFI.labels.EExternals, DFI.datosLead.EExternals1, scoringObject.scoringVars.EExternals,'ext');
            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }
            // Etiquetas generales, las tenemos que mapear individuálmente.
            if (scoringObject.scoringVars.EGenerals === undefined) {
                scoringObject.scoringVars.EGenerals = {};
            }

            if (DFI.datosLead.CallRegisterDate === undefined) {
                DFI.datosLead.EGenerals = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                DFI.datosLead.EGenerals = {};
                DFI.datosLead.EGenerals.CallRegisterDate = DFI.datosLead.CallRegisterDate;
                DFI.datosLead.EGenerals.Device = DFI.datosLead.Device;
                DFI.datosLead.EGenerals["Fecha Actualizacion"] = DFI.datosLead["Fecha Actualizacion"];
                DFI.datosLead.EGenerals["Fecha Registro"] = DFI.datosLead["Fecha Actualizacion"];
                DFI.datosLead.EGenerals.IP = DFI.datosLead.IP;
                DFI.datosLead.EGenerals.Navigator = DFI.datosLead.Navigator;
                DFI.datosLead.EGenerals.OS = DFI.datosLead.OS;
                DFI.datosLead.EGenerals.averageDurationPerPage = DFI.datosLead.averageDurationPerPage;
                DFI.datosLead.EGenerals.averagePagesPerVisit = DFI.datosLead.averagePagesPerVisit;
                DFI.datosLead.EGenerals.contactId = DFI.datosLead.contactIdt;
                DFI.datosLead.EGenerals.extleadId = DFI.datosLead.extleadId;
                DFI.datosLead.EGenerals.optout = DFI.datosLead.optout;
                DFI.datosLead.EGenerals.owner = DFI.datosLead.owner;
                DFI.datosLead.EGenerals.totalVisits = DFI.datosLead.totalVisits;
            }
            DFI.labels.EGenerals = {};

            tagTemp = DFI.compareObjects(DFI.labels.EGenerals, DFI.datosLead.EGenerals, scoringObject.scoringVars.EGenerals,'gen');
            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            // DFI.labels.utmVars
            if (DFI.labels.utmVars === undefined) {
                DFI.labels.utmVars = {};
            }

            if (DFI.datosLead.Visits === undefined) {
                DFI.datosLead.utmVars = {};
            } else {
                // Tipo: 1 utm_campaign
                //		 2 utm_medium  fuente de tráfico
                //		 3 utm_source proveedr
                //	     4 utm_term  tipo de acción
                //		 5 utm_content  creatividad	
                DFI.datosLead.utmVars = {};
                if(DFI.datosLead.Visits.length > 0){
                    DFI.datosLead.utmVars.utm_campaign = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].campaign;
                    DFI.datosLead.utmVars.utm_term = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].actionType;
                    DFI.datosLead.utmVars.utm_content = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].creativity;
                    DFI.datosLead.utmVars.utm_source = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].provider;
                    DFI.datosLead.utmVars.utm_medium = DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog[DFI.datosLead.Visits[DFI.datosLead.Visits.length - 1].visitLog.length - 1].trafficSource;
    
                }

            }

            if (scoringObject.scoringVars.ELanding === undefined) {
                scoringObject.scoringVars.utmVars = {};
            } else {
                //Adecuamos el objeto DFI.labels.EExternals, para poderlo comparar
                scoringObject.scoringVars.utmVars = [];
                if (scoringObject.scoringVars.length > 0 && scoringObject.scoringVars.ELanding.length > 0) {
                    for (var j = 0, len = scoringObject.scoringVars.ELanding.length; j < len; j++) {
                        // Tipo: 1 utm_campaign
                        //		 2 utm_medium  fuente de tráfico
                        //		 3 utm_source proveedr
                        //	     4 utm_term  tipo de acción
                        //		 5 utm_content  creatividad	
                        var utmType = "utm_campaign";

                        switch (scoringObject.scoringVars.ELanding[j]) {
                            case "Campaña":
                                utmType = "utm_campaign";
                                break;
                            case "Proveedor":
                                utmType = "utm_medium";
                                break;
                            case "Fuente de Tráfico":
                                utmType = "utm_source";
                                break;
                            case "Tipo de Acción":
                                utmType = "utm_term";
                                break;
                            case "Creatividad":
                                utmType = "utm_content";
                                break;
                            default:
                                utmType = DFI.DFI_configuration.showRules[i].rules.scoring.scoringVars.ELanding[j];
                        }

                        //scoringObject.scoringVars.utmVars[utmType] = scoringObject.scoringVars.ELanding[j].idLabelValue;
                        scoringObject.scoringVars.utmVars.push(utmType);
                    }
                }

            }



            tagTemp = DFI.compareObjects(DFI.labels.utmVars, DFI.datosLead.utmVars, scoringObject.scoringVars.utmVars,'utm');

            if (tagTemp !== "") {
                tagsToSend += ',' + tagTemp;
            }

            var indice = i;
            //Cerramos el objeto JSON

            if (scoringObject.hasOwnProperty('objetive')) {
                tagsToSend += ',"objetive":' + '"' + scoringObject.objetive + '"}';
            } else {
                tagsToSend += '}';
            }

            var urlProbabilisticScoring = scoringObject.scoringUrl
            if(urlProbabilisticScoring.indexOf('?') > -1){
                urlProbabilisticScoring += "&format=jsonp&data=";
            } else{
                urlProbabilisticScoring += "?format=jsonp&data=";
            }

            DAL.Ajax({
                type: "jsonp",
                url: urlProbabilisticScoring + JSONstringify(JSON.parse(tagsToSend)),
            }).done(function(response) {
                //Se devuelven invertidos
                //scoringObject.HighMedium:Nivel inferior
                //scoringObject.MediumLow: Nivel superior

                var highLevel = parseFloat(scoringObject.MediumLow);
                var lowLevel = parseFloat(scoringObject.HighMedium);
                var valueReceived = parseFloat(response.valueToMatch);

                scoringObject.valueReceived = valueReceived;

                var scoringReceived = "medium";
                if (valueReceived >= highLevel) {
                    scoringReceived = "high";
                } else if (valueReceived <= lowLevel) {
                    scoringReceived = "low";
                }

                var scoringToMatch = scoringObject.valueToMatch;

                if(scoringToMatch === undefined){
                    scoringToMatch = scoringObject.condition;
                }

                if (scoringToMatch === '1' && scoringReceived === "high") {
                    scoringObject.completed = true;
                    scoringObject.result = true;
                } else if (scoringToMatch === '2' && scoringReceived === "medium") {
                    scoringObject.completed = true;
                    scoringObject.result = true;
                } else if (scoringToMatch === '3' && scoringReceived === "low") {
                    scoringObject.completed = true;
                    scoringObject.result = true;
                } else {
                    scoringObject.completed = true;
                    scoringObject.result = false;

                }

                // En caso de que valueReceived === NaN, significa que no se ha recibido response.valueToMatch
                if (isNaN(valueReceived)) {
                    scoringObject.completed = false;
                    //En caso de que scoring.completed sea false, seteamos una etiqueta declarativa para indicar que no ha habido un error en la petición del scoring.
                    // Se devuelve el mismo valor de response serializado.
                    DFI.labels.EDeclaratives.scoringQueryeryError = JSON.stringify(response);
                }

                //Almacenamos en statusDFI.scoring, para que se utilice externamente.
                statusDFI.scoring = {};
                
                statusDFI.scoring.completed = scoringObject.completed;
                statusDFI.scoring.result = scoringObject.result;
                statusDFI.scoring.valueReceived = scoringObject.valueReceived;
                statusDFI.scoring.idRequest = scoringObject.idRequest;
                statusDFI.scoring.condition = scoringObject.condition;
                statusDFI.scoring.description = scoringObject.description;                   
                

                callBack();
                return statusDFI.scoring

            });

        } else{
            return {};
        }












    }

    //fin scoringVisibleToThirdParties


    /*
    |---------------------------------------------------------------------------
	| compareObjects ver objetos que tienen las mismas propiedades y como salida 
	| Lo que enviamos a matching Learning
	|Como entrada se ponen las etiquetas que se han calculado durante la visita
    |---------------------------------------------------------------------------
    */

    DFI.compareObjects = function(labels, datosLeadObject, scoringVarsArray,type) {
        //datos leídos del lead
        //Array del scoring
        //labels Datos de la visita

        var scoringVars = DFI.toObject(scoringVarsArray);
        var tagsToSend = '';

        //Comprobamos que no está en labels ni en el registro
        for (var p in scoringVars) {
            if (scoringVars.hasOwnProperty(p)) {
                if (!datosLeadObject.hasOwnProperty(p) && !labels.hasOwnProperty(p)) {
                    tagsToSend += ',"' + type +'.' + p + '":""';
                }
            }
        }

        //Comprobamos datos leídos y labels, con prioridad labels
        for (var p in datosLeadObject) {
            if (datosLeadObject.hasOwnProperty(p)) {
                if (scoringVars.hasOwnProperty(p)) {
                    if (labels.hasOwnProperty(p)  && labels[p] != "") {
                        tagsToSend += ',"'  + type +'.' + p + '":"' + labels[p] + '"';
                    } else {
                        tagsToSend += ',"' + type +'.' + p + '":"' + datosLeadObject[p] + '"';
                    }
                }
            }
        }

        //Comprobamos labels que no estén en los datos leídos
        for (var p in labels) {
            if (labels.hasOwnProperty(p)  && labels[p] != "") {
                if (scoringVars.hasOwnProperty(p)) {
                    if (!datosLeadObject.hasOwnProperty(p)) {
                        tagsToSend += ',"' + type +'.' + p + '":"' + labels[p] + '"';
                    }
                }
            }
        }

        if (tagsToSend.charAt(0) === ',') {
            tagsToSend = tagsToSend.slice(1);
        }
        return tagsToSend;
    };

    /*
    |---------------------------------------------------------------------------
    | Convert an array to an object de elementos vacios
    |---------------------------------------------------------------------------
    */

    DFI.toObject = function(arr) {
        var rv = {};
        for (var i = 0; i < arr.length; ++i)
            rv[arr[i]] = "";
        return rv;
    }

    /*
    |---------------------------------------------------------------------------
	| dynamicSort compara dos arrays de objetos en base a una propiedad
    |---------------------------------------------------------------------------
    */

    DFI.dynamicSort= function(property) {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    /*
    |---------------------------------------------------------------------------
    | Create a cookie
    |---------------------------------------------------------------------------
    */


    DFI.createCookie = function(name, value) {

        var expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + 60 * 60 * 24 * 30);
        expireDate.toUTCString();
        if (DFI.DFI_configuration)
            document.cookie = name + '=' + value + '; path=/; expires=' + expireDate + '; domain=' + DFI.DFI_configuration.domain;

    };




    /*
    |---------------------------------------------------------------------------
    | Obtener LeadId
    |---------------------------------------------------------------------------
    */
    DFI.getLeadId = function() {
        var idlead = "";

        if (window.womtp && window.womtp.getAsyncTracker) {
            idlead = window.womtp.getAsyncTracker().getVisitorId();
        } else if (window.Piwik) {
            idlead = window.Piwik.getAsyncTracker().getVisitorId();
        }
        idlead = idlead.substring(0, 45);
        if(idlead.indexOf("?") > -1){
            idlead = idlead.split("?")[0];
        }
        return idlead;
    };



    /*
    |---------------------------------------------------------------------------
    | Determina la interface en uso
    |---------------------------------------------------------------------------
    */
    DFI.getInterfaceMode = function() {

        if (mobileAndTabletcheck()) {
            return 'mobile';
        } else {
            return 'desktop';
        }
    };



    /*
    |---------------------------------------------------------------------------
    | Obtener el valor de un parametro en la URL.
    |---------------------------------------------------------------------------
    */
    DFI.getQueryVariable = function(variable, url) {
        var href = url || window.location.search;
        var i, pair;
        var query = href.split("?")[1];
        var vars = query ? query.split("&") : [];

        for (i = 0; i < vars.length; i++) {

            pair = vars[i].split("=");

            if (pair[0] == variable && pair[1] !== "")
                return pair[1];
        }

        return "";
    };



    DFI.loadConversion = function(leadId) {
        var idLead = leadId !== undefined ? leadId : DFI.getLeadId();
        DFI.leadSent = {
            send: "true",
            idLead: idLead
        };
        var url = DFI.global.womtpPixels + DFI.DFI_configuration.idTagConversion + "&orderid=" + idLead;

        //Grabamos una cookie con el idLead
        DFI.setCookie("wIdlLead", idLead, 30);

        DFI.setConversionsLabels();
        if(DFI.DFI_configuration.scoringIdRequest != undefined){
            DFI.saveScoringVisit(DFI.DFI_configuration.scoringIdRequest);
        }
        
        //Dynamic conversionvars
        if(typeof DFI_client === "object" 
        && typeof DFI_client.customVars === "object"
        && typeof DFI_client.customVars.Econversion === "object"
        && typeof DFI_client.customVars.Econversion.ringPool === "object"
        && typeof statusDFI === "object"
        && typeof statusDFI.uid !="undefined"
        ){
            for (let property in DFI_client.customVars.Econversion.ringPool) {

                window[property] = DFI_client.customVars.Econversion.ringPool[property];
            }
            window.DFI.labelsVarRingPool.EConversion = DFI_client.customVars.Econversion.ringPool;

            DAL.Ajax({
                type: "jsonp",
                url: DFI.global.sendRingPoolLabels + "idTag=" + window.DFI.DFI_configuration.idTagDelioClient +"&idvisitor=" + Piwik.getAsyncTracker().getVisitorId()  +"&labels=" + JSON.stringify(window.DFI.labelsVarRingPool) +"&idServ=" + window.DFI.servicioActivo1.serviceIdRingPool,
            }).done(function(responseRingPoolLabels) {
                DFI.consoleLogDelio("sendRingPoolLabels OK: " + responseRingPoolLabels);
                return true;
            }).fail(function(responseRingPoolLabels) {
                DFI.consoleLogDelio("sendRingPoolLabels NOK: " + responseRingPoolLabels);
            });

            //Actualización etiquetas de Ring Pool
        }

        if (typeof DFI_client === "object" 
        && typeof DFI_client.customVars === "object"
        && typeof DFI_client.customVars.Econversion === "object"
        && typeof DFI_client.customVars.Econversion.callMeBack === "object"
        && typeof statusDFI === "object"
        && typeof statusDFI.uid ==="undefined"
        ){
            for (let property in DFI_client.customVars.Econversion.callMeBack) {

                window[property] = DFI_client.customVars.Econversion.callMeBack[property];
            }       
        }
        


        window.DAL.Ajax({
            type: 'script',
            url: url
        });

    };

    /*
    |---------------------------------------------------------------------------
    | Schedule Valid Antigua
    |---------------------------------------------------------------------------
    | @return {boolean}   Horario válido   true | false
    */
    DFI.scheduleValid = function() {

        var now = new Date();
        var day = now.getDay();
        var hour = now.getHours();
        var dateDay = now.getDate();
        var month = now.getMonth();

        // Festivos
        var isDayOff = false;
        var daysOff = {
            "inmaculada": {
                day: 8,
                month: 12
            },
            "constitucion": {
                day: 6,
                month: 12
            },
            "navidad": {
                day: 25,
                month: 12
            },
            "navidad1": {
                day: 26,
                month: 12
            },
            "anio_nuevo": {
                day: 1,
                month: 1
            },
            "reyes": {
                day: 6,
                month: 1
            },
            "viernes-santo": {
                day: 14,
                month: 4
            }
        };

        for (var name in daysOff)
            if ((daysOff[name].month - 1) === month && daysOff[name].day === dateDay)
                isDayOff = true;

        if (isDayOff)
            return false;

        if ((day >= 0 && day <= 8) && (hour >= 8 && hour <= 21))
            return true;

        return false;
    };

    /*
    |---------------------------------------------------------------------------
    | Schedule Valid weekends off
    |---------------------------------------------------------------------------
    | @return {boolean}   Horario válido   true | false
    */
    DFI.scheduleValidWeekend = function() {

        var now = new Date();
        var day = now.getDay();
        var hour = now.getHours();
        var dateDay = now.getDate();
        var month = now.getMonth();

        if ((day >= 1 && day <= 5))
            return true;

        return false;
    };

    /*
        |---------------------------------------------------------------------------
        | Schedule Valid Nueva
        |---------------------------------------------------------------------------
        | @return {boolean}   Horario válido   true | false
        */

    DFI.scheduleValidAll = function(inpuValidSchedule) {
        if(inpuValidSchedule === undefined){
            return false;
        }

        var now = new Date();
        var day = now.getDay();
        if (day === 0) {
            day = 7;
        }
        var hour = now.getHours();
        var dateDay = now.getDate();
        var month = now.getMonth();

        // Festivos
        DFI.isDayOff = false;
        DFI.isTimeOff = false;

        var daysOff = inpuValidSchedule.dayOff;
        var usualDays = inpuValidSchedule.usualDays;

        if (DFI.validSchedule.dayOff[0] !== null) {
            for (var name in daysOff) {
                DFI.consoleLogDelio("(daysOff[name].month - 1): " + (daysOff[name].month - 1) + " day:  " + daysOff[name].day);
                if ((daysOff[name].month - 1) === month && daysOff[name].day === dateDay) {

                    DFI.isDayOff = true;
                    //DFI.consoleLogDelio(DFI.isDayOff);
                }

            }
        }

        for (var name in usualDays) {
            var pp = usualDays[name].day;
            var aa = usualDays[name].startHour;
            var bb = usualDays[name].endHour;
            DFI.consoleLogDelio("startHour: " + usualDays[name].startHour + "endHour: " + usualDays[name].endHour);
            if ((usualDays[name].day) === day && ((usualDays[name].startHour) <= hour && (usualDays[name].endHour) >= hour)) {

                DFI.isTimeOff = true;
                //DFI.consoleLogDelio(DFI.isDayOff);
            }

        }

        if (DFI.isTimeOff) {

            if (DFI.isDayOff) {
                return false;
            } else {
                return true;
            }


        } else {
            return false;
        }



    };

    /*
    |---------------------------------------------------------------------------
    | Inactivity Actions
    |---------------------------------------------------------------------------
    */
    //DFI.inactivityMode =DFI.DFI_configuration.modals.inactivityTime;
    DFI.checkInactivity = null;

    DFI.inactivityActions = function(modals) {

        if(modals.inactivityMode ){
            var inactivityTime = 0;
            var maxInactivity = modals.inactivityTime;
            //var userInactive = new window.DAL.Promise();
    
            //DFI.consoleLogDelio('Inactivity');
    
            startCheckInactivity();
      
                window.addEventListener("scroll", resetInactivityTime);
                window.addEventListener("click", resetInactivityTime);

    
            function resetInactivityTime() {
                inactivityTime = 0;
            }
    
            function startCheckInactivity() {
                DFI.checkInactivity = setInterval(function() {
    
                    ++inactivityTime;
                    if (inactivityTime >= maxInactivity) {
                        //userInactive.resolve();
                        resetInactivityTime();
                        if(DFI.ModalView !== undefined){
                            DFI.ModalView.open();
                            if(typeof statusDFI !="object"){
                                window.statusDFI={};
                            }
                            statusDFI.inactivityTriggered =true;
                        }
                        clearInterval(DFI.checkInactivity);
                    }
                }, 1000);
            }
        }

    };


    /*
    |---------------------------------------------------------------------------
    | Detectar cuando el Dom este cargado.
    |---------------------------------------------------------------------------
    */
    DFI.domReady = function(fn) {
        if (document.readyState === 'loaded' || document.readyState === 'complete') {
            fn();
        } else if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            document.attachEvent('onreadystatechange', function() {
                if (document.readyState === 'loaded' || document.readyState === 'complete')
                    fn();
            });
        }
    };



    /*
    |---------------------------------------------------------------------------
    | RingPoolidService
    |---------------------------------------------------------------------------
    */
    DFI.ringPoolIdService = function(conditions, visitObject) {
        // Si se encuentran todas las condiciones la prioridad es: peso o nick en una url, texto en una url, Etiqueta de visita
        //DFI.DFI_configuration.ringPoolidServiceConditions
        //	  DFI.DFI_configuration.ringPoolidServiceConditions.ringPoolidServiceConditions:{
        //		 v_var:{v_var_1,"vuelo"},
        //		 url:"carrefour.com",
        //		 nick:{"precio":"55"},
        //		  
        //	  }	
        obj[Object.keys(obj)[0]]
        if (DFI.DFI_configuration.ringPoolidServiceConditions.ringPoolidServiceConditions.v_var[Object.keys(DFI.DFI_configuration.ringPoolidServiceConditions.ringPoolidServiceConditions.v_var)[0]] === true) {


        }

        // Devuelve True o false

    };


    function mobileAndTabletcheck() {
        var check = false;
        (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
        })(navigator.userAgent || navigator.vendor || window.opera);

        if (window.matchMedia("(orientation: portrait)").matches) {
            DFI.consoleLogDelio("portrait");
            if (screen.width > 767) {
                DFI.consoleLogDelio("tablet");
                check = false;
            }
        }

        if (window.matchMedia("(orientation: landscape)").matches) {
            DFI.consoleLogDelio("landscape");
            if (screen.height > 767) {
                DFI.consoleLogDelio("tablet");
                check = false;
            }


        }



        return check;
    }

    /*
    |---------------------------------------------------------------------------
    | Get Site -- Visita y conversion
    |---------------------------------------------------------------------------
    */
    DFI.getSite = function() {
        var url = document.location.href.toString();
        return url;
    };


    DFI.logger = function(message) {

        if (DFI.debugger) {
            DFI.consoleLogDelio('[site] ' + message);
        }
    };


    DFI.getCookie = function(name) {
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) return match[1];
    };


    // Escoger variante de Landing
    // Cambiar porcentaje de control de 0 a 100 para distribuir el trÃ¡fico entre las variantes

    /*
    |---------------------------------------------------------------------------
    | Quitar duplicados en un array
    |---------------------------------------------------------------------------
    */


    DFI.uniq = function(a) {
        var prims = {
                "boolean": {},
                "number": {},
                "string": {}
            },
            objs = [];

        return a.filter(function(item) {
            var type = typeof item;
            if (type in prims)
                return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
            else
                return objs.indexOf(item) >= 0 ? false : objs.push(item);
        });
    }

    /*
    |---------------------------------------------------------------------------
    | Busca texto en array de sesión 
    |---------------------------------------------------------------------------
    */

    DFI.buscarTexto = function(condicion) {
        var correcto = false;
        for (var i = 0, len = DFI.sessionData.url.length; i < len; i++) {

            if (DFI.sessionData.url[i].indexOf(condicion) >= 0) {
                correcto = true;

            }
        }

        return correcto;
    }
    /*
     |---------------------------------------------------------------------------
     | Busca texto en array de sesión en la urls  configurable: ultima, penultima
     |---------------------------------------------------------------------------
     */

    DFI.buscarTextoUltimo = function(condicion, session) {
        var inicio = 0;
        let ultimo = DFI.sessionData.url.length - 1;

        if (session === "ultima") {
            inicio = DFI.sessionData.url.length - 1;
            ultimo = DFI.sessionData.url.length;
        }

        if (DFI.sessionData.url.length === 1) {
            inicio = 0;
            ultimo = DFI.sessionData.url.length;
        }


        var correcto = false;
        for (var i = inicio, len = ultimo; i < len; i++) {

            if (DFI.sessionData.url[i].indexOf(condicion) >= 0) {
                correcto = true;

            }
        }

        return correcto;
    }



    /*
    |---------------------------------------------------------------------------
    | Busca etiqueta de visita en array de sesión en las
    |---------------------------------------------------------------------------
    */

    DFI.buscarvisitTracking = function(condicionVisit, conditionVisitValue) {
        var correcto = false;
        if (conditionVisitValue !== undefined && conditionVisitValue !== "undefined") {
            for (var i = 0, len = DFI.sessionData.visitLabel.length; i < len; i++) {

                if (DFI.sessionData.visitLabel[i][condicionVisit] === conditionVisitValue) {
                    correcto = true;

                }
            }
        }

        return correcto;
    }

    /*
    |---------------------------------------------------------------------------
    | Busca etiqueta UTM en la sessión 
    |---------------------------------------------------------------------------
    */

    DFI.buscarUtmTracking = function(condicionUtm, conditionUTMValue) {
        var correcto = false;
        for (var i = 0, len = DFI.sessionData.url.length; i < len; i++) {

            if (DFI.sessionData.url[i].indexOf(condicionUtm) >= 0 && DFI.sessionData.url[i].indexOf(conditionUTMValue) >= 0) {
                correcto = true;

            }
        }

        return correcto;
    }

    /*
    |---------------------------------------------------------------------------
    | Busca etiqueta  UTM en la sessión  configurable: ultima, penultima
    |---------------------------------------------------------------------------
    */
    DFI.buscarUtmTrackingUltimo = function(condicionUtm, conditionUTMValue, session) {
        var inicio = 0;
        let ultimo = DFI.sessionData.url.length - 1;

        if (session === "ultima") {
            inicio = DFI.sessionData.url.length - 1;
            ultimo = DFI.sessionData.url.length;
        }

        if (DFI.sessionData.url.length === 1) {
            inicio = 0;
            ultimo = DFI.sessionData.url.length;
        }

        var correcto = false;
        for (var i = inicio, len = ultimo; i < len; i++) {

            if (DFI.sessionData.url[i].indexOf(condicionUtm) >= 0 && DFI.sessionData.url[i].indexOf(conditionUTMValue) >= 0) {
                correcto = true;

            }
        }

        return correcto;
    }

    /*
    |---------------------------------------------------------------------------
    | Añadimos un lead en Delio sin la librería Delio Client
    |---------------------------------------------------------------------------
    */
    DFI.addLead = function(json, fn) {
        //debugger;
        var declaratives = DFI.labels.EDeclaratives;
        var conversion = DFI.labels.EConversion;

        DFI.form = {};
        DFI.form.submitted = false;

        var ws = DFI.global.provision + "wsclient/client_addlead.html";

        var eConversions = [];

        for (let property in conversion) {
            var indice = property.replace("c_var_", "");
            eConversions.push({
                "id": +indice,
                "value": conversion[property]
            });
            window[property] = conversion[property];
        }
        var encode = encodeURIComponent(JSON.stringify(eConversions));
        

        ws += '?'
        ws += 'format=json';
        ws += '&idTag=' + DFI.idTagDelio;
        ws += '&idlead=' + DFI.getLeadId();
        if(DFI.setVerifyLeadid != "SI"){
            ws += '&verifyLeadId=NO';
        }
        
        for (var key in json) {
            if (json[key] !== null && json[key] !== "null" && json[key] !== "") {
                ws += '&' + key + '=' + json[key];
                if(window.DFI.DFI_configuration.services.userForm != undefined 
                    && window.DFI.DFI_configuration.services.userForm.formPhoneName === key 
                    && window.DFI.DFI_configuration.services.userForm.formPhoneName != "telefono"){
                    ws += '&' + 'telefono' + '=' + json[key];
                }
            }
        }

        for (var key in declaratives) {

            ws += '&' + key + '=' + declaratives[key];
        }

        ws += '&EConversion=' + encode;

        var params = {
            url: ws,
            type: 'jsonp',
        };

        window.DAL.Ajax(params).done(function(data) {
            DFI.form.submitted = true;
            if (data.result === 'OK') {
                DFI.form.result = true;
                DFI.loadConversion(data.leadId);

                if (fn) {
                    fn(data);
                }

            } else if (fn) {
                DFI.form.result = false;
                fn(data);
            }

        });

    };


    /*
    |---------------------------------------------------------------------------
	| 
	|DFI.whoInterfere: indica si la interferencia por parte de Delio es completa (Validación y anula la validación del cliente, 
	| o se da de alta el lead en Delio o con la validación del cliente.
	| Esta función sustituye a DFI.addDelioClientToForms en mobileb.js y en desktop.b.js
	| De esta forma solo habría que modificar esta función ante fuuros cambiios de lógica.
	| Ante futuros cambios en el objeto de entrada, puede verse afectado DFI.setShowRulesScoring(), cuyo resultado tiene que estar disponible en DFI.resultShowRules
	| 
    |---------------------------------------------------------------------------
    */

    DFI.whoInterfere = function() {
        //DFI.resultShowRules.whoValidate
        //whoValidate = 1   DelioClient// whoValidate = 2 el cliente
        //DFI.resultShowRules.interfereButtonsWithClass
        //DFI.resultShowRules.fieldsMandatory 
        if (DFI.resultShowRules.whoValidate === undefined || DFI.resultShowRules.whoValidate === 1) {
            if (DFI.resultShowRules.interfereButtonsWithClass === undefined || DFI.resultShowRules.interfereButtonsWithClass === "" || DFI.resultShowRules.interfereButtonsWithClass === null) {
                DFI.addDelioClientToForms();
            } else {
                var formsToInterfereByClassButton = document.querySelectorAll(DFI.resultShowRules.interfereButtonsWithClass);
                statusDFI.addDelioClientToFormsTotalElements = formsToInterfereByClassButton.length
                for (var i = 0, len = formsToInterfereByClassButton.length; i < len; i++) {
                    statusDFI.addDelioClientToFormsActualElement = i;
                    DFI.addDelioClientToForms(DFI.getparentFormFromSubmitButton(formsToInterfereByClassButton[i]));
                }
            }

        } else {
            // idFormButtons = document.querySelector("#edit-button--8 button");
            // idFormButtons = document.querySelectorAll(".btn.btn-primary.form-submit");
            let idFormButtons = document.querySelectorAll(DFI.resultShowRules.interfereButtonsWithClass);
            DFI.addEventToFormsWithoutValidation(DFI.resultShowRules.fieldsMandatory, idFormButtons)
        }

        return true;

    }



    // Fin whoInterfere

    //Add forms to DelioCliente	

    DFI.addDelioClientToForms = function(idForm) {


        // dataValidation, es un objeto con la siguiente estructura:
        //dataValidation = {name1: true || false, name1: true || false,}
        //siendo name1.... namen: el name del input
        //true: data-wg-validation ="required"
        //false: No se añade data-wg-validation
        // De momento no se tiene en cuenta la validación, se presumen que la tiene en cuenta el usuario
        //
        if (statusDFI.addDelioClientToForms !== true ) {
            if(statusDFI.addDelioClientToFormsTotalElements - 1 === statusDFI.addDelioClientToFormsActualElement ){
                statusDFI.addDelioClientToForms = true;
            }
            

            //Esta parte hay que cambiarla para la multimodal cuando pueda haber varias personalizadas tipo dmv
            if(document.getElementById("dmv-form") !== null){
                updateFormVars(document.getElementById("dmv-form"));
            }

            var formNum = [];
            if (typeof idForm !== "undefined" && idForm !== "") {
                formNum.push(idForm);
            } else {
                formNum = document.querySelectorAll("form");
            }

            for (var i = 0, len = formNum.length; i < len; i++) {
                if (formNum[i].id !== "dmv-form") {
                    //Anular eventos formularios
                    if (statusDFI.removeEventsForm !== false  
                        && (typeof DFI_client === "object" && DFI_client.removeEventsForm != false)) {
                        formNum[i].innerHTML = formNum[i].innerHTML;
                    }

                    formNum[i].className += " wg-form"
                    addWgInput(formNum[i]);
                    addWgSubmit(formNum[i]);
                    updateFormVars(formNum[i]);
                } else {
                    updateFormVars(formNum[i]);
                }

            }
            //Añadimos mandatorios a campos

            if (DFI.DFI_configuration.services.hasOwnProperty("userForm")) {
                // telefono y cambio del name
                if (DFI.DFI_configuration.services.userForm.hasOwnProperty("formPhoneName") && DFI.DFI_configuration.services.userForm.formPhoneName) {
                    var telefonoVarOcirrencia = document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName);
                    for (var i = 0, len = telefonoVarOcirrencia.length; i < len; i++) {
                        document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName)[i].setAttribute("data-wg-validation", "required,phone");
                        //document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName)[i].setAttribute("name", "telefono");
                    }
                    var inputElems = document.getElementsByTagName("input");
                    for (var i = inputElems.length - 1; i >= 0; --i) {
                        var elem = inputElems[i];
                        if (elem.name == DFI.DFI_configuration.services.userForm.formPhoneName && DFI.DFI_configuration.services.userForm.formPhoneName !== "") {
                            //Si DFI.DFI_configuration.services.userForm.formPhoneName !=="" se asigna el nuevo nombre. 
                            elem.name = "telefono";
                        }
                    }
                }

                // Condiciones particulares
                if (DFI.DFI_configuration.services.userForm.hasOwnProperty("formPolicyName")) {
                    var telefonoVarOcirrencia = document.getElementsByName(DFI.DFI_configuration.services.userForm.formPolicyName);
                    for (var i = 0, len = telefonoVarOcirrencia.length; i < len; i++) {
                        document.getElementsByName(DFI.DFI_configuration.services.userForm.formPolicyName)[i].setAttribute("data-wg-validation", "required");
                    }
                }
            }


        }

        function addWgInput(formIdentifier) {
            var searchEles = formIdentifier.getElementsByTagName('input');
            for (var i = 0; i < searchEles.length; i++) {
                searchEles[i].className += " wg-input";
            }

            var searchElesT = formIdentifier.getElementsByTagName('textarea');
            for (var i = 0; i < searchElesT.length; i++) {
                searchElesT[i].className += " wg-input";
            }


            // Añadimos tags hiddens
            if (DFI.setVerifyLeadid === undefined) {
                DFI.setVerifyLeadid = "NO";
            } else if (DFI.setVerifyLeadid !== "") {
                DFI.setVerifyLeadid = "NO";
            }

            //formIdentifier.innerHTML +='<input type="hidden" value="NO" name="verifyLeadId" class="wg-input">'; 
            DFI.addInputElement(formIdentifier, "", "verifyLeadId", "wg-input wg-newElement", DFI.setVerifyLeadid);
            //formIdentifier.innerHTML +='<input class="wg-return" type="hidden" value="DCL_success">';
            DFI.addInputElement(formIdentifier, "", "DCL_success", "wg-return wg-newElement", "DCL_success");
            //formIdentifier.innerHTML +='<input type="hidden" value="" name="c_var_1" class="wg-cvar">';
            // DFI.addInputElement(formIdentifier,"", "c_var_1", "wg-cvar","");		   
            //formIdentifier.innerHTML +='<input type="hidden" value="" name="c_var_2" class="wg-cvar">';
            // DFI.addInputElement(formIdentifier,"", "c_var_2", "wg-cvar","");	
            //formIdentifier.innerHTML +='<input type="hidden" value="" name="c_var_3" class="wg-cvar">';
            // DFI.addInputElement(formIdentifier,"", "c_var_3", "wg-cvar","");		   
            //formIdentifier.innerHTML +='<input type="hidden" value="" name="c_var_4" class="wg-cvar">';
            // DFI.addInputElement(formIdentifier,"", "c_var_4", "wg-cvar","");		   
            //formIdentifier.innerHTML +='<input id="" type="hidden" value="" name="service_call_assigned" class="wg-input wgIdService">';
            DFI.addInputElement(formIdentifier, "", "service_call_assigned", "wg-input wgIdService wg-newElement", "");
            //formIdentifier.innerHTML +='<input id="" type="hidden" value="" name="service_call_priority" class="wg-input wgIdService1">';	
            DFI.addInputElement(formIdentifier, "", "service_call_priority", "wg-input wgIdService1 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "service_call_ruleId", "wg-input wgIdService2 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "service_call_name", "wg-input wgIdService3 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idRule", "wg-input wgIdService4 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idOrder", "wg-input wgIdService5 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idDescription", "wg-input wgIdService6 wg-newElement", "");
            

        }

        function addWgSubmit(formIdentifier) {
            var searchEles = formIdentifier.getElementsByTagName('button');

            for (var i = 0; i < searchEles.length; i++) {
                if (searchEles[i].hasAttribute("type")) {
                    if (searchEles[i].getAttribute("type") === "submit") {
                        searchEles[i].className += " wg-submit";

                    }

                }

            }



        }

        function updateFormVars(formIdentifier) {

            var declaratives = DFI.labels.EDeclaratives;
            var conversion = DFI.labels.EConversion;
            var form = document.getElementById('dmv-form');
            var inputName;
            var inputValue;

            for (var i in declaratives) {
                inputName = i;
                inputValue = declaratives[i];
                DFI.addInputElement(formIdentifier, "", inputName, "wg-input wg-newElement ", inputValue);
            }

            for (var c in conversion) {
                inputName = c;
                inputValue = conversion[c];
                DFI.addInputElement(formIdentifier, "", inputName, "wg-cvar wg-newElement", inputValue);
            }

        };




        var tempWgIdentifier = document.querySelectorAll(".wgIdService");
        for (let index = 0; index < tempWgIdentifier.length; ++index) {
            tempWgIdentifier[index].value = DFI.servicioActivo1.serviceIdCallMeBack;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService1");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.priority;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService2");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.ruleId;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService3");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.serviceNameCallMeBack;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService4");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.idRule;
        }

        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService5");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.order;
        }

        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService6");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.description;
        }


    }

    //Actualiza etiquetado en una función creada después de la ejecución de delio 1 click y de que se haya seteado Delio client.
    //Tiene que tener la etiqueta wg-form y wg-
    DFI.updateFormAside = function(form) {

        var declaratives = DFI.labels.EDeclaratives;
        var conversion = DFI.labels.EConversion;
        if (form !== undefined && form !== null && form !== ""){
            var inputName;
            var inputValue;

            for (var i in declaratives) {
                inputName = i;
                inputValue = declaratives[i];

                DFI.deleteNameFromForm(inputName);

                form.innerHTML += "<input type='hidden' name='" + inputName + "' value='" + inputValue + "'>";
            }

            for (var c in conversion) {
                inputName = c;
                inputValue = conversion[c];
                DFI.deleteNameFromForm(inputName);
                form.innerHTML += "<input type='hidden'  class='wg-cvar'  name='" + inputName + "' value='" + inputValue + "'>";
            }

            //Añadimos etiquetado servicios de llamada

            //<input type="hidden" name="service_call_name" class="wg-input wgIdService2 wg-newElement" value="VERTI_RESTO_CallMe" style="visibility: hidden;">
            DFI.deleteNameFromForm("service_call_assigned");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside wg-newElement'  name='" + "service_call_assigned" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("service_call_priority");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside1 wg-newElement'  name='" + "service_call_priority" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("service_call_ruleId");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside3 wg-newElement'  name='" + "service_call_ruleId" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("service_call_name");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside3 wg-newElement'  name='" + "service_call_name" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("visual_idRule");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside4 wg-newElement'  name='" + "visual_idRule" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("visual_idOrder");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside5 wg-newElement'  name='" + "visual_idOrder" + "' value='" + '' + "'>";
            DFI.deleteNameFromForm("visual_idDescription");
            form.innerHTML += "<input type='hidden'  class='wg-input wgIdServiceAside6 wg-newElement'  name='" + "visual_idDescription" + "' value='" + '' + "'>";

            var tempWgIdentifier = document.querySelectorAll(".wgIdServiceAside");
            for (let index = 0; index < tempWgIdentifier.length; ++index) {
                tempWgIdentifier[index].value = window.DFI.servicioActivo1.serviceIdCallMeBack;
            }			
            var tempWgIdentifier1	 = document.querySelectorAll(".wgIdServiceAside1");
            for (let index = 0; index < tempWgIdentifier1.length; ++index) {
                tempWgIdentifier1[index].value = window.DFI.servicioActivo1.priority;
            }	
            var tempWgIdentifier1	 = document.querySelectorAll(".wgIdServiceAside2");
            for (let index = 0; index < tempWgIdentifier1.length; ++index) {
                tempWgIdentifier1[index].value = window.DFI.servicioActivo1.serviceNameCallMeBack;
            }	            

        }
        DCL.set.forms();
        DFI.addIdtagToFormsWhenNotRight()
        statusDFI.updateFormAside = true;

    };



    
    /*
    |---------------------------------------------------------------------------
	| Añadimos un array de botones que queremos monitorear sus cambios de estado
	| Cambio 02/07/2018: los botones a interferir se identifican con una clase. El parámetro de entrada es la clase.
	| Cuando se detecta un click en alguno de los botones de la lista se comprueba si están todos los campos requeridos
	| y si están los campos requeridos se da de alta el lead en Delio.
	| Como parámetro de entrada tenemos un array de objetos
	| Cada elemento del array de objetos es un objeto JSON con dos elementos
	| La primera propiedad identifica el boton, la segunda propiedad es a su vez un array que contiene los elementos que tiene que tener
	| ese formulario para que se de de alta.
	|idFormButtons,requiredParams son dos arrays, en una hay identificadores de botones y en la otra names de campos requeridos.
    |---------------------------------------------------------------------------
    */

    //    idFormButtonsAndRequiredParams =[
    // 		{
    // 		idFormButtons : '<button type="submit" id="edit-0--4" name="button" value="Enviar" class="btn btn-primary form-submit">Enviar</button>',
    // 		requiredParams: ['nombre','telefono','email','pais','codigopostal']
    // 		}

    // 	]


    DFI.addEventToFormsWithoutValidation = function(requiredParams, idFormButtons) {
        //(idFormButtons,requiredParams)
        //idFormButtons es un array con los identificadores de lo botones que tenemos que interferir.

        if (requiredParams === undefined) {
            var requiredParams = [];
        } else {
            requiredParams = requiredParams.split(",");
        }

        // Para probar en GP
        //requiredParams = ["nombre","telefono","email","codigopostal","avisolegal"]
        // fin para probar en GP

        if (idFormButtons === undefined) {
            var idFormButtons = [];
        }

        DFI.passiveForms = [];
        var eventButton;
        DFI.switchButton = false;

        //gestionamos todos los clicks con Capture en vez de Bubble en el document.
        document.addEventListener("click", ManageEventsForms, true);


        function ManageEventsForms() {
            //Solo actuamos si la acción es sobre un botón del formulario implicado
            if ((event.target.tagName === "BUTTON" || event.target.parentElement.tagName  === "BUTTON" || (event.target.type ==="submit" && event.target.tagName === "INPUT") ) && DFI.switchButton !== true) {
                for (var key in idFormButtons) {
                    if (((event.target.outerHTML === idFormButtons[key].outerHTML && event.target.tagName === "BUTTON" ) || (event.target.parentElement.outerHTML === idFormButtons[key].outerHTML && event.target.parentElement.tagName === "BUTTON" ))
                    || ((event.target.outerHTML === idFormButtons[key].outerHTML && event.target.tagName === "INPUT" && event.target.type ==="submit") || (event.target.parentElement.outerHTML === idFormButtons[key].outerHTML && event.target.parentElement.tagName === "INPUT" && event.target.type ==="submit"))) {
                        //alert(event.target.tagName + "   " +  DFI.switchButton+  "   OK");
                        event.preventDefault();
                        //alert("forzamos el click en el elemento");
                        eventButton = event.target;

                        //Ejecutamos el alta del lead

                        //Recogemos etiquetas declarativas del formulario partiendo del botón identifier.
                        var dataToSend = DFI.getElementsFromForm(DFI.getparentFormFromSubmitButton(eventButton));
                        dataToSend["service_call_assigned"] = DFI.servicioActivo1.serviceIdCallMeBack;
                        dataToSend["service_call_priority"] = DFI.servicioActivo1.priority;
                        dataToSend["service_call_name"] = DFI.servicioActivo1.serviceNameCallMeBack;
                        dataToSend["idLead"] = DFI.getLeadId();
                        dataToSend["visual_idRule"] = window.DFI.resultShowRules.idRule;
                        dataToSend["visual_idOrder"] = window.DFI.resultShowRules.order;
                        dataToSend["visual_idDescription"] = window.DFI.resultShowRules.description;

                        // Comprobamos que se encuentran todos los parámetros requeridos en requiredParams
                        var dataToCheck = requiredParams;

                        var doSend = true;

                        if(dataToSend["phone"] != undefined){
                            dataToSend["phone"] = dataToSend["phone"].replace(/\s/g,'');  
                        }

                        if(typeof DFI.personalized === "object" && typeof DFI.personalized.phoneRegex === "object" ){
                            var str = dataToSend["telefono"];
                            var patt = new RegExp(DFI.personalized.phoneRegex);
                            var res = patt.test(str);
                            if(!res){
                                dataToSend["telefono"] ="";
                            }
                        } else {
                            if(dataToSend["telefono"] != undefined){
                                dataToSend["telefono"] = dataToSend["telefono"].replace(/\s/g,'');  
                            }                          
                        }

                        for (i = 0; i < dataToCheck.length; i++) {
                            if (dataToSend[dataToCheck[i]] === ""
                            || dataToSend[dataToCheck[i]] === false
                            || dataToSend[dataToCheck[i]] === "false") {
                                doSend = false;
                            }
                        }

                        //Alta del lead
                        //debugger;
                        if (doSend && !DFI.switchButton) {
                            DFI.switchButton = true;
                            DFI.addLead(dataToSend, function() {

                                eventButton.click();
                                setTimeout(function() {
                                    DFI.switchButton = false;
                                }, 200);
                            });
                        }


                        //Fin del alta del lead



                    }
                }
            } else {
                //alert(event.target.tagName +  "   NOK");
            }

        }
    }


    DFI.getparentFormFromSubmitButton = function(IdSubmitButtonId) {
        //debugger;
        if (IdSubmitButtonId === undefined) {
            return undefined;
        }
        // Número de intentos que se permite a la función en buscar el parent form desde el botón donde se hace el submit
        var deepAllowed = 17;
        var elementDOM = IdSubmitButtonId;
        for (i = 0; i < deepAllowed; i++) {
            if (elementDOM !== null && elementDOM.parentElement !== null && elementDOM.parentElement.tagName === "FORM") {
                return elementDOM.parentElement;
            }
            if(elementDOM.parentElement !== null){
                elementDOM = elementDOM.parentElement;
            }
            
        }

        return undefined;

    }


    DFI.getElementsFromForm = function (IdForm) {
        //debugger;
        var outputElements = {};
        var elements = IdForm.getElementsByTagName("input");
        for (i = 0; i < elements.length; i++) {
            if (IdForm.getElementsByTagName("input")[i].getAttribute("name") !== null) {
                outputElements[IdForm.getElementsByTagName("input")[i].getAttribute("name")] = IdForm.getElementsByTagName("input")[i].value;
                if(IdForm.getElementsByTagName("input")[i].type === "checkbox"
                && IdForm.getElementsByTagName("input")[i].value === ""
                ){
                    outputElements[IdForm.getElementsByTagName("input")[i].getAttribute("name")] = IdForm.getElementsByTagName("input")[i].checked;
                }

            }

        }

        elements = IdForm.getElementsByTagName("select");
        for (i = 0; i < elements.length; i++) {

            if (IdForm.getElementsByTagName("select")[i].getAttribute("name") !== null) {
                outputElements[IdForm.getElementsByTagName("select")[i].getAttribute("name")] = IdForm.getElementsByTagName("select")[i].options[IdForm.getElementsByTagName("select")[i].selectedIndex].value;
            }
        }

        return outputElements;
    };


    DFI.addDelioClientToFormswithoutValidation = function(idForm, dataValidation) {
        // dataValidation, es un objeto con la siguiente estructura:
        //dataValidation = {name1: true || false, name1: true || false,}
        //siendo name1.... namen: el name del input
        //true: data-wg-validation ="required"
        //false: No se añade data-wg-validation
        // De momento no se tiene en cuenta la validación, se presumen que la tiene en cuenta el usuario
        //
        if (statusDFI.addDelioClientToForms !== true) {
            statusDFI.addDelioClientToForms = true

            if (idForm !== undefined && idForm !== "") {

                // document.getElementById(idForm).className ="wg-form"
                // addWgInput(document.getElementById(idForm));
                // addWgSubmit(document.getElementById(idForm));
                if (document.getElementById(idForm) !== null) {
                    if (document.getElementById(idForm) !== "dmv-form") {
                        //Anular eventos formularios
                        // if(statusDFI.removeEventsForm !== false){
                        // 	document.getElementById(idForm).innerHTML = document.getElementById(idForm).innerHTML;
                        // }

                        document.getElementById(idForm).className += " wg-form"
                        addWgInput(document.getElementById(idForm));
                        addWgSubmit(document.getElementById(idForm));
                        updateFormVars(document.getElementById(idForm));
                    } else {
                        updateFormVars(document.getElementById(idForm));
                    }
                }


            } else {

                var formNum = document.querySelectorAll("form");

                for (var i = 0, len = formNum.length; i < len; i++) {
                    if (document.querySelectorAll("form")[i].id !== "dmv-form") {
                        //Anular eventos formularios
                        // if(statusDFI.removeEventsForm !== false){
                        // 	document.querySelectorAll("form")[i].innerHTML = document.querySelectorAll("form")[i].innerHTML;
                        // }

                        document.querySelectorAll("form")[i].className += " wg-form"
                        addWgInput(document.querySelectorAll("form")[i]);
                        addWgSubmit(document.querySelectorAll("form")[i]);
                        updateFormVars(document.querySelectorAll("form")[i]);
                    } else {
                        updateFormVars(document.querySelectorAll("form")[i]);
                    }

                }
                //Añadimos mandatorios a campos

                if (DFI.DFI_configuration.services.hasOwnProperty("userForm")) {
                    // telefono y cambio del name
                    if (DFI.DFI_configuration.services.userForm.hasOwnProperty("formPhoneName") && DFI.DFI_configuration.services.userForm.formPhoneName) {
                        var telefonoVarOcirrencia = document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName);
                        for (var i = 0, len = telefonoVarOcirrencia.length; i < len; i++) {
                            document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName)[i].setAttribute("data-wg-validation", "required,phone");
                            //document.getElementsByName(DFI.DFI_configuration.services.userForm.formPhoneName)[i].setAttribute("name", "telefono");
                        }
                        var inputElems = document.getElementsByTagName("input");
                        for (var i = inputElems.length - 1; i >= 0; --i) {
                            var elem = inputElems[i];
                            if (elem.name == DFI.DFI_configuration.services.userForm.formPhoneName && DFI.DFI_configuration.services.userForm.formPhoneName !== "") {
                                //Si DFI.DFI_configuration.services.userForm.formPhoneName !=="" se asigna el nuevo nombre. 
                                elem.name = "telefono";
                            }
                        }
                    }

                    // Condiciones particulares
                    if (DFI.DFI_configuration.services.userForm.hasOwnProperty("formPolicyName")) {
                        var telefonoVarOcirrencia = document.getElementsByName(DFI.DFI_configuration.services.userForm.formPolicyName);
                        for (var i = 0, len = telefonoVarOcirrencia.length; i < len; i++) {
                            document.getElementsByName(DFI.DFI_configuration.services.userForm.formPolicyName)[i].setAttribute("data-wg-validation", "required");
                        }
                    }
                }
            }


        }

        function addWgInput(formIdentifier) {
            var searchEles = formIdentifier.getElementsByTagName('input');
            for (var i = 0; i < searchEles.length; i++) {
                searchEles[i].className += " wg-input";
            }

            var searchElesT = formIdentifier.getElementsByTagName('textarea');
            for (var i = 0; i < searchElesT.length; i++) {
                searchElesT[i].className += " wg-input";
            }


            // Añadimos tags hiddens
            if (DFI.setVerifyLeadid === undefined) {
                DFI.setVerifyLeadid = "NO";
            } else if (DFI.setVerifyLeadid !== "") {
                DFI.setVerifyLeadid = "NO";
            }

            DFI.addInputElement(formIdentifier, "", "verifyLeadId", "wg-input wg-newElement", DFI.setVerifyLeadid);
            DFI.addInputElement(formIdentifier, "", "DCL_success", "wg-return wg-newElement", "DCL_success");
            DFI.addInputElement(formIdentifier, "", "service_call_assigned", "wg-input wgIdService wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "service_call_priority", "wg-input wgIdService1 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "service_call_ruleId", "wg-input wgIdService2 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "service_call_name", "wg-input wgIdService3 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idRule", "wg-input wgIdService4 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idOrder", "wg-input wgIdService5 wg-newElement", "");
            DFI.addInputElement(formIdentifier, "", "visual_idDescription", "wg-input wgIdService6 wg-newElement", "");
        }

        function addWgSubmit(formIdentifier) {
            var searchEles = formIdentifier.getElementsByTagName('button');
            //debugger;
            DFI.submitsToClone = [];
            for (var i = 0; i < searchEles.length; i++) {
                if (searchEles[i].hasAttribute("type")) {
                    if (searchEles[i].getAttribute("type") === "submit") {
                        if (searchEles[i].style.display !== "none") {
                            var cloned_button = searchEles[i].cloneNode(true);
                            //searchEles[i].parentNode.insertBefore(cloned_button, searchEles[i].nextSibling);
                            DFI.submitsToClone.push({
                                "parent": searchEles[i],
                                "child": cloned_button
                            });
                        }
                    }
                }
            }

            for (var i = 0; i < submitsToClone.length; i++) {
                //debugger;
                DFI.submitsToClone[i].child.setAttribute('type', 'button');
                var newIdForElement = "newDelio_" + DFI.submitsToClone[i].child.id + "_" + Math.floor((Math.random() * 9999) + 1).toString();
                DFI.submitsToClone[i].child.id = newIdForElement;
                DFI.submitsToClone[i].parent.style.display = "none!important";
                DFI.submitsToClone[i].parent.parentNode.insertBefore(cloned_button, submitsToClone[i].child.nextSibling);
                var temp = document.getElementById(newIdForElement);

                if (temp === null) {
                    alert(newIdForElement);
                } else {
                    DFI.submitsToClone[i].child.id.addEventListener("click", function() {
                        alert("Viva la vida");
                        DFI.submitsToClone[i].parent.click();
                    });
                }
            }
        }

        function updateFormVars(formIdentifier) {

            var declaratives = DFI.labels.EDeclaratives;
            var conversion = DFI.labels.EConversion;
            var form = document.getElementById('dmv-form');
            var inputName;
            var inputValue;

            for (var i in declaratives) {
                inputName = i;
                inputValue = declaratives[i];
                DFI.addInputElement(formIdentifier, "", inputName, "wg-input wg-newElement ", inputValue);
            }

            for (var c in conversion) {
                inputName = c;
                inputValue = conversion[c];
                DFI.addInputElement(formIdentifier, "", inputName, "wg-cvar wg-newElement", inputValue);
            }

        };




        var tempWgIdentifier = document.querySelectorAll(".wgIdService");
        for (let index = 0; index < tempWgIdentifier.length; ++index) {
            tempWgIdentifier[index].value = DFI.servicioActivo1.serviceIdCallMeBack;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService1");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.priority;
        }

        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService2");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.ruleId;
        }

        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService3");
        for (let index = 0; index < tempWgIdentifier1.length; ++index) {
            tempWgIdentifier1[index].value = DFI.servicioActivo1.serviceNameCallMeBack;
        }
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService4");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.idRule;
        }	
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService5");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.order;
        }	
        var tempWgIdentifier1 = document.querySelectorAll(".wgIdService6");
        for (var _index2 = 0; _index2 < tempWgIdentifier1.length; ++_index2) {
            tempWgIdentifier1[_index2].value = window.DFI.resultShowRules.description;
        }	
    }

    DFI.assignPhoneRingClass = function() {

        var els = document.getElementsByTagName("a");

        for (var i = 0, _len = els.length; i < _len; i++) {
            var el = els[i]

            if (el.hasAttribute("href")) {
                if (el.getAttribute("href").indexOf("tel:") > -1) {

                    el.className += " wal-drp-phone"


                }
            }
        }
    }

    DFI.buildMaskString = function(string, mask) {
        mask = mask || "##########################################################################################################";
        var formatedString = ""
          , lastPosition = 0
          , pattern = mask.split(" ");
        for (var index in pattern)
            formatedString += string.substr(lastPosition, pattern[index].length) + " ",
            lastPosition += pattern[index].length;
        return formatedString = formatedString.replace(/\s+$/gi, "")
    } 

    DFI.convArrToObj = function(array) {
        var thisEleObj = new Object();
        if (typeof array == "object") {
            for (var i in array) {
                var thisEle = DFI.convArrToObj(array[i]);
                thisEleObj[i] = thisEle;
            }
        } else {
            thisEleObj = array;
        }
        return thisEleObj;
    };
    var oldJSONStringify = JSON.stringify;
    var JSONstringify = function(input) {
        if (oldJSONStringify(input) == '[]')
            return oldJSONStringify(DFI.convArrToObj(input));
        else
            return oldJSONStringify(input);
    };

    DFI.elegirVariante = function(porcentajeControl) {
        var varAB;
        var porcentajeControlA = porcentajeControl[0];
        var porcentajeControlB = porcentajeControl[0] + porcentajeControl[1];
        var porcentajeControlC = porcentajeControl[0] + porcentajeControl[1] + porcentajeControl[2];

        var porcentaje = Math.random() * 100;
        //alert(porcentaje);
        if (porcentajeControlA >= porcentaje) {
            varAB = "a";

        } else if (porcentajeControlB >= porcentaje) {

            varAB = "b";
        } else if (porcentajeControlC >= porcentaje) {

            varAB = "c";
        } else {

            varAB = "d";
        }
        return varAB;
    }

    // Comprobamos si un string tiene estructura JSON

    DFI.IsJsonString = function(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    DFI.addIdleadAllForm = function(idLead) {
        if (idLead !== undefined && idLead !== "undefined") {
            if (document.getElementsByTagName("form").length > 0) {
                for (var i = 0, len = document.getElementsByTagName("form").length; i < len; i++) {

                    var formIdentifier = document.getElementsByTagName("form")[i];
                    var lista = document.createElement('input');
                    lista.className = "wg-input";
                    lista.style.display = "none!important";
                    lista.value = idLead;
                    lista.name = "idLead"
                    formIdentifier.appendChild(lista);

                }
            }
            // else{
            // 	//landings sin tag form
            // 	//Botón llamar id="btnLlamar"
            // 	var lista = document.createElement('input');    
            // 	lista.className = "wg-input";
            // 	lista.style.display="none";
            // 	lista.value = idLead;
            // 	lista.name = "idLead"

            // 	var botonSubmit = document.getElementById("btnLlamar");  
            // 	botonSubmit.parentNode.insertBefore(lista, botonSubmit); 


            // }

        }

    }

    DFI.addInputElement = function(formIdentifier, idTag, nameTag, classTag, valueTag) {
        var f = formIdentifier;
        DFI.consoleLogDelio(f);
        var newPortabilidad = document.createElement("input");
        if (idTag != "") {
            newPortabilidad.id = idTag;
        }
        newPortabilidad.style.visibility = "hidden";
        newPortabilidad.type = "hidden";
        if (nameTag != "") {
            newPortabilidad.name = nameTag;
        }
        if (classTag != "") {
            newPortabilidad.className = classTag;
        }
        if (valueTag != "") {
            newPortabilidad.value = valueTag;
        }

        f.appendChild(newPortabilidad);


    }

    // Geocode desde Ip
    DFI.whereAreYouFrom = function() {
        if (statusDFI.location === undefined) {
            statusDFI.location = {};
        }
        var regionName = window.DAL.Ajax({
            type: "jsonp",
            url: 'https://pro.ip-api.com/json/?key=uGRNv2pc4vPwI87',
        }).done(function(data) {
 
            if (data.hasOwnProperty('country')) {
                statusDFI.location.country = data.country;
            } else {
                statusDFI.location.country = "";
            }
            if (data.hasOwnProperty('regionName')) {
                statusDFI.location.region = data.regionName;
            } else {
                statusDFI.location.region = "";
            }
            if (data.hasOwnProperty('zip')) {
                statusDFI.location.zip = data.zip;
            } else {
                statusDFI.location.zip = "";
            }
            if (data.hasOwnProperty('query')) {
                statusDFI.location.ipAddress = data.query;
            } else {
                statusDFI.location.ipAddress = "";
            }
            if (data.hasOwnProperty('isp')) {
                statusDFI.location.isp = data.isp;
            } else {
                statusDFI.location.isp = "";
            }

            if (data.hasOwnProperty('lat')) {
                statusDFI.location.lat = data.lat;
            } else {
                statusDFI.location.lat = "";
            }

            if (data.hasOwnProperty('lon')) {
                statusDFI.location.lon = data.lon;
            } else {
                statusDFI.location.lon = "";
            }



            if (statusDFI.location.hasOwnProperty('country')) {
                DFI.labels.EDeclaratives.country = statusDFI.location.country;
                statusDFI.location.country = statusDFI.location.country;
            } else {
                statusDFI.location.country= "";
            }
            if (statusDFI.location.hasOwnProperty('Region')) {
                DFI.labels.EDeclaratives.Region = statusDFI.location.region;
                statusDFI.location.Region = statusDFI.location.region;
            } else {
                statusDFI.location.Region = "";
            }
            if (statusDFI.location.hasOwnProperty('zip')) {
                DFI.labels.EDeclaratives.zip = statusDFI.location.zip;
                statusDFI.location.zip = statusDFI.location.zip;
            } else {
                statusDFI.location.zip = "";
            }
            if (statusDFI.location.hasOwnProperty('isp')) {
                DFI.labels.EDeclaratives.isp = statusDFI.location.isp;
                statusDFI.location.isp = statusDFI.location.isp;
            } else {
                statusDFI.location.isp = "";
            }
            if (statusDFI.location.hasOwnProperty('ipAddress')) {
                DFI.labels.EDeclaratives.IP_address = statusDFI.location.ipAddress;
                statusDFI.location.ipAddress = statusDFI.location.ipAddress;
            } else {
                statusDFI.location.ipAddress = "";
            }
            if (statusDFI.location.hasOwnProperty('ilat')) {
                DFI.labels.EDeclaratives.lat = statusDFI.location.lat;
                statusDFI.location.lat = statusDFI.location.lat;
            } else {
                statusDFI.location.lat = "";
            }
            if (statusDFI.location.hasOwnProperty('lon')) {
                DFI.labels.EDeclaratives.lon = statusDFI.location.lon;
                statusDFI.location.lon = statusDFI.location.lon;
            } else {
                statusDFI.location.lon = "";
            }

            statusDFI.location.completed = true;
            return statusDFI.location;

        });


        

    };

    DFI.operatorHistory = function(phone) {
        DFI.global.operatorHistory = 'https://t.womtp.com/slider/d/delio-lm/ws/people-call.php?phone=' + phone;
        if (phone) {
            if (statusDFI.operatorHistory === undefined) {
                statusDFI.operatorHistory = {};
            }
            DFI.loadScript(DFI.global.dal, function() {

                var regionName = window.DAL.Ajax({
                    type: "jsonp",
                    url: DFI.global.operatorHistory,
                }).done(function(data) {
                    var output = data;
                    if (output.hasOwnProperty('originalOperator')) {
                        statusDFI.operatorHistory.originalOperator = output.originalOperator;
                    } else {
                        statusDFI.operatorHistory.originalOperator = "";
                    }

                    if (output.hasOwnProperty('currentOperator')) {
                        statusDFI.operatorHistory.currentOperator = output.currentOperator;
                    } else {
                        statusDFI.operatorHistory.currentOperator = "";
                    }

                    if (output.hasOwnProperty('number')) {
                        statusDFI.operatorHistory.number = output.number;
                    } else {
                        statusDFI.operatorHistory.number = "";
                    }
                    if (output.hasOwnProperty('typeDescription')) {
                        statusDFI.operatorHistory.typeDescription = output.typeDescription;
                    } else {
                        statusDFI.operatorHistory.typeDescription = "";
                    }
                    if (output.hasOwnProperty('lastPortability')) {
                        if (output.lastPortability.hasOwnProperty('when')) {
                            statusDFI.operatorHistory.lastPortabilityWhen = output.lastPortability.when;
                        }
                        if (output.lastPortability.hasOwnProperty('from')) {
                            statusDFI.operatorHistory.lastPortabilityFrom = output.lastPortability.from;
                        }
                        if (output.lastPortability.hasOwnProperty('to')) {
                            statusDFI.operatorHistory.lastPortabilityTo = output.lastPortability.to;
                        }

                    } else {
                        statusDFI.operatorHistory.lastPortabilityWhen = "";
                        statusDFI.operatorHistory.lastPortabilityFrom = "";
                        statusDFI.operatorHistory.lastPortabilityTo = "";
                    }


                    DFI.consoleLogDelio(JSON.stringify(statusDFI.operatorHistory));
                    return statusDFI.operatorHistory;
                });

            });
        }


    }


    DFI.getMapCoord = function(ip) {
        if (!window.statusDFI.dataJson[ip]) {
            window.statusDFI.dataJson[ip] = {
                "ip": ip
            };

            var coordWs = "https://https-api.apigurus.com/iplocation/v1.8/locateip?key=SAK89R7297783RD3R63Z&ip=" + ip + "&format=JSON";
            var coord =
                DAL.Ajax({
                    type: "jsonp",
                    url: coordWs,
                }).done(function(data) {
                    if (data.query_status.query_status_code === "OK") {
                        statusDFI.dataJson[ip].latitude = data.geolocation_data.latitude;
                        statusDFI.dataJson[ip].longitude = data.geolocation_data.longitude;
                        statusDFI.getCompletedAddress(ip, data.geolocation_data.latitude, data.geolocation_data.longitude);
                    } else {
                        return false;
                    }
                });

        }

    }

    DFI.getCompletedAddress = function(ip, lat, long) {
        var gmapsWs = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + long + "&sensor=false&key=AIzaSyBRuqGae-KsoLWGtgqN5122l-3Ge2vJdJk";
        DAL.Ajax({
            type: "jsonp",
            url: gmapsWs,
        }).done(function(newData) {
            if (newData.status === "OK") {
                DFI.dataJson[ip].address = newData.results[0].formatted_address;
            } else {
                return false;
            }
        });
    }

    // Fin  Geocode desde Ip
    DFI.chatConfiguration = function() {
        DFI.Chat_config = {
            apiKey: DFI.DFI_configuration.services.serviceList.webChat.chatApiKey,
            idService: DFI.DFI_configuration.services.serviceList.webChat.chatIdservice,
            //idtag de LHT
            idTag: DFI.DFI_configuration.idTagDelioClient,
            env: DFI.global.chatEnviroment,
            labels: {
                "EDeclaratives": {
                    url: location.href,
                    web: document.title,
                    phone: +(new Date())
                },
            },
            v_vars: {
                chat: DFI.DFI_configuration.services.serviceList.webChat.visitVarChatUsage,
                chatAppears: DFI.DFI_configuration.services.serviceList.webChat.visitVarChatUsage,
            }
        };


        //Correccción temporal del teléfono del chat
        var setDefaultRingPool = false;
        var counterRingPoolChat = 0;
        var RingPoolChatCompleted = setInterval(function() {

            if (document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text").length > 0 && !setDefaultRingPool) {
                if (DFI.getInterfaceMode() === "mobile") {

                    document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text")[0].innerHTML = "Llámamos"

                } else {
                    document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text")[0].innerHTML = DFI.servicioActivo1.phoneCallCenterRingPool.replace(/^(\d{2})(\d{3})(\d{2})(\d{2}).*/, '$1 $2 $3 $4');
                }
                document.getElementsByClassName("SIO-Chat-Plus-Options__Btn")[0].setAttribute("href", "tel:" + DFI.servicioActivo1.phoneCallCenterRingPool)
                setDefaultRingPool = true;
            }

            counterRingPoolChat++;

            if (counterRingPoolChat > 20 || DFI.ringPoolCompleted) {
                if (document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text").length > 0 && setDefaultRingPool) {
                    if (DFI.getInterfaceMode() === "mobile") {

                        document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text")[0].innerHTML = "Llámamos"

                    } else if (DFI.Chat_configRingPoolActivo !== undefined) {
                        document.getElementsByClassName("SIO-Chat-Plus-Options__Btn__Text")[0].innerHTML = DFI.Chat_configRingPoolActivo.replace(/^(\d{2})(\d{3})(\d{2})(\d{2}).*/, '$1 $2 $3 $4');
                    }
                    document.getElementsByClassName("SIO-Chat-Plus-Options__Btn")[0].setAttribute("href", "tel:" + DFI.Chat_configRingPoolActivo);
                }
                clearInterval(RingPoolChatCompleted);
            }



        }, 250);



    };

    // Función para personalizar el DSA

    DFI.personalizedDSA = function(personalizedHtmlCode, positionX, positionY, factor, animated, optionalId, position) {
        //dsa-close
        if (position === "undefined" || position === undefined) {
            position = "bottom";
        }

        if (document.getElementById("dsa") !== null) {
            document.getElementById("dsa").remove();
        }


        window.SmartAccess = new DSA({
            dsaMessage: {
                text: '',
                position: position
            },
            dsaImage: DFI.DFI_configuration.DSAs.dsaImage,
            closeImage: DFI.DFI_configuration.DSAs.dsaClose,
            position: {
                x: positionX,
                y: positionY,
                factor: factor,
            },
            onclick: function() {

                if(DFI.ModalView !== undefined){
                    DFI.ModalView.open();
                }
            }
        });


        if (animated === false) {
            DSA.prototype.move = function(factor) {
                this.el.style[position] = positionY;
            }
        } else {
            DSA.prototype.move = function(factor) {
                var posOption, posY, height = DFI.windowSize("height"),
                    width = DFI.windowSize("width");
                posOption = 0 != factor && width / height > 1 ? height - height * (factor + .2) : height - height * factor,
                    posY = posOption - this.el.offsetHeight / 2 + DFI.windowScroll("y"),
                    this.el.style.top = posY + "px"
            }
        }


        var listenerIdForm = "dsa-image";
        if (optionalId !== undefined) {
            listenerIdForm = optionalId;
        }

        if(personalizedHtmlCode !== "" && personalizedHtmlCode !== undefined){
            var createdDSA = setInterval(function() {

                if (document.getElementById("dsa") !== null) {
                    clearInterval(createdDSA);
                    if (document.getElementById("dsa-close") !== null) {
                        document.getElementById("dsa-close").remove();
                    }
    
                    var idDSAtoModify = document.getElementById("dsa");
                    var f = document.getElementById("dsa");
                    var newPersonalizedDSA = document.createElement("div");
                    newPersonalizedDSA.id = "dsa-newId";
                    newPersonalizedDSA.innerHTML += (personalizedHtmlCode);
    
                    f.appendChild(newPersonalizedDSA);
                    document.getElementById("dsa-image").style.display = "none";
    
                    //newPersonalizedDSA.appendChild(newPersonalizedDSA);
    
                    if (listenerIdForm === "dsa-image") {
                        newPersonalizedDSA.addEventListener("click", function() {
                            document.getElementById(listenerIdForm).click();
                        });
                    } else {
                        if(document.getElementById(listenerIdForm) !== null){
                            document.getElementById(listenerIdForm).addEventListener("click", function() {
                                if(DFI.ModalView !== undefined){
                                    DFI.ModalView.open();
                                }
                            });
                        } else{
                            // Clase para levantar la modal .dModalForm
                            var btnsModalForm = document.querySelectorAll('.dModalForm');

                            for (var i = 0; i < btnsModalForm.length; i++) {
                                btnsModalForm[i].addEventListener('click', DFI.ModalView.open, false);
                            } 
                        }

                    }
    
                    statusDFI.createdDSA = true;
                }

    
            }, 66);
        }


        //DFI.checkCreationElement();

    }

    //Tamaño ventana

    DFI.windowSize = function(property) {
        var size = {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };
        return size[property];
    }

    DFI.windowScroll = function(axis) {
        var scroll = {
            x: window.scrollX || window.pageXOffset || document.body.scrollLeft,
            y: window.scrollY || window.pageYOffset || document.body.scrollTop
        };
        return scroll[axis]
    }

    //check if an element exist
    DFI.checkCreationElement = function(personalizedHtmlCode) {
        if (document.getElementById("dsa") !== null) {
            document.getElementById("dsa-close").remove();
            var idDSAtoModify = document.getElementById("dsa");
            var f = document.getElementById("dsa");
            var newPersonalizedDSA = document.createElement("div");
            newPersonalizedDSA.id = "dsa-newId";
            //debugger;	

            f.appendChild(newPersonalizedDSA);
            document.getElementById("dsa-image").style.display = "none";

            var newPersonalizedDSAhtml = document.innerHTML(personalizedHtmlCode);
            newPersonalizedDSA.appendChild(newPersonalizedDSAhtml);

            newPersonalizedDSA.addEventListener("click", function() {
                document.getElementById("dsa-image").click();
            });
            cancelAnimationFrame(globalID);

        } else {
            globalID = requestAnimationFrame(DFI.checkCreationElement);
        }

    };

    DFI.personalizedModal = function(personalizedHtmlCodeModal, personalizedHtmlCodeThankYouPage, personalizedHtmlCodeModalOutSchedule, personalizedHtmlCodeThankYouPageOutSchedule) {
        //Servicio de llamada
        //debugger;
        DFI.setRingPoolServicesNew();
        //Anulamos el flag de doble ejecución
        statusDFI.addDelioClientToForms = false;
        DFI.addDelioClientToForms("dmv-form");
        statusDFI.addDelioClientToForms = true;
        DCL.set.forms();
        DFI.addIdtagToFormsWhenNotRight();

    }


    // Añadir Un listener a un elementto, y ejecutar un call back cuando sucede.
    // Ej: addListenerNewElementId("dmv-cancel", funtionToExecute);

    DFI.addListenerNewElementId = function(Id, funtionToExecute) {
        if (document.getElementById(Id) !== null) {
            if (!document.getElementById(Id)) {
                window.requestAnimationFrame(addListenerNewElementId);
            } else {
                document.getElementById(Id).addEventListener("click", function() {
                    funtionToExecute()
                }, false);

            }
        }

    };


    //Object.defineProperty(statusDFI, "dynamicUpdate", DFI.dynamicFormUpdate());

    DFI.dynamicFormUpdate = function (formId) {
        // Borramos todos los elementos creados en los formularios.
        //Me cargo la parada por ahora 
        // if (typeof DRP !== "undefined") {
        //     DRP.stopRingPool();
        // }
        var paras = document.getElementsByClassName('wg-newElement');

        // if (formId !== undefined){
        // 	var formNum = formId	
        // } else{
        // 	var formNum = document.querySelectorAll("form");
        // }

        while (paras[0]) {
            //if(document.getElementById("wg-submit") !== paras[0]){
            paras[0].parentNode.removeChild(paras[0]);
            //}
        }

        var idFormTemp = document.getElementById("wg-form");
        if (document.getElementById("wg-submit") === null) {}

        //Ejecutamos funciones 
        DFI.setDataLayer();
        statusDFI.setDataLayer = true;
        DFI.setUtmsVars();
        statusDFI.setUtmsVars = true;
        if(typeof statusDFI.setTrackingVars === undefined){
            DFI.setTrackingVars();
        }
        statusDFI.setTrackingVars = true;
        DFI.setConversionsLabels();
        statusDFI.setConversionsLabel = true;
        DFI.setDeclaratives();
        statusDFI.setDeclaratives = true;

        statusDFI.addDelioClientToForms = false;
        //DFI.addDelioClientToForms();
        if (document.getElementById("dmv-form") !== null) {
            DFI.addDelioClientToForms(document.getElementById("dmv-form"));
            statusDFI.addDelioClientToForms = true;
        }
        //wg-form
        statusDFI.addDelioClientToForms = false;
        if (document.getElementsByClassName("wg-form").length > 0) {
            for (var i = 0; i < document.getElementsByClassName("wg-form").length; ++i) {
                DFI.addDelioClientToForms(document.getElementsByClassName("wg-form")[i]);
                statusDFI.addDelioClientToForms = false;
            }
        }

        statusDFI.addDelioClientToForms = false;
        if (document.getElementById("idFormAside") !== null) {
            DFI.addDelioClientToForms(document.getElementById("idFormAside"));
            statusDFI.addDelioClientToForms = true;
        }

        DFI.servicioActivo1 = DFI.setRingPoolServicesNew();
        statusDFI.callServicesLoaded = true;
        DFI.servicioActivo = DFI.servicioActivo1.serviceIdCallMeBack;
        DFI.servicioActivo2 = DFI.servicioActivo1.priority;
        DFI.servicioActivo3 = DFI.servicioActivo1.ruleId;
        DFI.servicioActivo4 = DFI.servicioActivo1.active;
        DFI.servicioPais = DFI.servicioActivo1.countryCallMeBack.toLowerCase();
        if (DFI.servicioActivo4 !== false && document.getElementById("idservice") !== null) {
            document.getElementById("idservice").value = DFI.servicioActivo1.serviceIdCallMeBack;
        } else {
            if (document.getElementById("idservice") !== null) {
                document.getElementById("idservice").value = "";
            }
        }

        if (document.getElementById("idservice1") !== null) {
            document.getElementById("idservice1").value = DFI.servicioActivo1.priority;
            document.getElementById("idservice2").value = DFI.servicioActivo1.ruleId;
            document.getElementById("idservice3").value = DFI.servicioActivo1.serviceNameCallMeBack;
        }

        //service_call_priority 
        for (var i = 0, len = document.getElementsByName("service_call_priority").length; i < len; i++) {
            document.getElementsByName("service_call_priority")[i].value = DFI.servicioActivo1.priority;
        }
 
        // service_call_ruleId
        for (var i = 0, len = document.getElementsByName("service_call_ruleId").length; i < len; i++) {
            document.getElementsByName("service_call_ruleId")[i].value = window.DFI.servicioActivo1.ruleId;
        }

        // service_call_name
        for (var i = 0, len = document.getElementsByName("service_call_name").length; i < len; i++) {
            document.getElementsByName("service_call_name")[i].value = DFI.servicioActivo1.serviceNameCallMeBack;
		}
		
		// visual_idRule
		for (var i = 0, len = document.getElementsByName("visual_idRule").length; i < len; i++) {
			document.getElementsByName("visual_idRule")[i].value = window.DFI.resultShowRules.idRule;
        }
 		// visual_idOrder
         for (var i = 0, len = document.getElementsByName("visual_idOrder").length; i < len; i++) {
			document.getElementsByName("visual_idOrder")[i].value = window.DFI.resultShowRules.order;
        }     
		// visual_idDescription
		for (var i = 0, len = document.getElementsByName("visual_idDescription").length; i < len; i++) {
			document.getElementsByName("visual_idDescription")[i].value = window.DFI.resultShowRules.description;
		}          

        //service_call_assigned
        for (var i = 0, len = document.getElementsByName("service_call_assigned").length; i < len; i++) {
            document.getElementsByName("service_call_assigned")[i].value = DFI.servicioActivo1.serviceIdCallMeBack;
        }
        if (typeof DRP !== "undefined") {
            DFI.refreshRingpool();
        }

        var CheckCreationDCL = setInterval(function () {
            if (statusDFI.DCLloaded === true) {

                DCL.set.forms();
                DFI.addIdtagToFormsWhenNotRight();

                clearInterval(CheckCreationDCL);
            }
        }, 100);
    };


    // Fin dynamic Update
    DFI.DCL_ready = function() {
        statusDFI.DCLloaded = true;
        DCL.set.forms();
        DFI.addIdtagToFormsWhenNotRight();
    }


    // Nos devuelve el tipo de una variable

    DFI.whatIsIt = function(object) {
        if (object === null) {
            return "null";
        } else if (object === undefined) {
            return "undefined";
        } else if (object.constructor === String) {
            return "String";
        } else if (object.constructor === Array) {
            return "Array";
        } else if (object.constructor === Object) {
            return "Object";
        } else if (object.constructor === Number) {
            return "Number";
        } else if (object.constructor === Array) {
            return "Array";
        } else {
            return "don't know";
        }
    }

    DFI.getUrlVar = function(variable, url) {
        var href = url || window.location.search;
        var i, pair;
        var query = href.split("?")[1];
        var vars = query ? query.split("&") : [];

        for (i = 0; i < vars.length; i++) {

            pair = vars[i].split("=");

            if (pair[0] == variable && pair[1] !== "")
                return pair[1];
        }

        return "";
    };

    DFI.loadScriptBefore = function(url, fn, docScope) {
        var doc = docScope || document;
        var head = doc.head || doc.getElementsByTagName("head")[0];
        var script = doc.createElement("script");
        script.src = url;
        script.type = "text/javascript";

        if (fn)
            script.addEventListener('load', fn);

        head.appendChild(script);
    };

    DFI.sleep = function(miliseconds) {
        var currentTime = new Date().getTime();

        while (currentTime + miliseconds >= new Date().getTime()) {}
    }

    // Función para setear el IdTag cuando DCL.set.forms() no lo hace. Es una incidencia a corregir en DCL
    DFI.addIdtagToFormsWhenNotRight = function(){
        //Chequeamos que se ha añadido el idTag.
        var idTagPurse = document.querySelectorAll(".wg-idTag");
        for(i = 0; i < idTagPurse.length; i++){
            if (idTagPurse[i].value ==="" || idTagPurse[i].value === "false") {
                idTagPurse[i].value = window.DFI.DFI_configuration.idTagDelioClient;
            }
        }
    }


    //Función para habilitar el watch
   DFI.objectObserver = function(){
    DFI.WatchJS = {
        noMore: false,        // use DFI.WatchJS.suspend(obj) instead
        useDirtyCheck: false // use only dirty checking to track changes.
    };
    
    var lengthsubjects = [];
    
    var dirtyChecklist = [];
    var pendingChanges = []; // used coalesce changes from defineProperty and __defineSetter__
    
    var supportDefineProperty = false;
    try {
        supportDefineProperty = Object.defineProperty && Object.defineProperty({},'x', {});
    } catch(ex) {  /* not supported */  }

    var isFunction = function (functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) == '[object Function]';
    };

    var isInt = function (x) {
        return x % 1 === 0;
    };

    var isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };

    var isObject = function(obj) {
        return {}.toString.apply(obj) === '[object Object]';
    };
    
    var getObjDiff = function(a, b){
        var aplus = [],
        bplus = [];

        if(!(typeof a == "string") && !(typeof b == "string")){

            if (isArray(a) && b) {
                for (var i=0; i<a.length; i++) {
                    if (b[i] === undefined) aplus.push(i);
                }
            } else {
                for(var i in a){
                    if (a.hasOwnProperty(i)) {
                        if(b && !b.hasOwnProperty(i)) {
                            aplus.push(i);
                        }
                    }
                }
            }

            if (isArray(b) && a) {
                for (var j=0; j<b.length; j++) {
                    if (a[j] === undefined) bplus.push(j);
                }
            } else {
                for(var j in b){
                    if (b.hasOwnProperty(j)) {
                        if(a && !a.hasOwnProperty(j)) {
                            bplus.push(j);
                        }
                    }
                }
            }
        }

        return {
            added: aplus,
            removed: bplus
        }
    };

    var clone = function(obj){

        if (null == obj || "object" != typeof obj) {
            return obj;
        }

        var copy = obj.constructor();

        for (var attr in obj) {
            copy[attr] = obj[attr];
        }

        return copy;        

    }

    var defineGetAndSet = function (obj, propName, getter, setter) {
        try {
            Object.defineProperty(obj, propName, {
                get: getter,
                set: function(value) {
                    setter.call(this,value,true); // coalesce changes
                },
                enumerable: true,
                configurable: true
            });
        }
        catch(e1) {
            try{
                Object.prototype.__defineGetter__.call(obj, propName, getter);
                Object.prototype.__defineSetter__.call(obj, propName, function(value) {
                    setter.call(this,value,true); // coalesce changes
                });
            }
            catch(e2) {
                observeDirtyChanges(obj,propName,setter);
                //throw new Error("DFI.WatchJS error: browser not supported :/")
            }
        }

    };

    var defineProp = function (obj, propName, value) {
        try {
            Object.defineProperty(obj, propName, {
                enumerable: false,
                configurable: true,
                writable: false,
                value: value
            });
        } catch(error) {
            obj[propName] = value;
        }
    };

    var observeDirtyChanges = function(obj,propName,setter) {
        dirtyChecklist[dirtyChecklist.length] = {
            prop:       propName,
            object:     obj,
            orig:       clone(obj[propName]),
            callback:   setter
        }        
    }
    
    var watch = function () {

        if (isFunction(arguments[1])) {
            watchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            watchMany.apply(this, arguments);
        } else {
            watchOne.apply(this, arguments);
        }

    };


    var watchAll = function (obj, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isArray(obj)) {
            defineWatcher(obj, "__watchall__", watcher, level); // watch all changes on the array
            if (level===undefined||level > 0) {
                for (var prop = 0; prop < obj.length; prop++) { // watch objects in array
                   watchAll(obj[prop],watcher,level, addNRemove);
                }
            }
        } 
        else {
            var prop,props = [];
            for (prop in obj) { //for each attribute if obj is an object
                if (prop == "$val" || (!supportDefineProperty && prop === 'watchers')) {
                    continue;
                }

                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    props.push(prop); //put in the props
                }
            }
            watchMany(obj, props, watcher, level, addNRemove); //watch all items of the props
        }


        if (addNRemove) {
            pushToLengthSubjects(obj, "$$watchlengthsubjectroot", watcher, level);
        }
    };


    var watchMany = function (obj, props, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        for (var i=0; i<props.length; i++) { //watch each property
            var prop = props[i];
            watchOne(obj, prop, watcher, level, addNRemove);
        }

    };

    var watchOne = function (obj, prop, watcher, level, addNRemove) {
        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isFunction(obj[prop])) { //dont watch if it is a function
            return;
        }
        if(obj[prop] != null && (level === undefined || level > 0)){
            watchAll(obj[prop], watcher, level!==undefined? level-1 : level); //recursively watch all attributes of this
        }

        defineWatcher(obj, prop, watcher, level);

        if(addNRemove && (level === undefined || level > 0)){
            pushToLengthSubjects(obj, prop, watcher, level);
        }

    };

    var unwatch = function () {

        if (isFunction(arguments[1])) {
            unwatchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            unwatchMany.apply(this, arguments);
        } else {
            unwatchOne.apply(this, arguments);
        }

    };

    var unwatchAll = function (obj, watcher) {

        if (obj instanceof String || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if (isArray(obj)) {
            var props = ['__watchall__'];
            for (var prop = 0; prop < obj.length; prop++) { //for each item if obj is an array
                props.push(prop); //put in the props
            }
            unwatchMany(obj, props, watcher); //watch all itens of the props
        } else {
            var unwatchPropsInObject = function (obj2) {
                var props = [];
                for (var prop2 in obj2) { //for each attribute if obj is an object
                    if (obj2.hasOwnProperty(prop2)) {
                        if (obj2[prop2] instanceof Object) {
                            unwatchPropsInObject(obj2[prop2]); //recurs into object props
                        } else {
                            props.push(prop2); //put in the props
                        }
                    }
                }
                unwatchMany(obj2, props, watcher); //unwatch all of the props
            };
            unwatchPropsInObject(obj);
        }
    };


    var unwatchMany = function (obj, props, watcher) {

        for (var prop2 in props) { //watch each attribute of "props" if is an object
            if (props.hasOwnProperty(prop2)) {
                unwatchOne(obj, props[prop2], watcher);
            }
        }
    };

    var timeouts = [],
        timerID = null;
    function clearTimerID() {
        timerID = null;
        for(var i=0; i< timeouts.length; i++) {
            timeouts[i]();
        }
        timeouts.length = 0;
    }
    var getTimerID= function () {
        if (!timerID)  {
            timerID = setTimeout(clearTimerID);
        }
        return timerID;
    }
    var registerTimeout = function(fn) { // register function to be called on timeout
        if (timerID==null) getTimerID();
        timeouts[timeouts.length] = fn;
    }
    
    // Track changes made to an array, object or an object's property 
    // and invoke callback with a single change object containing type, value, oldvalue and array splices
    // Syntax: 
    //      trackChange(obj, callback, recursive, addNRemove)
    //      trackChange(obj, prop, callback, recursive, addNRemove)
    var trackChange = function() {
        var fn = (isFunction(arguments[2])) ? trackProperty : trackObject ;
        fn.apply(this,arguments);
    }

    // track changes made to an object and invoke callback with a single change object containing type, value and array splices
    var trackObject= function(obj, callback, recursive, addNRemove) {
        var change = null,lastTimerID = -1;
        var isArr = isArray(obj);
        var level,fn = function(prop, action, newValue, oldValue) {
            var timerID = getTimerID();
            if (lastTimerID!==timerID) { // check if timer has changed since last update
                lastTimerID = timerID;
                change = {
                    type: 'update'
                }
                change['value'] = obj;
                change['splices'] = null;
                registerTimeout(function() {
                    callback.call(this,change);
                    change = null;
                });
            }
            // create splices for array changes
            if (isArr && obj === this && change !== null)  {                
                if (action==='pop'||action==='shift') {
                    newValue = [];
                    oldValue = [oldValue];
                }
                else if (action==='push'||action==='unshift') {
                    newValue = [newValue];
                    oldValue = [];
                }
                else if (action!=='splice') { 
                    return; // return here - for reverse and sort operations we don't need to return splices. a simple update will do
                }
                if (!change.splices) change.splices = [];
                change.splices[change.splices.length] = {
                    index: prop,
                    deleteCount: oldValue ? oldValue.length : 0,
                    addedCount: newValue ? newValue.length : 0,
                    added: newValue,
                    deleted: oldValue
                };
            }

        }  
        level = (recursive==true) ? undefined : 0;        
        watchAll(obj,fn, level, addNRemove);
    }
    
    // track changes made to the property of an object and invoke callback with a single change object containing type, value, oldvalue and splices
    var trackProperty = function(obj,prop,callback,recursive, addNRemove) { 
        if (obj && prop) {
            watchOne(obj,prop,function(prop, action, newvalue, oldvalue) {
                var change = {
                    type: 'update'
                }
                change['value'] = newvalue;
                change['oldvalue'] = oldvalue;
                if (recursive && isObject(newvalue)||isArray(newvalue)) {
                    trackObject(newvalue,callback,recursive, addNRemove);
                }               
                callback.call(this,change);
            },0)
            
            if (recursive && isObject(obj[prop])||isArray(obj[prop])) {
                trackObject(obj[prop],callback,recursive, addNRemove);
            }                           
        }
    }
    
    
    var defineWatcher = function (obj, prop, watcher, level) {
        var newWatcher = false;
        var isArr = isArray(obj);
        
        if (!obj.watchers) {
            defineProp(obj, "watchers", {});
            if (isArr) {
                // watch array functions
                watchFunctions(obj, function(index,action,newValue, oldValue) {
                    addPendingChange(obj, index, action,newValue, oldValue);
                    if (level !== 0 && newValue && (isObject(newValue) || isArray(newValue))) {
                        var i,n, ln, wAll, watchList = obj.watchers[prop];
                        if ((wAll = obj.watchers['__watchall__'])) {
                            watchList = watchList ? watchList.concat(wAll) : wAll;
                        }
                        ln = watchList ?  watchList.length : 0;
                        for (i = 0; i<ln; i++) {
                            if (action!=='splice') {
                                watchAll(newValue, watchList[i], (level===undefined)?level:level-1);
                            }
                            else {
                                // watch spliced values
                                for(n=0; n < newValue.length; n++) {
                                    watchAll(newValue[n], watchList[i], (level===undefined)?level:level-1);
                                }
                            }
                        }
                    }
                });
            }
        }

        if (!obj.watchers[prop]) {
            obj.watchers[prop] = [];
            if (!isArr) newWatcher = true;
        }

        for (var i=0; i<obj.watchers[prop].length; i++) {
            if(obj.watchers[prop][i] === watcher){
                return;
            }
        }

        obj.watchers[prop].push(watcher); //add the new watcher to the watchers array

        if (newWatcher) {
            var val = obj[prop];            
            var getter = function () {
                return val;                        
            };

            var setter = function (newval, delayWatcher) {
                var oldval = val;
                val = newval;                
                if (level !== 0 
                    && obj[prop] && (isObject(obj[prop]) || isArray(obj[prop]))
                    && !obj[prop].watchers) {
                    // watch sub properties
                    var i,ln = obj.watchers[prop].length; 
                    for(i=0; i<ln; i++) {
                        watchAll(obj[prop], obj.watchers[prop][i], (level===undefined)?level:level-1);
                    }
                }

                //watchFunctions(obj, prop);
                
                if (isSuspended(obj, prop)) {
                    resume(obj, prop);
                    return;
                }

                if (!DFI.WatchJS.noMore){ // this does not work with Object.observe
                    //if (JSON.stringify(oldval) !== JSON.stringify(newval)) {
                    if (oldval !== newval) {
                        if (!delayWatcher) {
                            callWatchers(obj, prop, "set", newval, oldval);
                        }
                        else {
                            addPendingChange(obj, prop, "set", newval, oldval);
                        }
                        DFI.WatchJS.noMore = false;
                    }
                }
            };

            if (DFI.WatchJS.useDirtyCheck) {
                observeDirtyChanges(obj,prop,setter);
            }
            else {
                defineGetAndSet(obj, prop, getter, setter);
            }
        }

    };

    var callWatchers = function (obj, prop, action, newval, oldval) {
        if (prop !== undefined) {
            var ln, wl, watchList = obj.watchers[prop];
            if ((wl = obj.watchers['__watchall__'])) {
                watchList = watchList ? watchList.concat(wl) : wl;
            }
            ln = watchList ? watchList.length : 0;
            for (var wr=0; wr< ln; wr++) {
                watchList[wr].call(obj, prop, action, newval, oldval);
            }
        } else {
            for (var prop in obj) {//call all
                if (obj.hasOwnProperty(prop)) {
                    callWatchers(obj, prop, action, newval, oldval);
                }
            }
        }
    };

    var methodNames = ['pop', 'push', 'reverse', 'shift', 'sort', 'slice', 'unshift', 'splice'];
    var defineArrayMethodWatcher = function (obj, original, methodName, callback) {
        defineProp(obj, methodName, function () {
            var index = 0;
            var i,newValue, oldValue, response;                        
            // get values before splicing array 
            if (methodName === 'splice') {
               var start = arguments[0];
               var end = start + arguments[1];
               oldValue = obj.slice(start,end);
               newValue = [];
               for(i=2;i<arguments.length;i++) {
                   newValue[i-2] = arguments[i];
               }
               index = start;
            } 
            else {
                newValue = arguments.length > 0 ? arguments[0] : undefined;
            } 

            response = original.apply(obj, arguments);
            if (methodName !== 'slice') {
                if (methodName === 'pop') {
                    oldValue = response;
                    index = obj.length;
                }
                else if (methodName === 'push') {
                    index = obj.length-1;
                }
                else if (methodName === 'shift') {
                    oldValue = response;
                }
                else if (methodName !== 'unshift' && newValue===undefined) {
                    newValue = response;
                }
                callback.call(obj, index, methodName,newValue, oldValue)
            }
            return response;
        });
    };

    var watchFunctions = function(obj, callback) {

        if (!isFunction(callback) || !obj || (obj instanceof String) || (!isArray(obj))) {
            return;
        }

        for (var i = methodNames.length, methodName; i--;) {
            methodName = methodNames[i];
            defineArrayMethodWatcher(obj, obj[methodName], methodName, callback);
        }

    };

    var unwatchOne = function (obj, prop, watcher) {
        if (prop) {
            if (obj.watchers && obj.watchers[prop]) {
                if (watcher === undefined) {
                    delete obj.watchers[prop]; // remove all property watchers
                }
                else {
                    for (var i = 0; i < obj.watchers[prop].length; i++) {
                        var w = obj.watchers[prop][i];
                        if (w == watcher) {
                            obj.watchers[prop].splice(i, 1);
                        }
                    }
                }
            }
        } else {
            delete obj.watchers;
        }

        removeFromLengthSubjects(obj, prop, watcher);
        removeFromDirtyChecklist(obj, prop);
    };
    
    // suspend watchers until next update cycle
    var suspend = function(obj, prop) {
        if (obj.watchers) {
            var name = '__wjs_suspend__'+(prop!==undefined ? prop : '');
            obj.watchers[name] = true;
        }
    }
    
    var isSuspended = function(obj, prop) {
        return obj.watchers 
               && (obj.watchers['__wjs_suspend__'] || 
                   obj.watchers['__wjs_suspend__'+prop]);
    }
    
    // resumes preivously suspended watchers
    var resume = function(obj, prop) {
        registerTimeout(function() {
            delete obj.watchers['__wjs_suspend__'];
            delete obj.watchers['__wjs_suspend__'+prop];
        })
    }

    var pendingTimerID = null;
    var addPendingChange = function(obj,prop, mode, newval, oldval) {
        pendingChanges[pendingChanges.length] = {
            obj:obj,
            prop: prop,
            mode: mode,
            newval: newval,
            oldval: oldval
        };
        if (pendingTimerID===null) {
            pendingTimerID = setTimeout(applyPendingChanges);
        }
    };
    
    
    var applyPendingChanges = function()  {
        // apply pending changes
        var change = null;
        pendingTimerID = null;
        for(var i=0;i < pendingChanges.length;i++) {
            change = pendingChanges[i];
            callWatchers(change.obj, change.prop, change.mode, change.newval, change.oldval);
        }
        if (change) {
            pendingChanges = [];
            change = null;
        }        
    }

    var loop = function(){

        // check for new or deleted props
        for(var i=0; i<lengthsubjects.length; i++) {

            var subj = lengthsubjects[i];

            if (subj.prop === "$$watchlengthsubjectroot") {

                var difference = getObjDiff(subj.obj, subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        watchMany(subj.obj, difference.added, subj.watcher, subj.level - 1, true);
                    }

                    subj.watcher.call(subj.obj, "root", "differentattr", difference, subj.actual);
                }
                subj.actual = clone(subj.obj);


            } else {

                var difference = getObjDiff(subj.obj[subj.prop], subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        for (var j=0; j<subj.obj.watchers[subj.prop].length; j++) {
                            watchMany(subj.obj[subj.prop], difference.added, subj.obj.watchers[subj.prop][j], subj.level - 1, true);
                        }
                    }

                    callWatchers(subj.obj, subj.prop, "differentattr", difference, subj.actual);
                }

                subj.actual = clone(subj.obj[subj.prop]);

            }

        }
        
        // start dirty check
        var n, value;
        if (dirtyChecklist.length > 0) {
            for (var i = 0; i < dirtyChecklist.length; i++) {
                n = dirtyChecklist[i];
                value = n.object[n.prop];
                if (!compareValues(n.orig, value)) {
                    n.orig = clone(value);
                    n.callback(value);
                }
            }
        }

    };

    var compareValues =  function(a,b) {
        var i, state = true;
        if (a!==b)  {
            if (isObject(a)) {
                for(i in a) {
                    if (!supportDefineProperty && i==='watchers') continue;
                    if (a[i]!==b[i]) {
                        state = false;
                        break;
                    };
                }
            }
            else {
                state = false;
            }
        }
        return state;
    }
    
    var pushToLengthSubjects = function(obj, prop, watcher, level){

        var actual;

        if (prop === "$$watchlengthsubjectroot") {
            actual =  clone(obj);
        } else {
            actual = clone(obj[prop]);
        }

        lengthsubjects.push({
            obj: obj,
            prop: prop,
            actual: actual,
            watcher: watcher,
            level: level
        });
    };

    var removeFromLengthSubjects = function(obj, prop, watcher){
        for (var i=0; i<lengthsubjects.length; i++) {
            var subj = lengthsubjects[i];

            if (subj.obj == obj) {
                if (!prop || subj.prop == prop) {
                    if (!watcher || subj.watcher == watcher) {
                        // if we splice off one item at position i
                        // we need to decrement i as the array is one item shorter
                        // so when we increment i in the loop statement we
                        // will land at the correct index.
                        // if it's not decremented, you won't delete all length subjects
                        lengthsubjects.splice(i--, 1);
                    }
                }
            }
        }

    };
    
    var removeFromDirtyChecklist = function(obj, prop){
        var notInUse;
        for (var i=0; i<dirtyChecklist.length; i++) {
            var n = dirtyChecklist[i];
            var watchers = n.object.watchers;
            notInUse = (
                n.object == obj 
                && (!prop || n.prop == prop)
                && watchers
                && (!prop || !watchers[prop] || watchers[prop].length == 0 )
            );
            if (notInUse)  {
                // we use the same syntax as in removeFromLengthSubjects
                dirtyChecklist.splice(i--, 1);
            }
        }

    };    

    setInterval(loop, 50);

    DFI.WatchJS.watch = watch;
    DFI.WatchJS.unwatch = unwatch;
    DFI.WatchJS.callWatchers = callWatchers;
    DFI.WatchJS.suspend = suspend; // suspend watchers    
    DFI.WatchJS.onChange = trackChange;  // track changes made to object or  it's property and return a single change object

    return DFI.WatchJS;     
   } 

    // Fin función para habilitar el watcher
	// Función para habilitar el watch en un objeto que se borre de nuevo y que por lo 
	// tanto no sirva DFI.objectObserver
	//Importante objectToObserve es un string

	DFI.objectObserverNew = function(objectToObserve,functionToExecute){
		var checkIfObjectExist = setInterval(function(){
			if( typeof DFI.eval(objectToObserve) === "object"){
				clearInterval(checkIfObjectExist);
				// Almacenamos objectToObserve en una variable del entornos de nombres DFI
				DFI.objectToObserve = {};
				DFI.objectToObserve.nameOriginal = DFI.copyObject(DFI.eval(objectToObserve));
				DFI.objectToObserve.nametoObserve = DFI.eval(objectToObserve);
				DFI.objectToObserve.started =true;
				var objectToObserveTest = setInterval(function(){
					if(typeof DFI.eval(objectToObserve) === "object"){
                        //DFI.objectToObserve.nametoObserve = DFI.eval(objectToObserve);
                        DFI.objectToObserve.nametoObserve = JSON.parse(JSON.stringify( DFI.eval(objectToObserve)));
					}
					if(DFI.compareequalsObjects(DFI.objectToObserve.nameOriginal,DFI.objectToObserve.nametoObserve) === false){
                        //DFI.objectToObserve.nameOriginal = DFI.copyObject(DFI.objectToObserve.nametoObserve);
                        DFI.objectToObserve.nameOriginal = JSON.parse(JSON.stringify(DFI.objectToObserve.nametoObserve));
                        functionToExecute();
					}
					if(DFI.objectToObserve.started === false){
						clearInterval(objectToObserveTest);
					}


				}, 1000);


			}
		}, 1000);


	}

	//Fin Función para habilitar el watch

	// Copiar 2 objectos
	DFI.copyObject = function(mainObj) {
		let objCopy = {}; // objCopy will store a copy of the mainObj
		let key;
	  
		for (key in mainObj) {
		  objCopy[key] = mainObj[key]; // copies each property to the objCopy object
		}
		return objCopy;
	  }

	// Fin copiar 2 objetos

	DFI.compareequalsObjects = function(obj1, obj2){

	//Loop through properties in object 1
	for (var p in obj1) {
		//Check property exists on both objects
		if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;
 
		switch (typeof (obj1[p])) {
			//Deep compare objects
			case 'object':
				if (!DFI.compareequalsObjects(obj1[p], obj2[p])) return false;
				break;
			//Compare function code
			case 'function':
				if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
				break;
			//Compare values
			default:
				if (obj1[p] != obj2[p]) return false;
		}
	}
 
	//Check object 2 for any extra properties
	for (var p in obj2) {
		if (typeof (obj1[p]) == 'undefined') return false;
	}
	return true;

	}

    // Fin compare objects
    

    //Funciones de Ring pool
    // Check if element is hidden

    DFI.isHidden= function(el) {
         if(el === null){
            return false;
        }
        if(el.length === 0){
            return false;
        }

        var output = true;

        for (var i = 0, len = el.length; i < len; i++)   {
            var style = window.getComputedStyle(el[i]);
            if((style.display != 'none') 
            && (style.visibility != 'hidden')){
                output = false;
            }
            if(style.display === 'inline'
            && DFI.isHiddenInline(el[i])){
                output = false;
            }
        }     
        //var style = window.getComputedStyle(el);
        //return ((style.display === 'none') || (style.visibility === 'hidden'));
        return output;
    }

    //Funcion 2 to check si es hidden
    //getComputedStyle a veces no obtiene el valor adecuado "inline" en vez de "none"
    //La siguiente función la utilizaremos si senos devuelve "inline"

    DFI.isHiddenInline = function(elInline) {
        return (elInline.offsetParent === null)
    }

        //Function to check if is visible window.DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass

    DFI.ringPollClassIsVisible = function(){
        if(window.DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass != undefined 
            && window.DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass!= ""){
                    if((!DFI.isHidden(document.querySelectorAll(window.DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass)))
                    || (!DFI.isHidden(document.querySelectorAll(".wal-drp-phone"))) ){
                    //DFI.initRingpool();
                    DFI.chooseRingPool();
                    statusDFI.initRingpool = true;
                    DFI.checkClass.disconnect();
                }
        }
    }

    DFI.requestRingPoolNumber = function(idTag,allTags,Evisit,visitorId, CampaignId,phoneCallCenterRingPool,element){
    //Update Visitvars
    DAL.Ajax({
        type: "jsonp",
        url: DFI.global.updateVisitLabelByVisitorId + "?&format=jsonp&idTag=" + idTag +"&idVisitor=" + visitorId +"&data=" + JSON.stringify(Evisit) ,
    }).done(function(responseVisitorId) {
        DFI.consoleLogDelio("updateVisitLabelByVisitorId OK: " + responseVisitorId);
            //Request phone
            DAL.Ajax({
                type: "jsonp",
                url: DFI.global.requestRingPoolNumber + "campaignid=" + CampaignId +"&prefid=" + visitorId ,
            }).done(function(responseRingPoolNumber) {
                DFI.consoleLogDelio("requestRingPoolNumber OK: " + JSON.stringify(responseRingPoolNumber));
                window.DFI.telefonoRingPoolActivo = responseRingPoolNumber.telefono;
                if(responseRingPoolNumber.telefono === "0" || responseRingPoolNumber.telefono === 0){
                    // window.open('tel:' + phoneCallCenterRingPool, '_system' );
                    element.setAttribute("href", 'tel:' + phoneCallCenterRingPool);
                }else{
                    // window.open('tel:' + window.DFI.telefonoRingPoolActivo , '_system' );
                    element.setAttribute("href", 'tel:' + window.DFI.telefonoRingPoolActivo);
                }
                if(element.tagName !="A" 
                && document.getElementById("WalmericContainer") === null){
                    var newAnchorElement = document.createElement("A");
                    newAnchorElement.style.display="none";
                    newAnchorElement.setAttribute("id", "WalmericContainer");
                    newAnchorElement.setAttribute("href", 'tel:' + window.DFI.telefonoRingPoolActivo);
                    document.body.appendChild(newAnchorElement);   
                    newAnchorElement.click();
                    element.addEventListener("click", function _listener(event) {
                        element.removeEventListener("click", _listener, true);
                        DFI.requestRingPoolNumber(window.DFI.DFI_configuration.idTagDelioClient,window.DFI.labelsVarRingPool,window.DFI.labelsVarRingPool.Evisit,Piwik.getAsyncTracker().getVisitorId(),window.DFI.servicioActivo1.serviceIdRingPool,window.DFI.servicioActivo1.phoneCallCenterRingPool,this);
                      }, true);
                } else if(document.getElementById("WalmericContainer") === null){
                    element.click();
                }else if(document.getElementById("WalmericContainer") != null){
                    element.addEventListener("click", function _listener(event) {
                        element.removeEventListener("click", _listener, true);
                        DFI.requestRingPoolNumber(window.DFI.DFI_configuration.idTagDelioClient,window.DFI.labelsVarRingPool,window.DFI.labelsVarRingPool.Evisit,Piwik.getAsyncTracker().getVisitorId(),window.DFI.servicioActivo1.serviceIdRingPool,window.DFI.servicioActivo1.phoneCallCenterRingPool,this);
                      }, true);
                    document.getElementById("WalmericContainer").click();
                    
                }
                
                
                

                //Update all vars
                DAL.Ajax({
                    type: "jsonp",
                    url: DFI.global.sendRingPoolLabels + "idTag=" + idTag +"&idvisitor=" + visitorId +"&labels=" + JSON.stringify(allTags) +"&idServ=" + CampaignId,
                }).done(function(responseRingPoolLabels) {
                    DFI.consoleLogDelio("sendRingPoolLabels OK: " + responseRingPoolLabels);
                    return true;
                }).fail(function(responseRingPoolLabels) {
                    DFI.consoleLogDelio("sendRingPoolLabels NOK: " + responseRingPoolLabels);
                });

            }).fail(function(responseRingPoolNumber) {
                DFI.consoleLogDelio("requestRingPoolNumber NOK: " + JSON.stringify(responseRingPoolNumber));
            });
    }).fail(function(responseVisitorId) {
        DFI.consoleLogDelio("updateVisitLabelByVisitorId NOK: " + responseVisitorId);
    });

    
    }


    DFI.chooseRingPool =function(){
        if( DFI.environment === "mobile" 
        && typeof   DFI_client === "object" 
        && typeof DFI_client.mobileNumberSaving === "string"){
            if(typeof DFI_client.mobileNumberSavingResult === "undefined"){
                DFI_client.mobileNumberSavingResult = Number(DFI_client.mobileNumberSaving);
            }
            if(DFI_client.mobileNumberSavingResult > Math.random() * 100){
                if(typeof DFI_client.visitRingPoolSave != "undefined"){
                    DFI.labels.EVisitsDef.push( {id: DFI_client.visitRingPoolSave, value: "true"});
                }
                DFI.labels.EDeclaratives["RingPoolSave"] = "true";
                window.DFI.labelsVarRingPool = {
                    EDeclaratives: DFI.labels.EDeclaratives,
                    EConversion: DFI.labels.EConversionDef,
                    Evisit: DFI.labels.EVisitsDef
                };
                window.DFI.labelsVarRingPool.EDeclaratives["service_call_assigned_RP"] = window.DFI.servicioActivo1.serviceIdCallMeBack;
                window.DFI.labelsVarRingPool.EDeclaratives["service_call_priority"] = window.DFI.servicioActivo1.priority;
                window.DFI.labelsVarRingPool.EDeclaratives["service_call_ruleId"] = window.DFI.servicioActivo1.ruleId;
                window.DFI.labelsVarRingPool.EDeclaratives["service_call_name"] = window.DFI.servicioActivo1.serviceName;
                window.DFI.labelsVarRingPool.EDeclaratives["visual_idRule"] = window.DFI.resultShowRules.idRule;
                window.DFI.labelsVarRingPool.EDeclaratives["visual_idOrder"] = window.DFI.resultShowRules.order;
                window.DFI.labelsVarRingPool.EDeclaratives["visual_idDescription"] = window.DFI.resultShowRules.description;          
    
    
                var phoneElementtoCall ="";
                window.DFI.DFI_configuration.layers1.push(".drp-phone-new");
                window.DFI.DFI_configuration.layers1.push(".wal-drp-phone");
                for (var ij = 0, len = window.DFI.DFI_configuration.layers1.length; ij < len; ij++) {
                    phoneElementtoCall = document.querySelectorAll(window.DFI.DFI_configuration.layers1[ij]);
                    for (var ijk = 0, lent = phoneElementtoCall.length; ijk < lent; ijk++) {
                        phoneElementtoCall[ijk].removeAttribute("href");
                        // phoneElementtoCall[ijk].addEventListener("touchstart", function(event) {
                        //     DFI.requestRingPoolNumber(window.DFI.DFI_configuration.idTagDelioClient,window.DFI.labelsVarRingPool,window.DFI.labelsVarRingPool.Evisit,Piwik.getAsyncTracker().getVisitorId(),window.DFI.servicioActivo1.serviceIdRingPool,window.DFI.servicioActivo1.phoneCallCenterRingPool,this);
                        //   });
                          phoneElementtoCall[ijk].addEventListener("click", function _listener(event) {
                            this.removeEventListener("click", _listener, true);
                            DFI.requestRingPoolNumber(window.DFI.DFI_configuration.idTagDelioClient,window.DFI.labelsVarRingPool,window.DFI.labelsVarRingPool.Evisit,Piwik.getAsyncTracker().getVisitorId(),window.DFI.servicioActivo1.serviceIdRingPool,window.DFI.servicioActivo1.phoneCallCenterRingPool,this);
                          }, true);
                    }

                }
            } else{
                DFI.labels.EDeclaratives["RingPoolSave"] = "false";
                if(typeof DFI_client.visitRingPoolSave != "undefined"){
                    DFI.labels.EVisitsDef.push( {id: DFI_client.visitRingPoolSave, value: "false"});
                }
                DFI.initRingpool();
            }

        } else{
            DFI.initRingpool();
        }

    }
   

    //Function to check The class that is hidden an element
    DFI.checkParentHidden = function(element){
        var actualElement = element;
        var passElemeent = element;

        if(DFI.isHidden(actualElement)){
            do {
                passElemeent = actualElement; 
                actualElement =actualElement.parentElement;
            } while (DFI.isHidden(actualElement.parentElement)) 
        }
        return passElemeent;
    }

    // Fin Funciones de Ring pool



    //Inicializaciones 
    DFI.totalURL = window.location.href;
    if(typeof window.statusDFI === "undefined"){
        window.statusDFI = {};
    }
    var statusDFI = window.statusDFI;

    DFI.idTagDelio = DFI.idTagDelio || window.idTagDelio;
    DFI.sessionData = {
		url:[],
		visitLabel:[],
		declarativeLabel:[],
		conversionLabel:[]
	};
	if (typeof(Storage) !== "undefined") {
		var temporal = JSON.parse(sessionStorage.getItem('delioSessionData'));
		
		if(temporal !== null){
			DFI.sessionData = temporal;
		}
		
	} else {
		// No hay datos de sesión
	}		
	DFI.sessionData.url.push(DFI.totalURL);
	
	// Fin lectura del objeto de datos almacenados en la misma sesión
	
    DFI.environment = DFI.getInterfaceMode();
    var site = DFI.getSite();

    DFI.consoleLogDelio("environment:" + DFI.environment);
	
	// Para propósitos de previsualización.
	if(DFI.GlobalWalmeric === "mobile"){
		DFI.environment = "mobile";
	}
	if(DFI.GlobalWalmeric === "desktop"){
		DFI.environment = "desktop";
	}		


    statusDFI.configurationResponse = true;
    DFI.labels = {
        EDeclaratives: {},
        EExternals: [],
        EConversion: [],
        EVisits: [],
    };
    // Seteamos valores por defecto en caso de que vengan vacios.

    if (DFI.DFI_configuration.services.ringPool === undefined) {
        DFI.DFI_configuration.services.ringPool = {
            active: true,
            phoneMask: "### ### ###",
            ringpoolClass: ".drp-phone",
        }
    }
    if (DFI.DFI_configuration.defaultStyles === "" || DFI.DFI_configuration.defaultStyles === null) {
        DFI.DFI_configuration.defaultStyles = "https://t.womtp.com/slider/c/delio-lm/dfi/assets/stylesheets/dmv.css";
    } 


    DFI.DFI_configuration.layers1 = [];
    DFI.DFI_configuration.layers1.push(DFI.DFI_configuration.layers);

    if (DFI.DFI_configuration.DSAs.dsaImage === undefined || DFI.DFI_configuration.DSAs.dsaImage === "undefined" || DFI.DFI_configuration.DSAs.dsaImage === "") {

        DFI.DFI_configuration.DSAs.dsaImage = "https://delio-lm.com/delio-lite/delio-lm/dfi/assets/img/agente_amarillo.png";
    }

    if (DFI.DFI_configuration.DSAs.dsaClose === undefined || DFI.DFI_configuration.DSAs.dsaClose === "undefined" || DFI.DFI_configuration.DSAs.dsaClose === "") {

        DFI.DFI_configuration.DSAs.dsaClose = "https://delio-lm.com/delio-lite/delio-lm/dfi/assets/img/btn_close_yellow_white.png";
    }



    // Fin Borrar cuando me lo devuelvan bien

    DFI.DFI_configuration.labels = {};
    DFI.DFI_configuration.labelsUrl = {};
    DFI.DFI_configuration.labelsByUrl = {};
    DFI.DFI_configuration.valuesByUrl = {};
    DFI.DFI_configuration.labelsJson = {};
    DFI.DFI_configuration.labelsForm = {};
    DFI.DFI_configuration.labelsIds = {};
    DFI.DFI_configuration.labels.EDeclaratives = {};
    DFI.DFI_configuration.labels.EConversion = {};
    DFI.DFI_configuration.labels.EVisits = {};
    if (DFI.DFI_configuration.hasOwnProperty("mappingLabels")) {
        if (DFI.DFI_configuration.mappingLabels.url !== null) {
            DFI.DFI_configuration.datalayer = {
                type: "url"
            };
            if (DFI.DFI_configuration.mappingLabels.url.hasOwnProperty("labels")) {
                DFI.DFI_configuration.labelsUrl = DFI.DFI_configuration.mappingLabels.url.labels;

            }
        }
        if (DFI.DFI_configuration.mappingLabels.json !== null) {
            DFI.DFI_configuration.datalayer = {
                type: "json",
                container: DFI.DFI_configuration.mappingLabels.json.container,
                objectName: DFI.DFI_configuration.mappingLabels.json.objectName,
                parentName: DFI.DFI_configuration.mappingLabels.json.parentName,
                path: DFI.DFI_configuration.mappingLabels.json.path
            }
            if (DFI.DFI_configuration.mappingLabels.json.hasOwnProperty("labels")) {
                DFI.DFI_configuration.labelsJson = DFI.DFI_configuration.mappingLabels.json.labels;
                //Object.assign(DFI.DFI_configuration.labels, DFI.DFI_configuration.mappingLabels.json.labels);	
            }
        }
        if (DFI.DFI_configuration.mappingLabels.form !== null) {
            DFI.DFI_configuration.datalayer = {
                type: "form",
                id: DFI.DFI_configuration.mappingLabels.form.parentId
            };
            if (DFI.DFI_configuration.mappingLabels.form.hasOwnProperty("labels")) {
                DFI.DFI_configuration.labelsForm = DFI.DFI_configuration.mappingLabels.form.labels;
                //Object.assign(DFI.DFI_configuration.labels, DFI.DFI_configuration.mappingLabels.form.labels);		
            }
        }
        if (DFI.DFI_configuration.mappingLabels.ids !== null) {
            DFI.DFI_configuration.datalayer = {
                type: "ids"
            };
            if (DFI.DFI_configuration.mappingLabels.ids.hasOwnProperty("labels")) {
                DFI.DFI_configuration.labelsIds = DFI.DFI_configuration.mappingLabels.ids.labels;
                //Object.assign(DFI.DFI_configuration.labels, DFI.DFI_configuration.mappingLabels.ids.labels);	
            }
        }
        if (DFI.DFI_configuration.mappingLabels.byUrl !== null && DFI.DFI_configuration.mappingLabels.byUrl !== undefined) {
            DFI.DFI_configuration.datalayer = {
                type: "byUrl"
            };
            var urlSinParametros = window.location.href.replace(window.location.search, "");
            urlSinParametros = urlSinParametros.replace("http://", "");
            urlSinParametros = urlSinParametros.replace("https://", "");
            //quitamos los #
            urlSinParametros = urlSinParametros.replace("#", "");
            //quitamos index.html/ e index.html
            urlSinParametros = urlSinParametros.replace("index.html/", "");
            urlSinParametros = urlSinParametros.replace("index.html?", "");
            urlSinParametros = urlSinParametros.replace("index.html", "");

            //var urlSinParametros = window.location.hostname + window.location.pathname + window.location.search;
            window.labelsByUrlOk = false;
            for (var i = 0, len = DFI.DFI_configuration.mappingLabels.byUrl.length; i < len; i++) {
                DFI.consoleLogDelio(DFI.DFI_configuration.mappingLabels.byUrl[i]);
                //Para mantener toda la estructura igual al del resto de los casos Lo que hacemos es lo mismo que en los otros casos, por un lado creamos el objeto
                //DFI.DFI_configuration.labelsbyUrl, y por otro lado seteamos "window.layerIdVal" en "DFI.setDataLayer()", de esta forma el tratamiento siempre es el mismos
                // aunque en este caso no sea óptimo
                DFI.DFI_configuration.mappingLabels.byUrl[i].url = DFI.DFI_configuration.mappingLabels.byUrl[i].url.replace("http://", "");
                DFI.DFI_configuration.mappingLabels.byUrl[i].url = DFI.DFI_configuration.mappingLabels.byUrl[i].url.replace("https://", "");
                if (DFI.DFI_configuration.mappingLabels.byUrl[i].url.indexOf(urlSinParametros) > -1) {
                    DFI.DFI_configuration.labelsByUrl = DFI.DFI_configuration.mappingLabels.byUrl[i].labelsByUrls[0];
                    DFI.DFI_configuration.labelsValuesByUrl = DFI.DFI_configuration.mappingLabels.byUrl[i].labelsByUrls;
                    window.labelsByUrlOk = true;
                }
            }
        }

        Object.assign(DFI.DFI_configuration.labels.EDeclaratives, DFI.DFI_configuration.labelsUrl.EDeclaratives, DFI.DFI_configuration.labelsJson.EDeclaratives, DFI.DFI_configuration.labelsForm.EDeclaratives, DFI.DFI_configuration.labelsIds.EDeclaratives, DFI.DFI_configuration.labelsByUrl.EDeclaratives);
        Object.assign(DFI.DFI_configuration.labels.EConversion, DFI.DFI_configuration.labelsUrl.EConversion, DFI.DFI_configuration.labelsJson.EConversion, DFI.DFI_configuration.labelsForm.EConversion, DFI.DFI_configuration.labelsIds.EConversion, DFI.DFI_configuration.labelsByUrl.EConversion);
        Object.assign(DFI.DFI_configuration.labels.EVisits, DFI.DFI_configuration.labelsUrl.EVisits, DFI.DFI_configuration.labelsJson.EVisits, DFI.DFI_configuration.labelsForm.EVisits, DFI.DFI_configuration.labelsIds.EVisits, DFI.DFI_configuration.labelsByUrl.EVisits);
    }

    // Fin seteamos valores por defecto si vienen vacios.

    // Fin inicializaciones

    // Para actualizaciones dinámicas.

    // Esta función se ejecuta con el setter en el objeto statusDFI.dynamicUpdate = true
    //Object.defineProperty(statusDFI, "dynamicUpdate", {DFI.dynamicFormUpdate();});
    let statusDFI1 = {
        set dynamicUpdate(mensaje) {
            if (mensaje === true) {
                DFI.dynamicFormUpdate();
            }
        }

    }

    DFI.DFI_configuration.layers1 = [];
    //DFI.DFI_configuration.services.ringPool
    DFI.DFI_configuration.layers1.push(DFI.DFI_configuration.services.serviceList.ringPool.ringpoolClass);

    if (DFI.DFI_configuration.DSAs.dsaImage === undefined || DFI.DFI_configuration.DSAs.dsaImage === "undefined" || DFI.DFI_configuration.DSAs.dsaImage === "") {

        DFI.DFI_configuration.DSAs.dsaImage = "https://delio-lm.com/delio-lite/delio-lm/dfi/assets/img/agente_amarillo.png";
    }

    DFI.deleteNameFromForm = function (inputName) {
        var element = document.getElementsByTagName(inputName),
            index;
        for (index = element.length - 1; index >= 0; index--) {
            element[index].parentNode.removeChild(element[index]);
        }
    };

    DFI.support();
}